{
  "level": "db01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:db01",
    "objects": "AREAS.E3:db01.e3",
    "mesh": "TREES.E3:db01.e3"
  },
  "spawn_point": {
    "position": [
      -3151.2392594323906,
      -5009.366471045616,
      964.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3151.2392594323906,
      -4909.366471045616,
      964.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3567.142578125,
      -5219.0,
      940.0
    ],
    "bbox_max": [
      -2880.0,
      -3619.7685546875,
      1402.623779296875
    ],
    "vertex_count": 2110,
    "vertices": [
      [
        -2980.000244140625,
        -5094.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5094.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -5219.0,
        1035.0
      ],
      [
        -2940.000244140625,
        -5194.0,
        1080.0
      ],
      [
        -2880.000244140625,
        -5176.0,
        1035.0
      ],
      [
        -2880.000244140625,
        -5194.0,
        1035.0
      ],
      [
        -2940.000244140625,
        -5194.0,
        1060.0
      ],
      [
        -2880.000244140625,
        -5194.0,
        1035.0
      ],
      [
        -2880.000244140625,
        -5194.0,
        1060.0
      ],
      [
        -2900.0,
        -5194.0,
        1035.0
      ],
      [
        -2900.0,
        -5176.0,
        1035.0
      ],
      [
        -2880.000244140625,
        -5176.0,
        1060.0
      ],
      [
        -2880.000244140625,
        -5176.0,
        1035.0
      ],
      [
        -2900.0,
        -5176.0,
        1035.0
      ],
      [
        -2900.0,
        -5194.0,
        1035.0
      ],
      [
        -2940.000244140625,
        -5194.0,
        1080.0
      ],
      [
        -2940.000244140625,
        -5194.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2969.000244140625,
        -5119.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5109.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5139.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5044.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5084.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5084.0,
        1080.0
      ],
      [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      [
        -2969.000244140625,
        -5044.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      [
        -2969.000244140625,
        -5084.0,
        1080.0
      ],
      [
        -2969.000244140625,
        -5084.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5119.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5119.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5149.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5139.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5139.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5139.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5149.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5109.0,
        1060.0
      ],
      [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5119.0,
        1075.5
      ],
      [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2979.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2979.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -2979.000244140625,
        -5150.0,
        1035.0
      ],
      [
        -2979.000244140625,
        -5159.0,
        1035.0
      ],
      [
        -3116.6005859375,
        -4920.0,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4920.0,
        1101.623779296875
      ],
      [
        -3066.5947265625,
        -3884.224853515625,
        1101.623779296875
      ],
      [
        -3082.545166015625,
        -3928.78857421875,
        1101.623779296875
      ],
      [
        -3064.56787109375,
        -3874.62548828125,
        1101.623779296875
      ],
      [
        -3066.5947265625,
        -3884.224853515625,
        1101.623779296875
      ],
      [
        -2989.13427734375,
        -4804.8466796875,
        1101.623779296875
      ],
      [
        -3015.14697265625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1101.623779296875
      ],
      [
        -3145.921875,
        -4739.90283203125,
        1101.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58203125,
        1082.623779296875
      ],
      [
        -3119.999755859375,
        -4722.58203125,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4695.85546875,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4695.85546875,
        1101.623779296875
      ],
      [
        -3015.14697265625,
        -4765.91552734375,
        1101.623779296875
      ],
      [
        -3054.07763671875,
        -4739.90283203125,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1082.623779296875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1101.623779296875
      ],
      [
        -3054.07763671875,
        -4739.90283203125,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      [
        -3145.921875,
        -4739.90283203125,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1083.3529052734375
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1083.3529052734375
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1083.561279296875
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1083.561279296875
      ],
      [
        -3045.07763671875,
        -4798.42578125,
        1082.7908935546875
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1086.4156494140625
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1086.4156494140625
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1086.6236572265625
      ],
      [
        -3040.041748046875,
        -4830.0341796875,
        1081.9837646484375
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1086.6236572265625
      ],
      [
        -3052.26806640625,
        -4789.77880859375,
        1086.2978515625
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1088.9765625
      ],
      [
        -3139.73779296875,
        -4804.4375,
        1088.8004150390625
      ],
      [
        -3150.283935546875,
        -4811.484375,
        1088.9765625
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1093.626953125
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1093.6697998046875
      ],
      [
        -3062.6923828125,
        -4782.8134765625,
        1093.626953125
      ],
      [
        -3086.677490234375,
        -4779.7685546875,
        1093.384765625
      ],
      [
        -3077.999755859375,
        -4779.7685546875,
        1093.6697998046875
      ],
      [
        -3040.360595703125,
        -4807.90087890625,
        1085.9569091796875
      ],
      [
        -3161.597900390625,
        -4823.36669921875,
        1088.1514892578125
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1098.60302734375
      ],
      [
        -3056.74462890625,
        -4786.7880859375,
        1093.10986328125
      ],
      [
        -3056.74462890625,
        -4786.7880859375,
        1094.59423828125
      ],
      [
        -3115.306396484375,
        -4799.7685546875,
        1099.294677734375
      ],
      [
        -3121.999755859375,
        -4799.7685546875,
        1098.60302734375
      ],
      [
        -3050.65576171875,
        -4790.8564453125,
        1092.58056640625
      ],
      [
        -3158.871337890625,
        -4802.89697265625,
        1094.3204345703125
      ],
      [
        -3170.15087890625,
        -4819.82421875,
        1090.4659423828125
      ],
      [
        -3161.09130859375,
        -4813.603515625,
        1092.473876953125
      ],
      [
        -3170.575927734375,
        -4819.64794921875,
        1090.5809326171875
      ],
      [
        -3158.871337890625,
        -4802.89697265625,
        1094.3204345703125
      ],
      [
        -3161.09130859375,
        -4813.603515625,
        1092.473876953125
      ],
      [
        -3051.03662109375,
        -4790.60205078125,
        1092.70654296875
      ],
      [
        -3247.0,
        -3633.42822265625,
        1395.809326171875
      ],
      [
        -3235.93408203125,
        -3644.481689453125,
        1390.294921875
      ],
      [
        -3196.34130859375,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3247.0,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3221.23876953125,
        -3906.280029296875,
        1259.68896484375
      ],
      [
        -3172.192138671875,
        -3927.405029296875,
        1249.1500244140625
      ],
      [
        -3148.77587890625,
        -3959.59814453125,
        1197.2989501953125
      ],
      [
        -3128.2265625,
        -3950.715576171875,
        1102.623779296875
      ],
      [
        -3148.77587890625,
        -3959.59814453125,
        1197.2989501953125
      ],
      [
        -3114.6005859375,
        -3944.82568359375,
        1121.6236572265625
      ],
      [
        -3196.34130859375,
        -3894.20458984375,
        1302.623779296875
      ],
      [
        -3162.9111328125,
        -4733.07763671875,
        1152.623779296875
      ],
      [
        -3162.690185546875,
        -4732.7470703125,
        1182.32275390625
      ],
      [
        -3119.999755859375,
        -4722.58203125,
        1133.5791015625
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1133.5791015625
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1114.09521484375
      ],
      [
        -3119.999755859375,
        -4722.58203125,
        1114.09521484375
      ],
      [
        -3153.438720703125,
        -4736.1064453125,
        1207.623779296875
      ],
      [
        -3145.76220703125,
        -4739.43017578125,
        1190.625732421875
      ],
      [
        -3145.76220703125,
        -4739.43017578125,
        1190.625732421875
      ],
      [
        -3144.686279296875,
        -4739.0771484375,
        1188.243408203125
      ],
      [
        -3120.0,
        -4679.7998046875,
        1114.09521484375
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1133.579345703125
      ],
      [
        -3128.600341796875,
        -4733.79931640625,
        1152.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1133.5791015625
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1114.09521484375
      ],
      [
        -3128.943603515625,
        -4733.92041015625,
        1101.623779296875
      ],
      [
        -3128.600341796875,
        -4733.79931640625,
        1152.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1114.09521484375
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1133.5791015625
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1110.01806640625
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1110.01806640625
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1110.01806640625
      ],
      [
        -3121.054931640625,
        -4731.140625,
        1112.6239013671875
      ],
      [
        -3119.999755859375,
        -3947.159423828125,
        1102.623779296875
      ],
      [
        -3121.054931640625,
        -3947.615478515625,
        1112.6239013671875
      ],
      [
        -3119.999755859375,
        -3947.159423828125,
        1110.0181884765625
      ],
      [
        -3120.0,
        -4679.7998046875,
        1110.0186767578125
      ],
      [
        -3117.00537109375,
        -3945.864990234375,
        1102.623779296875
      ],
      [
        -3119.999755859375,
        -4327.22119140625,
        1112.623779296875
      ],
      [
        -3119.999755859375,
        -4329.7685546875,
        1110.01806640625
      ],
      [
        -3119.999755859375,
        -3947.159423828125,
        1110.0181884765625
      ],
      [
        -3119.999755859375,
        -3947.159423828125,
        1114.09521484375
      ],
      [
        -3119.999755859375,
        -4327.22119140625,
        1112.623779296875
      ],
      [
        -3119.999755859375,
        -4329.7685546875,
        1114.0950927734375
      ],
      [
        -3116.500732421875,
        -3945.646728515625,
        1102.623779296875
      ],
      [
        -3115.50048828125,
        -4316.35888671875,
        1112.623779296875
      ],
      [
        -3115.50048828125,
        -4316.35888671875,
        1112.623779296875
      ],
      [
        -3110.536376953125,
        -4304.37451171875,
        1112.623779296875
      ],
      [
        -3105.568603515625,
        -4303.13525390625,
        1101.623779296875
      ],
      [
        -3106.020263671875,
        -3941.11669921875,
        1102.623779296875
      ],
      [
        -3110.536376953125,
        -4304.37451171875,
        1112.623779296875
      ],
      [
        -3063.05419921875,
        -3856.597412109375,
        1168.225341796875
      ],
      [
        -3070.75439453125,
        -3895.846923828125,
        1151.1749267578125
      ],
      [
        -3070.75439453125,
        -3895.846923828125,
        1151.1749267578125
      ],
      [
        -3069.76953125,
        -3893.0947265625,
        1101.623779296875
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1120.741943359375
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1123.0234375
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1123.0234375
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1120.741943359375
      ],
      [
        -3084.1005859375,
        -3931.641845703125,
        1121.6240234375
      ],
      [
        -3084.1005859375,
        -4277.24267578125,
        1121.623779296875
      ],
      [
        -3070.10009765625,
        -4257.443359375,
        1152.623779296875
      ],
      [
        -3084.1005859375,
        -4277.24267578125,
        1121.623779296875
      ],
      [
        -3077.651611328125,
        -4268.1171875,
        1112.623779296875
      ],
      [
        -3069.76953125,
        -4269.306640625,
        1101.623779296875
      ],
      [
        -3077.651611328125,
        -4268.1171875,
        1112.623779296875
      ],
      [
        -3037.309326171875,
        -4732.7470703125,
        1182.322265625
      ],
      [
        -3037.08837890625,
        -4733.07763671875,
        1152.623779296875
      ],
      [
        -3054.225341796875,
        -4739.4658203125,
        1187.7740478515625
      ],
      [
        -3045.2607421875,
        -4735.583984375,
        1207.623779296875
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1115.901123046875
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1130.7039794921875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1130.7039794921875
      ],
      [
        -3079.999755859375,
        -4722.58154296875,
        1115.901123046875
      ],
      [
        -3055.219970703125,
        -4739.1396484375,
        1185.5716552734375
      ],
      [
        -3054.225341796875,
        -4739.4658203125,
        1187.7740478515625
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1130.7037353515625
      ],
      [
        -3080.0,
        -4679.7998046875,
        1115.901123046875
      ],
      [
        -3070.10009765625,
        -4734.2568359375,
        1152.623779296875
      ],
      [
        -3069.76953125,
        -4734.37353515625,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1115.901123046875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1130.7039794921875
      ],
      [
        -3070.10009765625,
        -4734.2568359375,
        1152.623779296875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1130.7039794921875
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1115.901123046875
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1106.818115234375
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1106.818115234375
      ],
      [
        -3079.999755859375,
        -3921.677001953125,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -3921.67724609375,
        1106.818115234375
      ],
      [
        -3077.651611328125,
        -3915.11669921875,
        1112.6239013671875
      ],
      [
        -3079.999755859375,
        -4273.5439453125,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4271.44091796875,
        1106.8177490234375
      ],
      [
        -3079.999755859375,
        -4730.7685546875,
        1106.818115234375
      ],
      [
        -3077.651611328125,
        -4731.59619140625,
        1112.6240234375
      ],
      [
        -3082.1005859375,
        -3927.546630859375,
        1101.623779296875
      ],
      [
        -3082.100341796875,
        -4274.4140625,
        1101.623779296875
      ],
      [
        -3080.0,
        -4679.7998046875,
        1106.8173828125
      ],
      [
        -3079.999755859375,
        -3921.67724609375,
        1115.9010009765625
      ],
      [
        -3079.999755859375,
        -3921.67724609375,
        1106.818115234375
      ],
      [
        -3079.999755859375,
        -4269.08984375,
        1112.623779296875
      ],
      [
        -3079.999755859375,
        -4271.44091796875,
        1106.8177490234375
      ],
      [
        -3079.999755859375,
        -4271.43994140625,
        1115.9007568359375
      ],
      [
        -3079.999755859375,
        -4269.08984375,
        1112.623779296875
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1115.3028564453125
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1115.3028564453125
      ],
      [
        -3083.200439453125,
        -4270.41552734375,
        1112.623779296875
      ],
      [
        -3083.200439453125,
        -4270.41552734375,
        1112.623779296875
      ],
      [
        -3092.681640625,
        -3935.35107421875,
        1102.623779296875
      ],
      [
        -3093.13330078125,
        -4278.98388671875,
        1101.623779296875
      ],
      [
        -3088.165283203125,
        -4272.47216796875,
        1112.623779296875
      ],
      [
        -3088.165283203125,
        -4272.47216796875,
        1112.623779296875
      ],
      [
        -3079.301025390625,
        -3919.725341796875,
        1252.9814453125
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1247.1727294921875
      ],
      [
        -3123.158447265625,
        -3948.52490234375,
        1238.61376953125
      ],
      [
        -3079.301025390625,
        -3919.725341796875,
        1252.9814453125
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1247.1727294921875
      ],
      [
        -3123.158447265625,
        -3948.52490234375,
        1238.61376953125
      ],
      [
        -3172.192138671875,
        -3927.405029296875,
        1249.1500244140625
      ],
      [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      [
        -3079.999755859375,
        -4271.443359375,
        1130.703857421875
      ],
      [
        -3085.635986328125,
        -4629.7685546875,
        1121.623779296875
      ],
      [
        -3085.635986328125,
        -4679.7998046875,
        1121.623779296875
      ],
      [
        -3085.635986328125,
        -4679.7998046875,
        1121.623779296875
      ],
      [
        -3085.635986328125,
        -4277.87890625,
        1121.623779296875
      ],
      [
        -3085.635986328125,
        -4277.87890625,
        1121.623779296875
      ],
      [
        -3086.670654296875,
        -4274.2265625,
        1115.933349609375
      ],
      [
        -3119.999755859375,
        -4329.7685546875,
        1133.579345703125
      ],
      [
        -3119.999755859375,
        -4309.0048828125,
        1152.623779296875
      ],
      [
        -3114.36328125,
        -4629.7685546875,
        1121.623779296875
      ],
      [
        -3114.36328125,
        -4679.7998046875,
        1121.623779296875
      ],
      [
        -3114.36328125,
        -4329.19580078125,
        1121.623779296875
      ],
      [
        -3114.36328125,
        -4679.7998046875,
        1121.623779296875
      ],
      [
        -3114.36328125,
        -4329.19580078125,
        1121.623779296875
      ],
      [
        -3114.20361328125,
        -4327.28759765625,
        1120.7445068359375
      ],
      [
        -3087.617431640625,
        -4273.115234375,
        1113.8370361328125
      ],
      [
        -2980.000244140625,
        -5219.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5219.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -4976.0,
        1035.0
      ],
      [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3085.73388671875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3195.000244140625,
        -5004.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5019.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -4976.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5004.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5219.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5019.0,
        1035.0
      ],
      [
        -3247.0,
        -5003.5,
        1078.5999755859375
      ],
      [
        -3247.0,
        -5023.5,
        1078.5999755859375
      ],
      [
        -3247.0,
        -5003.5,
        1077.076171875
      ],
      [
        -3247.0,
        -5003.5,
        1078.5999755859375
      ],
      [
        -3247.0,
        -5023.5,
        1077.076171875
      ],
      [
        -3247.0,
        -5003.5,
        1064.699951171875
      ],
      [
        -3247.0,
        -5003.5,
        1064.699951171875
      ],
      [
        -3180.000244140625,
        -5112.80029296875,
        1086.5
      ],
      [
        -3180.000244140625,
        -5112.80029296875,
        1086.5
      ],
      [
        -3195.000244140625,
        -5112.80029296875,
        1086.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5124.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5074.2421875,
        1083.0
      ],
      [
        -3120.000244140625,
        -5144.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5073.2421875,
        1083.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -5074.2421875,
        1083.0
      ],
      [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1083.0
      ],
      [
        -3120.000244140625,
        -5144.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -5204.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3080.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3080.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3110.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3120.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3080.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3070.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      [
        -3080.000244140625,
        -5073.24267578125,
        1083.0
      ],
      [
        -3110.000244140625,
        -5073.24267578125,
        1083.0
      ],
      [
        -3120.000244140625,
        -5073.2421875,
        1083.0
      ],
      [
        -3080.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3080.000244140625,
        -5073.24267578125,
        1083.0
      ],
      [
        -3110.000244140625,
        -5074.24267578125,
        1083.0
      ],
      [
        -3110.000244140625,
        -5073.24267578125,
        1083.0
      ],
      [
        -3070.000244140625,
        -4991.0,
        1083.3143310546875
      ],
      [
        -3070.515869140625,
        -4991.0,
        1083.0
      ],
      [
        -3070.515869140625,
        -4976.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -4976.0,
        1083.3143310546875
      ],
      [
        -3070.000244140625,
        -4991.0,
        1083.0
      ],
      [
        -3070.515869140625,
        -4991.0,
        1083.0
      ],
      [
        -3070.000244140625,
        -4991.0,
        1083.3143310546875
      ],
      [
        -3094.545654296875,
        -5134.0,
        1083.0
      ],
      [
        -3091.818359375,
        -5134.0,
        1083.0
      ],
      [
        -3087.7275390625,
        -5143.0,
        1085.5
      ],
      [
        -3087.7275390625,
        -5134.0,
        1085.5
      ],
      [
        -3091.818359375,
        -5134.0,
        1083.0
      ],
      [
        -3091.818359375,
        -5143.0,
        1083.0
      ],
      [
        -3094.545654296875,
        -5143.0,
        1083.0
      ],
      [
        -3094.545654296875,
        -5134.0,
        1083.0
      ],
      [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      [
        -3064.609619140625,
        -4991.0,
        1083.0
      ],
      [
        -3058.867431640625,
        -4991.0,
        1086.5
      ],
      [
        -3064.773681640625,
        -4991.0,
        1086.5
      ],
      [
        -3064.773681640625,
        -4976.0,
        1086.5
      ],
      [
        -3065.000244140625,
        -5193.9150390625,
        1086.361572265625
      ],
      [
        -3070.000244140625,
        -5203.0576171875,
        1083.314208984375
      ],
      [
        -3065.000244140625,
        -5204.0,
        1086.361572265625
      ],
      [
        -3065.000244140625,
        -5193.9150390625,
        1086.361572265625
      ],
      [
        -3058.867431640625,
        -4991.0,
        1086.5
      ],
      [
        -3064.609619140625,
        -4991.0,
        1083.0
      ],
      [
        -3064.773681640625,
        -4991.0,
        1086.5
      ],
      [
        -3065.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3065.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3025.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3140.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3140.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3140.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3140.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3140.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3145.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3145.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3145.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3141.1767578125,
        -5105.0,
        1098.0
      ],
      [
        -3145.000244140625,
        -5105.0,
        1098.0
      ],
      [
        -3145.000244140625,
        -5105.0,
        1101.5
      ],
      [
        -3145.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3145.000244140625,
        -5105.0,
        1101.5
      ],
      [
        -3141.1767578125,
        -5114.0,
        1098.0
      ],
      [
        -3141.1767578125,
        -5105.0,
        1098.0
      ],
      [
        -3141.1767578125,
        -5114.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3130.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5164.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5157.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5157.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5164.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5159.2978515625,
        1101.5
      ],
      [
        -3080.000244140625,
        -5169.728515625,
        1098.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5070.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5054.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5054.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5004.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5004.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5184.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5184.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5184.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5184.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5203.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5203.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5185.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5185.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5144.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5144.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5144.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5094.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3110.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3110.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3110.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3110.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3110.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3110.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3110.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3110.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5094.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5094.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5094.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5104.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5019.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3125.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3130.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3125.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3130.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3125.000244140625,
        -5185.0,
        1100.5
      ],
      [
        -3125.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5054.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5054.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5184.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5004.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5184.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5184.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5184.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5184.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3100.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3100.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5204.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5203.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5203.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5204.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5185.0,
        1100.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5185.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5070.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5070.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5070.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5070.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5069.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5069.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5069.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5143.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5143.0,
        1100.5
      ],
      [
        -3107.500244140625,
        -5143.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5143.0,
        1098.0
      ],
      [
        -3092.500244140625,
        -5144.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5144.0,
        1098.0
      ],
      [
        -3107.500244140625,
        -5144.0,
        1100.5
      ],
      [
        -3092.500244140625,
        -5144.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5019.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5203.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5203.0,
        1100.5
      ],
      [
        -3120.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5204.0,
        1100.5
      ],
      [
        -3125.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3125.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3125.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3125.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3110.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3110.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3110.000244140625,
        -5185.0,
        1098.0
      ],
      [
        -3110.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5054.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5143.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3065.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3065.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3025.000244140625,
        -5144.0,
        1100.5
      ],
      [
        -3025.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3025.000244140625,
        -5124.0,
        1100.5
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5074.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5074.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5004.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5004.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5114.0,
        1100.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3050.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3050.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3050.000244140625,
        -5069.0,
        1100.5
      ],
      [
        -3050.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5074.0,
        1101.5
      ],
      [
        -3040.000244140625,
        -5074.0,
        1100.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3050.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1100.5
      ],
      [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      [
        -3065.000244140625,
        -5159.0,
        1100.5
      ],
      [
        -3065.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -3025.000244140625,
        -5159.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5162.27783203125,
        1100.5
      ],
      [
        -3080.000244140625,
        -5159.2978515625,
        1101.5
      ],
      [
        -3065.000244140625,
        -5159.2978515625,
        1101.5
      ],
      [
        -3065.000244140625,
        -5162.27783203125,
        1100.5
      ],
      [
        -3065.000244140625,
        -5162.27783203125,
        1100.5
      ],
      [
        -3065.000244140625,
        -5159.2978515625,
        1101.5
      ],
      [
        -3065.000244140625,
        -5159.0,
        1101.5
      ],
      [
        -3065.000244140625,
        -5159.0,
        1100.5
      ],
      [
        -3080.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5054.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5054.0,
        1100.5
      ],
      [
        -3070.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3035.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3035.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3035.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3035.000244140625,
        -5124.0,
        1098.0
      ],
      [
        -3040.000244140625,
        -5004.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5169.728515625,
        1098.0
      ],
      [
        -3065.000244140625,
        -5169.728515625,
        1098.0
      ],
      [
        -3065.000244140625,
        -5169.728515625,
        1098.0
      ],
      [
        -3080.000244140625,
        -5115.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5004.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5184.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5184.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5203.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3100.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      [
        -3100.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5185.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5070.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5070.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5140.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5140.0,
        1101.5
      ],
      [
        -3092.500244140625,
        -5140.0,
        1101.5999755859375
      ],
      [
        -3107.500244140625,
        -5140.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5144.0,
        1101.5
      ],
      [
        -3107.500244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3092.500244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3120.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3120.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3125.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3125.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5070.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5079.0,
        1101.5
      ],
      [
        -3119.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5203.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5185.0,
        1101.5
      ],
      [
        -3116.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      [
        -3114.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3114.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3114.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3110.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3110.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3110.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3110.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5115.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5114.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5184.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5143.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5144.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5070.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5070.0,
        1101.5
      ],
      [
        -3090.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3089.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3089.000244140625,
        -5115.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5115.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5143.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5069.0,
        1101.5
      ],
      [
        -3085.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      [
        -3085.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3085.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3085.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      [
        -3090.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3080.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3026.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      [
        -3026.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      [
        -3026.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      [
        -3026.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3040.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5054.0,
        1101.5
      ],
      [
        -3070.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5091.80322265625,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5086.5,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5091.80322265625,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5086.5,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3075.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5106.80322265625,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5101.5,
        1101.5999755859375
      ],
      [
        -3077.500244140625,
        -5101.5,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5096.19677734375,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5096.19677734375,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      [
        -3070.000244140625,
        -5109.0,
        1101.5999755859375
      ],
      [
        -3075.303466796875,
        -5106.80322265625,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5105.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5162.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5146.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5160.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3180.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5087.44482421875,
        1098.0
      ],
      [
        -3180.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3180.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5160.0,
        1101.5999755859375
      ],
      [
        -3195.000244140625,
        -5087.44482421875,
        1098.0
      ],
      [
        -3180.000244140625,
        -5087.44482421875,
        1098.0
      ],
      [
        -3195.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3195.000244140625,
        -5126.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5126.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5134.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3180.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3179.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3180.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3179.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3179.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3180.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5019.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5162.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5170.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5146.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5134.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5134.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3160.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5204.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5019.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5146.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5146.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5019.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5019.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5104.0,
        1101.5
      ],
      [
        -3161.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5204.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5162.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5162.0,
        1098.0
      ],
      [
        -3179.000244140625,
        -5134.0,
        1098.0
      ],
      [
        -3179.000244140625,
        -5134.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5134.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5134.0,
        1098.0
      ],
      [
        -3179.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5170.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5170.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5105.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5184.0,
        1098.0
      ],
      [
        -3045.906494140625,
        -4991.0,
        1098.0
      ],
      [
        -3045.906494140625,
        -4976.0,
        1098.0
      ],
      [
        -3045.906494140625,
        -4991.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5204.0,
        1120.0
      ],
      [
        -3160.000244140625,
        -5204.0,
        1110.0
      ],
      [
        -3180.000244140625,
        -5204.0,
        1110.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1112.0
      ],
      [
        -3180.000244140625,
        -5104.0,
        1110.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1110.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1120.0
      ],
      [
        -3160.000244140625,
        -5104.0,
        1112.0
      ],
      [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5204.0,
        1110.0
      ],
      [
        -3179.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3179.000244140625,
        -5104.0,
        1110.0
      ],
      [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5204.0,
        1110.0
      ],
      [
        -3161.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3160.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      [
        -3161.000244140625,
        -5104.0,
        1110.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1120.0
      ],
      [
        -3070.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1120.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5124.0,
        1115.0
      ],
      [
        -3070.000244140625,
        -5124.0,
        1115.0
      ],
      [
        -3119.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5143.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5204.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5184.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5203.0,
        1110.0
      ],
      [
        -3119.000244140625,
        -5185.0,
        1110.0
      ],
      [
        -3119.000244140625,
        -5203.0,
        1110.0
      ],
      [
        -3119.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5185.0,
        1110.0
      ],
      [
        -3119.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5144.0,
        1115.0
      ],
      [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5069.0,
        1115.0
      ],
      [
        -3119.000244140625,
        -5144.0,
        1115.0
      ],
      [
        -3119.000244140625,
        -5144.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5144.0,
        1106.0
      ],
      [
        -3120.000244140625,
        -5069.0,
        1106.0
      ],
      [
        -3119.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5069.0,
        1106.0
      ],
      [
        -3119.000244140625,
        -5144.0,
        1106.0
      ],
      [
        -3119.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5069.0,
        1115.0
      ],
      [
        -3119.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5069.0,
        1120.0
      ],
      [
        -3080.000244140625,
        -5069.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5069.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5143.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5143.0,
        1120.0
      ],
      [
        -3080.000244140625,
        -5143.0,
        1115.0
      ],
      [
        -3080.000244140625,
        -5143.0,
        1120.0
      ],
      [
        -3089.000244140625,
        -5114.0,
        1120.0
      ],
      [
        -3089.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3116.000244140625,
        -5136.400390625,
        1101.5999755859375
      ],
      [
        -3119.000244140625,
        -5079.0,
        1106.0
      ],
      [
        -3116.000244140625,
        -5079.0,
        1104.0
      ],
      [
        -3116.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      [
        -3114.000244140625,
        -5079.0,
        1102.666748046875
      ],
      [
        -3114.000244140625,
        -5070.0,
        1102.666748046875
      ],
      [
        -3114.000244140625,
        -5079.0,
        1102.666748046875
      ],
      [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      [
        -3114.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5079.0,
        1120.0
      ],
      [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      [
        -3075.303466796875,
        -5106.80322265625,
        1120.0
      ],
      [
        -3077.500244140625,
        -5101.5,
        1120.0
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1120.0
      ],
      [
        -3070.000244140625,
        -5079.0,
        1120.0
      ],
      [
        -3077.500244140625,
        -5086.5,
        1120.0
      ],
      [
        -3075.303466796875,
        -5081.19677734375,
        1120.0
      ],
      [
        -3077.500244140625,
        -5101.5,
        1120.0
      ],
      [
        -3075.303466796875,
        -5096.19677734375,
        1120.0
      ],
      [
        -3075.303466796875,
        -5096.19677734375,
        1120.0
      ],
      [
        -3070.000244140625,
        -5094.0,
        1120.0
      ],
      [
        -3070.000244140625,
        -5108.99951171875,
        1120.0
      ],
      [
        -3075.303466796875,
        -5106.80322265625,
        1120.0
      ],
      [
        -3070.000244140625,
        -5094.0,
        1120.0
      ],
      [
        -3073.75,
        -5092.44677734375,
        1101.5999755859375
      ],
      [
        -3073.75,
        -5092.44677734375,
        1120.0
      ],
      [
        -3075.303466796875,
        -5091.80322265625,
        1120.0
      ],
      [
        -3077.500244140625,
        -5086.5,
        1120.0
      ],
      [
        -3075.303466796875,
        -5091.80322265625,
        1120.0
      ],
      [
        -3070.000244140625,
        -5070.0,
        1120.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1120.0
      ],
      [
        -3180.000244140625,
        -5104.0,
        1092.7918701171875
      ],
      [
        -3180.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      [
        -3120.000244140625,
        -5143.0,
        1091.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1086.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1091.5
      ],
      [
        -3140.000244140625,
        -5114.0,
        1086.5
      ],
      [
        -3140.000244140625,
        -5114.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1086.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5143.0,
        1091.5
      ],
      [
        -3120.000244140625,
        -5143.0,
        1096.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5124.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5143.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5104.0,
        1096.5
      ],
      [
        -3130.000244140625,
        -5114.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5114.0,
        1096.5
      ],
      [
        -3130.000244140625,
        -5114.0,
        1091.5
      ],
      [
        -3140.000244140625,
        -5114.0,
        1096.5
      ],
      [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1096.5
      ],
      [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5104.0,
        1098.0
      ],
      [
        -3140.000244140625,
        -5114.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5164.0,
        1089.5
      ],
      [
        -3160.000244140625,
        -5164.0,
        1098.0
      ],
      [
        -3160.000244140625,
        -5164.0,
        1086.5
      ],
      [
        -3160.000244140625,
        -5164.0,
        1089.5
      ],
      [
        -3161.000244140625,
        -5164.0,
        1098.0
      ],
      [
        -3161.000244140625,
        -5164.0,
        1089.5
      ],
      [
        -3161.000244140625,
        -5164.0,
        1089.5
      ],
      [
        -3161.000244140625,
        -5164.0,
        1086.5
      ],
      [
        -3195.000244140625,
        -5104.0,
        1092.7918701171875
      ],
      [
        -3180.000244140625,
        -5104.0,
        1092.7918701171875
      ],
      [
        -3180.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      [
        -3195.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      [
        -3080.000244140625,
        -5069.0,
        1086.5
      ],
      [
        -3080.000244140625,
        -5069.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3080.000244140625,
        -5070.0,
        1086.5
      ],
      [
        -3120.000244140625,
        -5070.0,
        1098.0
      ],
      [
        -3120.000244140625,
        -5070.0,
        1086.5
      ],
      [
        -3070.000244140625,
        -5159.0,
        1098.0
      ],
      [
        -3070.000244140625,
        -5193.5,
        1086.5
      ],
      [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      [
        -3070.000244140625,
        -5169.728515625,
        1098.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1098.0
      ],
      [
        -3025.000244140625,
        -5144.0,
        1140.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      [
        -3060.000244140625,
        -5124.0,
        1120.0
      ],
      [
        -3025.000244140625,
        -5124.0,
        1140.0
      ],
      [
        -3025.000244140625,
        -5124.0,
        1135.0
      ],
      [
        -3025.000244140625,
        -5124.0,
        1135.0
      ],
      [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      [
        -3119.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3119.000244140625,
        -5059.0,
        1135.0
      ],
      [
        -3119.000244140625,
        -5059.0,
        1140.0
      ],
      [
        -3092.500244140625,
        -5004.0,
        1069.5999755859375
      ],
      [
        -3092.500244140625,
        -5004.0,
        1066.0
      ],
      [
        -3086.593994140625,
        -4976.0,
        1069.5999755859375
      ],
      [
        -3086.593994140625,
        -4991.0,
        1069.5999755859375
      ],
      [
        -3086.593994140625,
        -4991.0,
        1069.5999755859375
      ],
      [
        -3120.000244140625,
        -5147.5,
        1072.0
      ],
      [
        -3120.000244140625,
        -5079.60009765625,
        1072.0
      ],
      [
        -3120.000244140625,
        -5079.60009765625,
        1072.0
      ],
      [
        -3120.000244140625,
        -5079.60009765625,
        1070.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1072.0
      ],
      [
        -3070.000244140625,
        -5087.57568359375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1072.0
      ],
      [
        -3120.000244140625,
        -5091.39990234375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5091.39990234375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3074.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3116.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3120.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3074.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3116.000244140625,
        -5086.57568359375,
        1072.0
      ],
      [
        -3070.000244140625,
        -5144.0,
        1072.0
      ],
      [
        -3120.000244140625,
        -5144.0,
        1072.0
      ],
      [
        -3120.000244140625,
        -5143.0,
        1072.0
      ],
      [
        -3070.000244140625,
        -5143.0,
        1072.0
      ],
      [
        -3120.000244140625,
        -5121.72705078125,
        1072.0
      ],
      [
        -3110.000244140625,
        -5121.72705078125,
        1072.0
      ],
      [
        -3110.000244140625,
        -5123.0908203125,
        1072.0
      ],
      [
        -3120.000244140625,
        -5123.0908203125,
        1072.0
      ],
      [
        -3110.000244140625,
        -5121.72705078125,
        1072.0
      ],
      [
        -3110.000244140625,
        -5123.0908203125,
        1072.0
      ],
      [
        -3097.27294921875,
        -5134.0,
        1081.0
      ],
      [
        -3097.27294921875,
        -5134.0,
        1081.0
      ],
      [
        -3097.27294921875,
        -5143.0,
        1081.0
      ],
      [
        -3120.000244140625,
        -5132.63623046875,
        1080.0
      ],
      [
        -3110.000244140625,
        -5132.63623046875,
        1080.0
      ],
      [
        -3110.000244140625,
        -5132.63623046875,
        1080.0
      ],
      [
        -3080.000244140625,
        -5134.0,
        1050.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1050.0
      ],
      [
        -3080.000244140625,
        -5144.0,
        1050.0
      ],
      [
        -3080.000244140625,
        -5134.0,
        1050.0
      ],
      [
        -3004.734375,
        -5041.3671875,
        1060.0
      ],
      [
        -3004.734375,
        -5041.3671875,
        1063.5
      ],
      [
        -3009.00048828125,
        -5043.5,
        1065.0
      ],
      [
        -3009.00048828125,
        -5084.5,
        1065.0
      ],
      [
        -3004.734375,
        -5086.6328125,
        1063.5
      ],
      [
        -3004.734375,
        -5086.6328125,
        1060.0
      ],
      [
        -3004.734375,
        -5042.3154296875,
        1065.0
      ],
      [
        -3004.734375,
        -5041.3671875,
        1065.0
      ],
      [
        -3004.734375,
        -5085.6845703125,
        1065.0
      ],
      [
        -3004.734375,
        -5086.6328125,
        1065.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5094.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5094.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5034.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5035.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5035.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5035.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5094.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2980.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2990.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -3009.000244140625,
        -5084.5,
        1075.0
      ],
      [
        -3009.000244140625,
        -5043.5,
        1075.0
      ],
      [
        -3009.000244140625,
        -5043.5,
        1075.0
      ],
      [
        -3009.000244140625,
        -5043.5,
        1080.0
      ],
      [
        -3009.000244140625,
        -5084.5,
        1080.0
      ],
      [
        -3009.000244140625,
        -5084.5,
        1075.0
      ],
      [
        -2992.000244140625,
        -5093.0,
        1065.0
      ],
      [
        -2992.000244140625,
        -5093.0,
        1080.0
      ],
      [
        -2992.000244140625,
        -5035.0,
        1080.0
      ],
      [
        -2992.000244140625,
        -5035.0,
        1065.0
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      [
        -3025.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      [
        -3010.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      [
        -3015.000244140625,
        -5129.0,
        1135.0
      ],
      [
        -3025.000244140625,
        -5129.0,
        1120.0
      ],
      [
        -3367.0,
        -3651.509765625,
        1386.788818359375
      ],
      [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      [
        -3367.0,
        -4126.3291015625,
        1147.634521484375
      ],
      [
        -3367.0,
        -4142.04638671875,
        1102.623779296875
      ],
      [
        -3367.0,
        -4119.22314453125,
        1150.4337158203125
      ],
      [
        -3367.0,
        -4126.3291015625,
        1147.634521484375
      ],
      [
        -3367.0,
        -3651.509765625,
        1386.788818359375
      ],
      [
        -3367.0,
        -3829.95947265625,
        1322.2840576171875
      ],
      [
        -3367.0,
        -3829.95947265625,
        1322.2840576171875
      ],
      [
        -3367.0,
        -3885.97607421875,
        1302.623779296875
      ],
      [
        -3357.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3353.89990234375,
        -5060.00048828125,
        1064.699951171875
      ],
      [
        -3357.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3359.89990234375,
        -5060.00048828125,
        1064.699951171875
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1061.70703125
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1064.699951171875
      ],
      [
        -3361.949951171875,
        -5073.943359375,
        1064.699951171875
      ],
      [
        -3353.89990234375,
        -5060.00048828125,
        1064.699951171875
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1064.699951171875
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1064.699951171875
      ],
      [
        -3291.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3293.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3320.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3358.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3364.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3289.30078125,
        -5023.50048828125,
        1075.0
      ],
      [
        -3323.69921875,
        -5023.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3320.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3293.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3293.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3293.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3260.0,
        -5023.5,
        1075.0
      ],
      [
        -3358.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3353.000244140625,
        -5023.50048828125,
        1075.0
      ],
      [
        -3358.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3353.000244140625,
        -5023.50048828125,
        1075.0
      ],
      [
        -3367.0,
        -5023.50048828125,
        1078.6033935546875
      ],
      [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3364.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3289.30078125,
        -5023.50048828125,
        1075.0
      ],
      [
        -3260.0,
        -5023.5,
        1075.0
      ],
      [
        -3353.000244140625,
        -5023.50048828125,
        1075.0
      ],
      [
        -3323.69921875,
        -5023.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5035.00048828125,
        1075.0
      ],
      [
        -3295.0,
        -5035.00048828125,
        1075.0
      ],
      [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3295.0,
        -5024.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5024.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5024.50048828125,
        1075.0
      ],
      [
        -3318.0,
        -5035.00048828125,
        1075.0
      ],
      [
        -3247.0,
        -5003.5,
        1075.0
      ],
      [
        -3256.463134765625,
        -5003.5,
        1075.0
      ],
      [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3305.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3306.5,
        -4985.7431640625,
        1078.6070556640625
      ],
      [
        -3305.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3305.5,
        -4984.19921875,
        1084.70703125
      ],
      [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3306.5,
        -4985.7431640625,
        1078.6070556640625
      ],
      [
        -3307.5,
        -4984.19921875,
        1084.70703125
      ],
      [
        -3290.094482421875,
        -4996.705078125,
        1078.6070556640625
      ],
      [
        -3288.742919921875,
        -5003.50048828125,
        1078.6070556640625
      ],
      [
        -3299.70458984375,
        -4987.0947265625,
        1078.6070556640625
      ],
      [
        -3293.94384765625,
        -4990.9443359375,
        1078.6070556640625
      ],
      [
        -3293.94384765625,
        -4990.9443359375,
        1078.6070556640625
      ],
      [
        -3290.094482421875,
        -4996.705078125,
        1078.6070556640625
      ],
      [
        -3299.70458984375,
        -4987.0947265625,
        1078.6070556640625
      ],
      [
        -3326.0,
        -4968.7568359375,
        1084.70703125
      ],
      [
        -3324.272705078125,
        -4960.5927734375,
        1078.6617431640625
      ],
      [
        -3324.257080078125,
        -5003.50048828125,
        1078.6070556640625
      ],
      [
        -3322.905517578125,
        -4996.705078125,
        1078.6070556640625
      ],
      [
        -3319.05615234375,
        -4990.9443359375,
        1078.6070556640625
      ],
      [
        -3313.29541015625,
        -4987.0947265625,
        1078.6070556640625
      ],
      [
        -3322.905517578125,
        -4996.705078125,
        1078.6070556640625
      ],
      [
        -3319.05615234375,
        -4990.9443359375,
        1078.6070556640625
      ],
      [
        -3313.29541015625,
        -4987.0947265625,
        1078.6070556640625
      ],
      [
        -3288.743896484375,
        -4960.5322265625,
        1078.6033935546875
      ],
      [
        -3289.7734375,
        -4960.32763671875,
        1075.0
      ],
      [
        -3306.5,
        -4957.00048828125,
        1075.0
      ],
      [
        -3324.256103515625,
        -4960.5322265625,
        1078.6033935546875
      ],
      [
        -3306.5,
        -4957.00048828125,
        1075.0
      ],
      [
        -3323.2265625,
        -4960.32763671875,
        1075.0
      ],
      [
        -3307.5,
        -4990.23828125,
        1078.6070556640625
      ],
      [
        -3306.5,
        -4990.03955078125,
        1077.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      [
        -3305.5,
        -4986.19921875,
        1077.70703125
      ],
      [
        -3305.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      [
        -3306.5,
        -4990.03955078125,
        1077.70703125
      ],
      [
        -3305.5,
        -4990.23828125,
        1078.6070556640625
      ],
      [
        -3305.5,
        -4990.23828125,
        1077.70703125
      ],
      [
        -3320.0,
        -5023.50048828125,
        1077.70703125
      ],
      [
        -3320.0,
        -5003.50048828125,
        1077.70703125
      ],
      [
        -3320.0,
        -4992.810546875,
        1077.70703125
      ],
      [
        -3320.0,
        -4992.35693359375,
        1078.6070556640625
      ],
      [
        -3320.0,
        -5003.50048828125,
        1077.70703125
      ],
      [
        -3318.936279296875,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3316.018310546875,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3311.651123046875,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3318.936279296875,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3316.018310546875,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3311.651123046875,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3293.0,
        -5003.50048828125,
        1077.70703125
      ],
      [
        -3293.0,
        -5023.50048828125,
        1077.70703125
      ],
      [
        -3293.0,
        -4992.810546875,
        1077.70703125
      ],
      [
        -3293.0,
        -4992.35693359375,
        1078.6070556640625
      ],
      [
        -3294.063720703125,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3293.0,
        -5003.50048828125,
        1077.70703125
      ],
      [
        -3301.348876953125,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3296.981689453125,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3296.981689453125,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3294.063720703125,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3301.348876953125,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3320.0,
        -4997.90869140625,
        1075.70703125
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3320.0,
        -4997.90869140625,
        1075.70703125
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3320.0,
        -4992.810546875,
        1077.70703125
      ],
      [
        -3320.820068359375,
        -4997.56884765625,
        1075.0
      ],
      [
        -3321.29296875,
        -4999.9462890625,
        1075.0
      ],
      [
        -3321.29296875,
        -4999.9462890625,
        1075.0
      ],
      [
        -3320.820068359375,
        -4997.56884765625,
        1075.0
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      [
        -3320.820068359375,
        -4997.56884765625,
        1075.0
      ],
      [
        -3320.820068359375,
        -4997.56884765625,
        1075.0
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3293.0,
        -4997.90869140625,
        1075.70703125
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3293.0,
        -4997.90869140625,
        1075.70703125
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3293.0,
        -4992.810546875,
        1077.70703125
      ],
      [
        -3292.179931640625,
        -4997.56884765625,
        1075.0
      ],
      [
        -3291.706787109375,
        -4999.947265625,
        1075.0
      ],
      [
        -3291.706787109375,
        -4999.947265625,
        1075.0
      ],
      [
        -3292.179931640625,
        -4997.56884765625,
        1075.0
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.0
      ],
      [
        -3292.179931640625,
        -4997.56884765625,
        1075.0
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.70703125
      ],
      [
        -3292.179931640625,
        -4997.56884765625,
        1075.0
      ],
      [
        -3293.0,
        -4996.34130859375,
        1075.0
      ],
      [
        -3307.5,
        -4977.00048828125,
        1075.0
      ],
      [
        -3305.5,
        -4977.00048828125,
        1075.0
      ],
      [
        -3305.5,
        -4977.00048828125,
        1075.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3307.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3307.5,
        -4977.00048828125,
        1075.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3305.5,
        -4986.19921875,
        1077.70703125
      ],
      [
        -3307.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1075.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      [
        -3305.5,
        -4990.23828125,
        1075.70703125
      ],
      [
        -3305.5,
        -4990.23828125,
        1077.70703125
      ],
      [
        -3305.5,
        -4977.00048828125,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3306.5,
        -4988.00048828125,
        1075.0
      ],
      [
        -3312.431640625,
        -4989.18017578125,
        1075.0
      ],
      [
        -3312.431640625,
        -4989.18017578125,
        1075.0
      ],
      [
        -3306.5,
        -4988.00048828125,
        1075.0
      ],
      [
        -3307.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3307.5,
        -4977.00048828125,
        1075.0
      ],
      [
        -3312.431640625,
        -4989.18017578125,
        1075.0
      ],
      [
        -3317.460205078125,
        -4992.54052734375,
        1075.0
      ],
      [
        -3317.460205078125,
        -4992.54052734375,
        1075.0
      ],
      [
        -3312.431640625,
        -4989.18017578125,
        1075.0
      ],
      [
        -3317.460205078125,
        -4992.54052734375,
        1075.0
      ],
      [
        -3317.460205078125,
        -4992.54052734375,
        1075.0
      ],
      [
        -3307.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3306.5,
        -4988.00048828125,
        1075.0
      ],
      [
        -3306.5,
        -4988.00048828125,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.70703125
      ],
      [
        -3295.539794921875,
        -4992.54052734375,
        1075.0
      ],
      [
        -3300.568359375,
        -4989.18017578125,
        1075.0
      ],
      [
        -3300.568359375,
        -4989.18017578125,
        1075.0
      ],
      [
        -3295.539794921875,
        -4992.54052734375,
        1075.0
      ],
      [
        -3300.568359375,
        -4989.18017578125,
        1075.0
      ],
      [
        -3300.568359375,
        -4989.18017578125,
        1075.0
      ],
      [
        -3295.539794921875,
        -4992.54052734375,
        1075.0
      ],
      [
        -3295.539794921875,
        -4992.54052734375,
        1075.0
      ],
      [
        -3305.5,
        -4957.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4967.00048828125,
        1075.0
      ],
      [
        -3307.5,
        -4967.00048828125,
        1075.0
      ],
      [
        -3307.5,
        -4957.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4967.00048828125,
        1075.0
      ],
      [
        -3307.5,
        -4967.00048828125,
        1075.0
      ],
      [
        -3322.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3291.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3367.0,
        -5003.50048828125,
        1078.6046142578125
      ],
      [
        -3367.0,
        -5023.50048828125,
        1078.6046142578125
      ],
      [
        -3349.45263671875,
        -4985.708984375,
        1078.612060546875
      ],
      [
        -3349.45263671875,
        -4985.708984375,
        1078.612060546875
      ],
      [
        -3339.371337890625,
        -4970.62890625,
        1078.6163330078125
      ],
      [
        -3339.371337890625,
        -4970.62890625,
        1078.6163330078125
      ],
      [
        -3324.287353515625,
        -4960.5576171875,
        1078.622802734375
      ],
      [
        -3367.0,
        -5003.50048828125,
        1078.602783203125
      ],
      [
        -3367.0,
        -5023.50048828125,
        1078.602783203125
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1078.5999755859375
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1078.5999755859375
      ],
      [
        -3367.0,
        -5003.50048828125,
        1078.6046142578125
      ],
      [
        -3324.294677734375,
        -4960.5400390625,
        1078.5941162109375
      ],
      [
        -3339.38037109375,
        -4970.6201171875,
        1078.59716796875
      ],
      [
        -3339.38037109375,
        -4970.6201171875,
        1078.59716796875
      ],
      [
        -3324.25341796875,
        -4960.53173828125,
        1078.5941162109375
      ],
      [
        -3324.294677734375,
        -4960.5400390625,
        1078.5941162109375
      ],
      [
        -3349.46044921875,
        -4985.70556640625,
        1075.0
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1075.0
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1075.0
      ],
      [
        -3367.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3367.0,
        -5003.50048828125,
        1078.602783203125
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1075.0
      ],
      [
        -3367.0,
        -5003.50048828125,
        1075.0
      ],
      [
        -3339.38037109375,
        -4970.6201171875,
        1075.0
      ],
      [
        -3349.46044921875,
        -4985.70556640625,
        1075.0
      ],
      [
        -3324.294677734375,
        -4960.5400390625,
        1075.0
      ],
      [
        -3339.38037109375,
        -4970.6201171875,
        1075.0
      ],
      [
        -3324.294677734375,
        -4960.5400390625,
        1075.0
      ],
      [
        -3260.0,
        -5003.5,
        1075.0
      ],
      [
        -3263.53955078125,
        -4985.70556640625,
        1075.0
      ],
      [
        -3260.0,
        -5003.5,
        1075.0
      ],
      [
        -3273.61962890625,
        -4970.6201171875,
        1075.0
      ],
      [
        -3288.705322265625,
        -4960.5400390625,
        1075.0
      ],
      [
        -3263.53955078125,
        -4985.70556640625,
        1075.0
      ],
      [
        -3273.61962890625,
        -4970.6201171875,
        1075.0
      ],
      [
        -3288.705322265625,
        -4960.5400390625,
        1075.0
      ],
      [
        -3357.767822265625,
        -5035.00048828125,
        1074.63720703125
      ],
      [
        -3357.767822265625,
        -5035.00048828125,
        1064.699951171875
      ],
      [
        -3363.767822265625,
        -5035.00048828125,
        1074.63720703125
      ],
      [
        -3357.767822265625,
        -5035.00048828125,
        1074.63720703125
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      [
        -3361.949951171875,
        -5073.943359375,
        1070.228515625
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      [
        -3363.767822265625,
        -5035.00048828125,
        1064.699951171875
      ],
      [
        -3363.767822265625,
        -5035.00048828125,
        1074.63720703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1070.6409912109375
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1064.699951171875
      ],
      [
        -3367.0,
        -5023.50048828125,
        1064.70703125
      ],
      [
        -3358.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1064.70703125
      ],
      [
        -3257.0,
        -5023.5,
        1065.8070068359375
      ],
      [
        -3257.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1064.70703125
      ],
      [
        -3364.0,
        -5024.50048828125,
        1064.70703125
      ],
      [
        -3364.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      [
        -3364.0,
        -5024.50048828125,
        1064.70703125
      ],
      [
        -3364.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3364.0,
        -5024.50048828125,
        1074.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1074.8070068359375
      ],
      [
        -3364.0,
        -5024.50048828125,
        1074.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1074.8070068359375
      ],
      [
        -3367.0,
        -5023.50048828125,
        1064.705810546875
      ],
      [
        -3367.0,
        -5003.50048828125,
        1064.705810546875
      ],
      [
        -3367.0,
        -5003.50048828125,
        1064.705810546875
      ],
      [
        -3367.0,
        -5003.50048828125,
        1064.705810546875
      ],
      [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      [
        -3322.0,
        -4998.47265625,
        1068.70703125
      ],
      [
        -3322.0,
        -4998.47265625,
        1068.70703125
      ],
      [
        -3305.5,
        -4977.00048828125,
        1065.800048828125
      ],
      [
        -3305.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3305.5,
        -4957.19921875,
        1065.800048828125
      ],
      [
        -3305.5,
        -4967.00048828125,
        1065.800048828125
      ],
      [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4977.00048828125,
        1065.800048828125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1065.800048828125
      ],
      [
        -3307.5,
        -4957.19921875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4977.00048828125,
        1065.800048828125
      ],
      [
        -3305.5,
        -4977.00048828125,
        1065.800048828125
      ],
      [
        -3306.5,
        -4987.00048828125,
        1065.800048828125
      ],
      [
        -3305.5,
        -4987.19921875,
        1064.699951171875
      ],
      [
        -3305.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4987.19921875,
        1064.699951171875
      ],
      [
        -3306.5,
        -4987.00048828125,
        1065.800048828125
      ],
      [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3305.5,
        -4967.00048828125,
        1065.800048828125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1065.800048828125
      ],
      [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3318.167236328125,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3318.167236328125,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3312.814208984375,
        -4988.25634765625,
        1065.800048828125
      ],
      [
        -3312.814208984375,
        -4988.25634765625,
        1065.800048828125
      ],
      [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3322.0,
        -4998.47265625,
        1065.800048828125
      ],
      [
        -3294.832763671875,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3291.255859375,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3300.185791015625,
        -4988.25634765625,
        1065.800048828125
      ],
      [
        -3294.832763671875,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3300.185791015625,
        -4988.25634765625,
        1065.800048828125
      ],
      [
        -3291.255859375,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3291.0,
        -4998.47265625,
        1064.699951171875
      ],
      [
        -3291.0,
        -4998.47265625,
        1065.800048828125
      ],
      [
        -3291.0,
        -4998.47265625,
        1068.70703125
      ],
      [
        -3293.0,
        -4994.57568359375,
        1065.800048828125
      ],
      [
        -3293.0,
        -4994.57568359375,
        1068.70703125
      ],
      [
        -3291.0,
        -4998.47265625,
        1068.70703125
      ],
      [
        -3293.0,
        -4994.57568359375,
        1068.70703125
      ],
      [
        -3293.0,
        -4996.34130859375,
        1069.70703125
      ],
      [
        -3320.0,
        -4994.57568359375,
        1065.800048828125
      ],
      [
        -3320.0,
        -4994.57568359375,
        1068.70703125
      ],
      [
        -3320.0,
        -4994.57568359375,
        1068.70703125
      ],
      [
        -3320.0,
        -4996.34130859375,
        1069.70703125
      ],
      [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4987.19921875,
        1068.70703125
      ],
      [
        -3307.5,
        -4987.19921875,
        1068.70703125
      ],
      [
        -3307.5,
        -4988.19921875,
        1069.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1069.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1065.800048828125
      ],
      [
        -3305.5,
        -4987.19921875,
        1069.70703125
      ],
      [
        -3305.5,
        -4957.19921875,
        1069.70703125
      ],
      [
        -3305.5,
        -4967.00048828125,
        1069.70703125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1069.70703125
      ],
      [
        -3307.5,
        -4957.19921875,
        1069.70703125
      ],
      [
        -3305.5,
        -4967.00048828125,
        1069.70703125
      ],
      [
        -3307.5,
        -4967.00048828125,
        1069.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1069.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3305.5,
        -4988.19921875,
        1069.70703125
      ],
      [
        -3305.5,
        -4988.19921875,
        1075.0
      ],
      [
        -3364.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3364.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3357.767822265625,
        -5035.00048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.767822265625,
        -5035.00048828125,
        1064.70703125
      ],
      [
        -3364.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3363.767822265625,
        -5035.00048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5035.00048828125,
        1074.63720703125
      ],
      [
        -3448.039306640625,
        -4168.08642578125,
        1228.752685546875
      ],
      [
        -3398.675537109375,
        -4126.21435546875,
        1226.4107666015625
      ],
      [
        -3567.142578125,
        -4206.91162109375,
        1234.052490234375
      ],
      [
        -3502.647216796875,
        -4206.91162109375,
        1234.052490234375
      ],
      [
        -3494.719970703125,
        -4207.68310546875,
        1230.967041015625
      ],
      [
        -3398.3798828125,
        -4106.7890625,
        1233.3277587890625
      ],
      [
        -3398.675537109375,
        -4126.21435546875,
        1226.4107666015625
      ],
      [
        -3494.100830078125,
        -4207.7431640625,
        1230.725830078125
      ],
      [
        -3448.039306640625,
        -4168.08642578125,
        1228.752685546875
      ],
      [
        -3494.100830078125,
        -4207.7431640625,
        1230.72607421875
      ],
      [
        -3447.064208984375,
        -4165.8994140625,
        1232.6005859375
      ],
      [
        -3400.11083984375,
        -4126.208984375,
        1229.9801025390625
      ],
      [
        -3399.709228515625,
        -4106.26220703125,
        1236.8394775390625
      ],
      [
        -3400.11083984375,
        -4126.208984375,
        1229.9801025390625
      ],
      [
        -3495.07421875,
        -4206.91162109375,
        1234.052490234375
      ],
      [
        -3494.719970703125,
        -4207.68310546875,
        1230.967041015625
      ],
      [
        -3494.467041015625,
        -4206.91162109375,
        1234.052490234375
      ],
      [
        -3492.775634765625,
        -4205.1201171875,
        1234.9482421875
      ],
      [
        -3447.064208984375,
        -4165.8994140625,
        1232.6005859375
      ],
      [
        -3494.467041015625,
        -4206.91162109375,
        1234.052490234375
      ],
      [
        -3439.29150390625,
        -4148.46630859375,
        1263.2750244140625
      ],
      [
        -3419.163818359375,
        -4098.55322265625,
        1288.231689453125
      ],
      [
        -3400.0986328125,
        -4125.603515625,
        1230.1883544921875
      ],
      [
        -3417.996337890625,
        -4125.90966796875,
        1274.5533447265625
      ],
      [
        -3439.29150390625,
        -4148.46630859375,
        1263.2750244140625
      ],
      [
        -3417.986328125,
        -4126.14453125,
        1274.4359130859375
      ],
      [
        -3417.986328125,
        -4126.14453125,
        1274.4359130859375
      ],
      [
        -3417.996337890625,
        -4125.90966796875,
        1274.5533447265625
      ],
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -4971.00048828125,
        1096.70703125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -4968.900390625,
        1092.53173828125
      ],
      [
        -3430.0,
        -4968.900390625,
        1085.7276611328125
      ],
      [
        -3430.0,
        -4971.00048828125,
        1096.70703125
      ],
      [
        -3430.0,
        -4968.900390625,
        1092.53173828125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -4968.97900390625,
        1092.687744140625
      ],
      [
        -3425.304931640625,
        -4950.13916015625,
        1096.31689453125
      ],
      [
        -3423.878662109375,
        -4940.70068359375,
        1093.4639892578125
      ],
      [
        -3425.304931640625,
        -5064.00048828125,
        1096.31689453125
      ],
      [
        -3425.66015625,
        -5064.00048828125,
        1097.0274658203125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3425.304931640625,
        -5064.00048828125,
        1096.31689453125
      ],
      [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3427.029052734375,
        -4940.70068359375,
        1079.70703125
      ],
      [
        -3430.0,
        -4953.50048828125,
        1079.70703125
      ],
      [
        -3430.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3418.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3420.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3420.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3420.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3420.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3420.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3422.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3425.66015625,
        -5039.00048828125,
        1097.0274658203125
      ],
      [
        -3424.0,
        -5039.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5039.00048828125,
        1090.70703125
      ],
      [
        -3421.5,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3421.5,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3421.5,
        -5043.00048828125,
        1088.70703125
      ],
      [
        -3424.0,
        -5043.00048828125,
        1093.706787109375
      ],
      [
        -3424.0,
        -5039.00048828125,
        1093.706787109375
      ],
      [
        -3425.66015625,
        -5031.00048828125,
        1097.0274658203125
      ],
      [
        -3424.0,
        -5031.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5031.00048828125,
        1090.70703125
      ],
      [
        -3421.5,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3421.5,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3421.5,
        -5035.00048828125,
        1088.70703125
      ],
      [
        -3424.0,
        -5035.00048828125,
        1093.706787109375
      ],
      [
        -3424.0,
        -5031.00048828125,
        1093.706787109375
      ],
      [
        -3418.0,
        -5064.00048828125,
        1092.099365234375
      ],
      [
        -3418.0,
        -5064.00048828125,
        1104.687744140625
      ],
      [
        -3418.0,
        -5064.00048828125,
        1092.099365234375
      ],
      [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3418.0,
        -5043.00048828125,
        1088.70703125
      ],
      [
        -3418.0,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3418.0,
        -5035.00048828125,
        1088.70703125
      ],
      [
        -3418.0,
        -5039.00048828125,
        1090.70703125
      ],
      [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3418.0,
        -5031.00048828125,
        1090.70703125
      ],
      [
        -3418.0,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -4985.720703125,
        1079.70703125
      ],
      [
        -3370.0,
        -4953.50048828125,
        1079.70703125
      ],
      [
        -3409.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      [
        -3409.0,
        -5036.92919921875,
        1088.70703125
      ],
      [
        -3409.0,
        -5036.92919921875,
        1090.70703125
      ],
      [
        -3401.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3401.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3401.0,
        -4969.00048828125,
        1092.45703125
      ],
      [
        -3401.0,
        -4968.00048828125,
        1096.70703125
      ],
      [
        -3401.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3401.0,
        -4969.00048828125,
        1092.45703125
      ],
      [
        -3395.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3378.0,
        -4976.6474609375,
        1079.70703125
      ],
      [
        -3378.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3408.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3403.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3405.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3403.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3378.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3370.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1079.70703125
      ],
      [
        -3427.029052734375,
        -4940.70068359375,
        1075.70703125
      ],
      [
        -3430.0,
        -4953.50048828125,
        1075.70703125
      ],
      [
        -3370.0,
        -4953.50048828125,
        1075.70703125
      ],
      [
        -3370.0,
        -4959.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -4959.00048828125,
        1075.70703125
      ],
      [
        -3370.0,
        -4959.00048828125,
        1056.70703125
      ],
      [
        -3403.0,
        -5056.00048828125,
        1070.70703125
      ],
      [
        -3403.0,
        -5056.00048828125,
        1073.70703125
      ],
      [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      [
        -3403.0,
        -5058.34375,
        1066.0501708984375
      ],
      [
        -3403.0,
        -5058.34375,
        1066.0501708984375
      ],
      [
        -3403.0,
        -5056.00048828125,
        1070.70703125
      ],
      [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3422.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3405.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3403.0,
        -5056.00048828125,
        1073.70703125
      ],
      [
        -3403.0,
        -5058.34375,
        1079.3638916015625
      ],
      [
        -3403.0,
        -5058.34375,
        1079.3638916015625
      ],
      [
        -3403.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3420.0,
        -5058.48583984375,
        1079.70703125
      ],
      [
        -3370.0,
        -4966.88232421875,
        1079.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1044.4298095703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1044.4298095703125
      ],
      [
        -2900.0,
        -5176.0,
        1000.0
      ],
      [
        -2880.0,
        -5176.0,
        1000.0
      ],
      [
        -2979.000244140625,
        -5159.0,
        1000.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1000.0
      ],
      [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      [
        -2979.000244140625,
        -5150.0,
        1000.0
      ],
      [
        -2979.000244140625,
        -5150.0,
        1000.0
      ],
      [
        -2979.000244140625,
        -5159.0,
        1000.0
      ],
      [
        -2969.000244140625,
        -5159.0,
        1000.0
      ],
      [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      [
        -2880.0,
        -5194.0,
        1000.0
      ],
      [
        -2900.0,
        -5194.0,
        1000.0
      ],
      [
        -2900.0,
        -5176.0,
        1000.0
      ],
      [
        -2900.0,
        -5194.0,
        1000.0
      ],
      [
        -2880.0,
        -5176.0,
        1000.0
      ],
      [
        -2880.0,
        -5194.0,
        1000.0
      ],
      [
        -2890.00048828125,
        -5076.0,
        940.0
      ],
      [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      [
        -2880.000244140625,
        -5134.0,
        943.3334350585938
      ],
      [
        -2880.000244140625,
        -5076.0,
        943.3334350585938
      ],
      [
        -2880.000244140625,
        -5076.0,
        943.3334350585938
      ],
      [
        -2890.00048828125,
        -5076.0,
        940.0
      ],
      [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      [
        -2880.000244140625,
        -5134.0,
        943.3334350585938
      ],
      [
        -2905.000244140625,
        -5076.0,
        965.0
      ],
      [
        -2905.000244140625,
        -5134.0,
        965.0
      ],
      [
        -2910.00048828125,
        -5124.0,
        960.0
      ],
      [
        -2910.00048828125,
        -5134.0,
        960.0
      ],
      [
        -2908.00048828125,
        -5134.0,
        962.0
      ],
      [
        -2908.00048828125,
        -5124.0,
        962.0
      ],
      [
        -2908.00048828125,
        -5124.0,
        962.0
      ],
      [
        -2910.00048828125,
        -5124.0,
        960.0
      ],
      [
        -2911.81884765625,
        -5134.0,
        962.0
      ],
      [
        -2917.272705078125,
        -5124.0,
        962.0
      ],
      [
        -2917.272705078125,
        -5124.0,
        960.0
      ],
      [
        -2911.818603515625,
        -5134.0,
        960.0
      ],
      [
        -2917.272705078125,
        -5124.0,
        962.0
      ],
      [
        -2917.272705078125,
        -5124.0,
        960.0
      ],
      [
        -2910.000244140625,
        -5134.0,
        960.0
      ],
      [
        -2908.000244140625,
        -5134.0,
        962.0
      ],
      [
        -2911.818603515625,
        -5134.0,
        962.0
      ],
      [
        -2911.818603515625,
        -5134.0,
        960.0
      ],
      [
        -2911.818603515625,
        -5134.0,
        958.1815795898438
      ],
      [
        -2911.818603515625,
        -5134.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5044.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5064.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5064.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5044.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5044.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5044.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5064.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5064.0,
        965.0
      ],
      [
        -3120.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3100.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5154.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5134.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5124.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5104.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3040.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3020.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5009.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5029.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5074.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3060.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5184.0,
        965.0
      ],
      [
        -3080.000244140625,
        -5164.0,
        965.0
      ],
      [
        -3165.000244140625,
        -5009.0,
        1010.0
      ],
      [
        -3015.000244140625,
        -5009.0,
        1010.0
      ],
      [
        -3160.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3194.33349609375,
        -5009.0,
        980.0
      ],
      [
        -3194.33349609375,
        -5009.0,
        980.0
      ],
      [
        -3160.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3022.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3156.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3156.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3022.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3022.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3022.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3160.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3156.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3160.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3156.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3194.33349609375,
        -5009.0,
        980.0
      ],
      [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3194.33349609375,
        -5009.0,
        980.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      [
        -2980.000244140625,
        -5009.0,
        980.0
      ],
      [
        -2980.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3165.000244140625,
        -5009.0,
        1010.0
      ],
      [
        -3165.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3015.000244140625,
        -5009.0,
        1010.0
      ],
      [
        -3015.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3195.000244140625,
        -5004.0,
        1010.0000610351562
      ],
      [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      [
        -3195.000244140625,
        -5009.0,
        1010.0000610351562
      ],
      [
        -3165.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3165.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3165.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3015.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3015.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3195.000244140625,
        -5006.5,
        1010.0000610351562
      ],
      [
        -3195.000244140625,
        -5009.0,
        1012.5
      ],
      [
        -3195.000244140625,
        -5006.5,
        1012.5
      ],
      [
        -3195.000244140625,
        -5004.0,
        1012.5
      ],
      [
        -3195.000244140625,
        -5006.5,
        1012.5
      ],
      [
        -3195.000244140625,
        -5009.0,
        1035.0
      ],
      [
        -3195.000244140625,
        -5006.5,
        1035.0
      ],
      [
        -3162.500244140625,
        -5009.0,
        1015.0
      ],
      [
        -3162.500244140625,
        -5009.0,
        1015.0
      ],
      [
        -3162.500244140625,
        -5009.0,
        1015.0
      ],
      [
        -3017.500244140625,
        -5009.0,
        1015.0
      ],
      [
        -3017.500244140625,
        -5009.0,
        1015.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        1010.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        980.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        1010.0
      ],
      [
        -3020.000244140625,
        -5189.0,
        1012.5
      ],
      [
        -3020.000244140625,
        -5189.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1015.0
      ],
      [
        -3020.000244140625,
        -5186.5,
        1015.0
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5124.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5189.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5189.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      [
        -3100.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5184.0,
        1010.0
      ],
      [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      [
        -3160.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5029.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5044.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5044.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5044.0,
        980.0
      ],
      [
        -3162.500244140625,
        -5029.0,
        1010.0
      ],
      [
        -3162.500244140625,
        -5029.0,
        980.0
      ],
      [
        -3080.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3079.500244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3079.500244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3079.500244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5104.5,
        980.0
      ],
      [
        -3060.000244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3079.500244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5123.5,
        980.0
      ],
      [
        -3060.500244140625,
        -5119.0,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5109.0,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5109.0,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5119.0,
        1012.5000610351562
      ],
      [
        -3060.500244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5109.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5119.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5109.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5119.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5108.0,
        991.0
      ],
      [
        -3060.000244140625,
        -5120.0,
        991.0
      ],
      [
        -3060.000244140625,
        -5120.0,
        991.0
      ],
      [
        -3060.000244140625,
        -5120.0,
        980.0
      ],
      [
        -3060.000244140625,
        -5108.0,
        980.0
      ],
      [
        -3060.000244140625,
        -5108.0,
        991.0
      ],
      [
        -3060.000244140625,
        -5119.0,
        980.0
      ],
      [
        -3060.000244140625,
        -5119.0,
        990.0
      ],
      [
        -3060.000244140625,
        -5119.0,
        990.0
      ],
      [
        -3060.000244140625,
        -5109.0,
        990.0
      ],
      [
        -3060.000244140625,
        -5109.0,
        990.0
      ],
      [
        -3060.000244140625,
        -5109.0,
        980.0
      ],
      [
        -3140.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3040.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3080.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      [
        -3160.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      [
        -3140.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3120.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5104.5,
        1030.0
      ],
      [
        -3060.000244140625,
        -5104.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5123.5,
        1030.0
      ],
      [
        -3060.000244140625,
        -5123.5,
        1012.5000610351562
      ],
      [
        -3060.000244140625,
        -5109.0,
        1029.5
      ],
      [
        -3060.000244140625,
        -5119.0,
        1029.5
      ],
      [
        -3060.000244140625,
        -5104.5,
        1029.5
      ],
      [
        -3060.000244140625,
        -5109.0,
        1029.5
      ],
      [
        -3060.000244140625,
        -5119.0,
        1029.5
      ],
      [
        -3060.000244140625,
        -5123.5,
        1029.5
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3247.0,
      "bbox_min": [
        -3963.999755859375,
        -5310.0,
        1035.0
      ],
      "bbox_max": [
        -2660.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.0,
      "bbox_min": [
        -3247.0,
        -5310.0,
        1035.0
      ],
      "bbox_max": [
        -2660.0,
        -3633.42822265625,
        1395.809326171875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2940.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5044.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        -2940.000244140625,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -2940.000244140625,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5194.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5176.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5176.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5176.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2900.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2900.0,
        -5176.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5176.0,
      "bbox_min": [
        -2940.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.9486833810806274,
        0.0
      ],
      "plane_d": 3893.396728515625,
      "bbox_min": [
        -2940.000244140625,
        -5084.0,
        1060.0
      ],
      "bbox_max": [
        -2910.000244140625,
        -5054.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2910.000244140625,
      "bbox_min": [
        -2910.000244140625,
        -5074.0,
        1060.0
      ],
      "bbox_max": [
        -2910.000244140625,
        -5054.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5194.0,
      "bbox_min": [
        -2940.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5176.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        -2901.000244140625,
        -5194.0,
        1075.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5176.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2901.000244140625,
      "bbox_min": [
        -2901.000244140625,
        -5194.0,
        1075.0
      ],
      "bbox_max": [
        -2901.000244140625,
        -5176.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2969.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5194.0,
        1035.0
      ],
      "bbox_max": [
        -2940.000244140625,
        -5044.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -2969.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2940.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        -2969.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2940.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2960.000244140625,
      "bbox_min": [
        -2969.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2940.000244140625,
        -5084.0,
        1080.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5084.0,
      "bbox_min": [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5084.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5118.99951171875,
      "bbox_min": [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5109.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5148.99951171875,
      "bbox_min": [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5139.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5139.0,
      "bbox_min": [
        -2969.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5139.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 2289.73388671875,
      "bbox_min": [
        -2969.000244140625,
        -5149.0,
        1075.5
      ],
      "bbox_max": [
        -2960.000244140625,
        -5139.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5109.0,
      "bbox_min": [
        -2969.000244140625,
        -5119.0,
        1060.0
      ],
      "bbox_max": [
        -2960.000244140625,
        -5109.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 2289.73388671875,
      "bbox_min": [
        -2969.000244140625,
        -5119.0,
        1075.5
      ],
      "bbox_max": [
        -2960.000244140625,
        -5109.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5194.0,
      "bbox_min": [
        -2960.000244140625,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2940.000244140625,
        -5194.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5150.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1035.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5044.0,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        -2980.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        -2980.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5084.0,
      "bbox_min": [
        -2980.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2970.000244140625,
      "bbox_min": [
        -2970.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5118.99951171875,
      "bbox_min": [
        -2970.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5148.99951171875,
      "bbox_min": [
        -2970.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5139.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5139.0,
      "bbox_min": [
        -2970.000244140625,
        -5149.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5139.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 2289.73388671875,
      "bbox_min": [
        -2970.000244140625,
        -5149.0,
        1075.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5139.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5109.0,
      "bbox_min": [
        -2970.000244140625,
        -5119.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 2289.73388671875,
      "bbox_min": [
        -2970.000244140625,
        -5119.0,
        1075.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5109.0,
        1075.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5044.0,
      "bbox_min": [
        -2980.000244140625,
        -5044.0,
        1060.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5044.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1035.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2979.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1035.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5999755859375,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1115.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3247.0,
        -4920.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3633.42822265625,
        1395.809326171875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3210.865234375,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3874.62548828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3082.545166015625,
        -3928.78857421875,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.56787109375,
        -3874.62548828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3066.5947265625,
        -3884.224853515625,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.56787109375,
        -3874.62548828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        -0.0
      ],
      "plane_d": -5154.79296875,
      "bbox_min": [
        -3210.865234375,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3210.865234375,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3015.14697265625,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3184.8525390625,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3015.14697265625,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4722.58203125,
        1082.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3079.999755859375,
        -4695.85546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555710792541504,
        -0.8314691185951233,
        -0.0
      ],
      "plane_d": -5637.83984375,
      "bbox_min": [
        -3177.4326171875,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3015.14697265625,
        -4695.85546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3079.999755859375,
        -4722.58154296875,
        1082.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4695.85546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33234429359436035,
        -0.9431581497192383,
        -0.0
      ],
      "plane_d": -5485.4833984375,
      "bbox_min": [
        -3177.4326171875,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4722.58154296875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33234429359436035,
        -0.9431581497192383,
        0.0
      ],
      "plane_d": -3424.94873046875,
      "bbox_min": [
        -3177.4326171875,
        -4862.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4722.58203125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2875499129295349,
        -0.07020559161901474,
        0.955189049243927
      ],
      "plane_d": -2246.758056640625,
      "bbox_min": [
        -3177.4326171875,
        -4862.19482421875,
        1074.311279296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3045.07763671875,
        -4835.07568359375,
        1074.311279296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4798.42578125,
        1083.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -5197.7412109375,
      "bbox_min": [
        -3045.07763671875,
        -4804.46142578125,
        1080.436279296875
      ],
      "bbox_max": [
        -3041.044677734375,
        -4798.42578125,
        1083.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2550874352455139,
        0.018345560878515244,
        0.9667439460754395
      ],
      "plane_d": -1732.361083984375,
      "bbox_min": [
        -3177.4326171875,
        -4862.19482421875,
        1077.373779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476786494255066,
        0.016561293974518776,
        0.9668603539466858
      ],
      "plane_d": -1740.162353515625,
      "bbox_min": [
        -3177.4326171875,
        -4848.052734375,
        1077.373779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23879720270633698,
        -0.17490075528621674,
        0.9551888108253479
      ],
      "plane_d": -2604.228759765625,
      "bbox_min": [
        -3177.4326171875,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3052.26806640625,
        -4830.0341796875,
        1081.9837646484375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4789.77880859375,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3052.26806640625,
        -4830.0341796875,
        1081.9837646484375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4789.77880859375,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3052.26806640625,
        -4791.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4789.77880859375,
        1086.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23999638855457306,
        -0.14432395994663239,
        0.9599855542182922
      ],
      "plane_d": -2465.7001953125,
      "bbox_min": [
        -3177.4326171875,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1081.311279296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.7685546875,
        1084.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -53.724609375,
      "bbox_min": [
        -3158.954833984375,
        -4824.46142578125,
        1080.436279296875
      ],
      "bbox_max": [
        -3139.73779296875,
        -4804.4375,
        1088.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3139.73779296875,
        -4804.4375,
        1088.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03231842815876007,
        -0.17637556791305542,
        0.9837923049926758
      ],
      "plane_d": -2018.45458984375,
      "bbox_min": [
        -3177.4326171875,
        -4824.46142578125,
        1084.373779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -3181.282470703125,
      "bbox_min": [
        -3087.100341796875,
        -4819.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -5197.7412109375,
      "bbox_min": [
        -3087.100341796875,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3087.100341796875,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3087.100341796875,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4779.7685546875,
        1093.6697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3041.044677734375,
        -4807.90087890625,
        1085.9569091796875
      ],
      "bbox_max": [
        -3040.360595703125,
        -4804.46142578125,
        1087.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1664927452802658,
        -0.22518356144428253,
        0.9599857330322266
      ],
      "plane_d": -2632.12109375,
      "bbox_min": [
        -3041.044677734375,
        -4819.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4796.8076171875,
        1092.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3041.044677734375,
        -4819.7685546875,
        1084.373779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4804.46142578125,
        1087.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31399640440940857,
        -0.0,
        0.949424147605896
      ],
      "plane_d": -79.42742919921875,
      "bbox_min": [
        -3177.4326171875,
        -4824.46142578125,
        1087.436279296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10164552927017212,
        -0.14857377111911774,
        0.9836635589599609
      ],
      "plane_d": -2111.11279296875,
      "bbox_min": [
        -3177.4326171875,
        -4824.46142578125,
        1087.436279296875
      ],
      "bbox_max": [
        -3050.65576171875,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1822548806667328,
        -0.1801173835992813,
        0.9666131138801575
      ],
      "plane_d": -2496.810302734375,
      "bbox_min": [
        -3170.575927734375,
        -4824.46142578125,
        1087.436279296875
      ],
      "bbox_max": [
        -3050.65576171875,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950962394475937,
        -0.9807840585708618,
        0.0
      ],
      "plane_d": -5288.4267578125,
      "bbox_min": [
        -3161.597900390625,
        -4824.46142578125,
        1087.436279296875
      ],
      "bbox_max": [
        -3050.65576171875,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -2250.378173828125,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1088.8004150390625
      ],
      "bbox_max": [
        -3050.65576171875,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950962394475937,
        -0.9807841181755066,
        0.0
      ],
      "plane_d": -4098.4462890625,
      "bbox_min": [
        -3137.30712890625,
        -4802.8134765625,
        1089.561279296875
      ],
      "bbox_max": [
        -3050.65576171875,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3062.6923828125,
        -4786.7880859375,
        1093.10986328125
      ],
      "bbox_max": [
        -3056.74462890625,
        -4782.8134765625,
        1096.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4799.7685546875,
        1092.58056640625
      ],
      "bbox_max": [
        -3050.65576171875,
        -4786.7880859375,
        1099.294677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3056.74462890625,
        -4790.8564453125,
        1092.58056640625
      ],
      "bbox_max": [
        -3050.65576171875,
        -4786.7880859375,
        1094.59423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009122781455516815,
        -0.2162281721830368,
        0.9763002991676331
      ],
      "plane_d": -2135.724609375,
      "bbox_min": [
        -3170.575927734375,
        -4823.36669921875,
        1088.1514892578125
      ],
      "bbox_max": [
        -3144.960693359375,
        -4784.3359375,
        1098.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -2707.666015625,
      "bbox_min": [
        -3170.15087890625,
        -4823.36669921875,
        1088.1514892578125
      ],
      "bbox_max": [
        -3150.283935546875,
        -4811.484375,
        1092.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -2707.666015625,
      "bbox_min": [
        -3170.575927734375,
        -4819.82421875,
        1090.4659423828125
      ],
      "bbox_max": [
        -3150.283935546875,
        -4802.89697265625,
        1094.3204345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03231843188405037,
        -0.17637555301189423,
        0.9837923049926758
      ],
      "plane_d": -1821.6077880859375,
      "bbox_min": [
        -3161.09130859375,
        -4813.603515625,
        1092.473876953125
      ],
      "bbox_max": [
        -3150.283935546875,
        -4802.89697265625,
        1094.3204345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31399640440940857,
        0.0,
        0.949424147605896
      ],
      "plane_d": -2026.2049560546875,
      "bbox_min": [
        -3177.4326171875,
        -4819.64794921875,
        1090.5809326171875
      ],
      "bbox_max": [
        -3115.306396484375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950962394475937,
        -0.9807841181755066,
        0.0
      ],
      "plane_d": -4098.4462890625,
      "bbox_min": [
        -3137.30712890625,
        -4802.8134765625,
        1096.561279296875
      ],
      "bbox_max": [
        -3115.306396484375,
        -4799.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4799.7685546875,
        1098.60302734375
      ],
      "bbox_max": [
        -3115.306396484375,
        -4799.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009122781455516815,
        -0.2162281721830368,
        0.9763002991676331
      ],
      "plane_d": -2135.724609375,
      "bbox_min": [
        -3177.4326171875,
        -4819.64794921875,
        1090.5809326171875
      ],
      "bbox_max": [
        -3144.960693359375,
        -4784.3359375,
        1098.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07770257443189621,
        -0.4069710969924927,
        0.9101300835609436
      ],
      "plane_d": -2707.666015625,
      "bbox_min": [
        -3177.4326171875,
        -4819.64794921875,
        1090.5809326171875
      ],
      "bbox_max": [
        -3161.09130859375,
        -4813.603515625,
        1092.473876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009122795425355434,
        -0.216228187084198,
        0.9763002395629883
      ],
      "plane_d": -2074.8388671875,
      "bbox_min": [
        -3077.999755859375,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3051.03662109375,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4790.60205078125,
        1092.70654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10164552181959152,
        -0.14857377111911774,
        0.9836635589599609
      ],
      "plane_d": -1477.9390869140625,
      "bbox_min": [
        -3077.999755859375,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1822548657655716,
        -0.18011736869812012,
        0.9666131138801575
      ],
      "plane_d": -1363.227783203125,
      "bbox_min": [
        -3062.6923828125,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4764.3359375,
        1098.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        -0.8314673900604248,
        0.0
      ],
      "plane_d": -5678.3037109375,
      "bbox_min": [
        -3062.6923828125,
        -4791.484375,
        1092.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4782.8134765625,
        1096.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113733768463135,
        0.0,
        0.41158080101013184
      ],
      "plane_d": 2376.92529296875,
      "bbox_min": [
        -3247.0,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3633.42822265625,
        1395.809326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.812631368637085,
        0.0,
        -0.5827782154083252
      ],
      "plane_d": 3184.68017578125,
      "bbox_min": [
        -3247.0,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3105.568603515625,
        -3633.42822265625,
        1395.809326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3247.0,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3633.42822265625,
        1395.809326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3221.23876953125,
        -3984.973388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3906.280029296875,
        1259.68896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3944.82568359375,
        1197.2989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3884.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -5585.61865234375,
      "bbox_min": [
        -3170.900634765625,
        -4733.07763671875,
        1152.623779296875
      ],
      "bbox_max": [
        -3162.690185546875,
        -4729.86767578125,
        1182.32275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555710792541504,
        -0.8314691185951233,
        0.0
      ],
      "plane_d": -2193.2998046875,
      "bbox_min": [
        -3184.8525390625,
        -4765.91552734375,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3162.9111328125,
        -4739.90283203125,
        1114.09521484375
      ],
      "bbox_max": [
        -3114.6005859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -5585.61865234375,
      "bbox_min": [
        -3162.9111328125,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3144.686279296875,
        -4732.7470703125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3323265314102173,
        -0.9431077837944031,
        0.010334725491702557
      ],
      "plane_d": -3436.677978515625,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3144.686279296875,
        -4739.0771484375,
        1190.625732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3120.0,
        -4679.7998046875,
        1114.09521484375
      ],
      "bbox_max": [
        -3114.6005859375,
        -4679.7998046875,
        1133.579345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33234429359436035,
        -0.9431581497192383,
        0.0
      ],
      "plane_d": -3424.94873046875,
      "bbox_min": [
        -3145.921875,
        -4739.90283203125,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4722.58203125,
        1188.243408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1114.09521484375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4722.58203125,
        1133.5791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9268893003463745,
        0.0,
        0.37533503770828247
      ],
      "plane_d": 2475.265625,
      "bbox_min": [
        -3128.943603515625,
        -4733.92041015625,
        1101.623779296875
      ],
      "bbox_max": [
        -3105.568603515625,
        -3941.11669921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3128.943603515625,
        -4733.92041015625,
        1101.623779296875
      ],
      "bbox_max": [
        -3116.6005859375,
        -3945.864990234375,
        1112.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33234429359436035,
        -0.9431581497192383,
        0.0
      ],
      "plane_d": -3424.94873046875,
      "bbox_min": [
        -3128.943603515625,
        -4733.92041015625,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -3947.159423828125,
        1112.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3128.2265625,
        -3950.715576171875,
        1102.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -3947.159423828125,
        1112.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3120.0,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3116.6005859375,
        -3945.864990234375,
        1110.0186767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950372576713562,
        0.0,
        -0.09950372576713562
      ],
      "plane_d": 3210.749267578125,
      "bbox_min": [
        -3121.054931640625,
        -4731.140625,
        1101.623779296875
      ],
      "bbox_max": [
        -3105.568603515625,
        -3941.11669921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3121.054931640625,
        -4731.140625,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3944.82568359375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865304172039032,
        -0.35842156410217285,
        0.3504037857055664
      ],
      "plane_d": 758.911865234375,
      "bbox_min": [
        -3121.054931640625,
        -4731.140625,
        1110.01806640625
      ],
      "bbox_max": [
        -3119.999755859375,
        -3947.159423828125,
        1114.09521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3121.054931640625,
        -3947.615478515625,
        1110.0181884765625
      ],
      "bbox_max": [
        -3119.999755859375,
        -3947.159423828125,
        1114.09521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770167350769043,
        -0.319015771150589,
        -0.5523326396942139
      ],
      "plane_d": 1637.0086669921875,
      "bbox_min": [
        -3121.054931640625,
        -4329.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4327.22119140625,
        1114.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3120.0,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3944.82568359375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3119.999755859375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -3944.82568359375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865304172039032,
        -0.35842156410217285,
        0.3504037857055664
      ],
      "plane_d": 758.911865234375,
      "bbox_min": [
        -3119.999755859375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4316.35888671875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770167350769043,
        -0.319015771150589,
        -0.5523326396942139
      ],
      "plane_d": 1637.0086669921875,
      "bbox_min": [
        -3119.999755859375,
        -4329.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4316.35888671875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865304172039032,
        -0.35842156410217285,
        0.3504037857055664
      ],
      "plane_d": 758.911865234375,
      "bbox_min": [
        -3116.6005859375,
        -4329.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3105.568603515625,
        -3941.11669921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3116.500732421875,
        -3945.646728515625,
        1102.623779296875
      ],
      "bbox_max": [
        -3106.020263671875,
        -3941.11669921875,
        1121.6236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770167350769043,
        -0.319015771150589,
        -0.5523326396942139
      ],
      "plane_d": 1637.0086669921875,
      "bbox_min": [
        -3115.50048828125,
        -4329.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -3110.536376953125,
        -4304.37451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113652110099792,
        0.0,
        0.4115986227989197
      ],
      "plane_d": -3272.40087890625,
      "bbox_min": [
        -3235.93408203125,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3644.481689453125,
        1390.294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8128610849380493,
        0.0,
        -0.5824577808380127
      ],
      "plane_d": -1853.646728515625,
      "bbox_min": [
        -3093.13330078125,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3856.597412109375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        -0.0
      ],
      "plane_d": -5154.79296875,
      "bbox_min": [
        -3084.1005859375,
        -4804.8466796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2989.13427734375,
        -3856.597412109375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3084.1005859375,
        -4733.07763671875,
        1101.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -3856.597412109375,
        1182.322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3084.1005859375,
        -3931.641845703125,
        1101.623779296875
      ],
      "bbox_max": [
        -3066.5947265625,
        -3884.224853515625,
        1151.1749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3084.1005859375,
        -3931.641845703125,
        1120.741943359375
      ],
      "bbox_max": [
        -3083.468505859375,
        -3931.36865234375,
        1123.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3084.1005859375,
        -4733.07763671875,
        1101.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4247.66796875,
        1182.322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3084.1005859375,
        -4277.24267578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4255.21337890625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3077.651611328125,
        -4269.306640625,
        1101.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4255.21337890625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -3274.530029296875,
      "bbox_min": [
        -3037.309326171875,
        -4733.07763671875,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4729.86767578125,
        1182.322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555710792541504,
        -0.8314691185951233,
        -0.0
      ],
      "plane_d": -5637.83984375,
      "bbox_min": [
        -3084.1005859375,
        -4765.91552734375,
        1101.623779296875
      ],
      "bbox_max": [
        -3015.14697265625,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -3274.530029296875,
      "bbox_min": [
        -3084.1005859375,
        -4739.90283203125,
        1115.901123046875
      ],
      "bbox_max": [
        -3037.08837890625,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3084.1005859375,
        -4739.90283203125,
        1115.901123046875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4679.7998046875,
        1187.7740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3323265016078949,
        -0.9431077241897583,
        0.010337146930396557
      ],
      "plane_d": -5497.1044921875,
      "bbox_min": [
        -3055.219970703125,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4739.1396484375,
        1187.7740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3084.1005859375,
        -4679.7998046875,
        1115.901123046875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4679.7998046875,
        1130.7037353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33234429359436035,
        -0.9431581497192383,
        -0.0
      ],
      "plane_d": -5485.4833984375,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1101.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4722.58154296875,
        1185.5716552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3079.999755859375,
        -4730.7685546875,
        1115.901123046875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4722.58154296875,
        1130.7039794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9270538687705994,
        0.0,
        0.37492841482162476
      ],
      "plane_d": -3270.30322265625,
      "bbox_min": [
        -3093.13330078125,
        -4734.37353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.76953125,
        -3893.0947265625,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3082.1005859375,
        -4734.37353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.76953125,
        -3893.0947265625,
        1112.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3079.999755859375,
        -4734.37353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.76953125,
        -3893.0947265625,
        1112.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3079.999755859375,
        -4734.37353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.76953125,
        -4268.1171875,
        1112.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33234429359436035,
        -0.9431581497192383,
        -0.0
      ],
      "plane_d": -5485.4833984375,
      "bbox_min": [
        -3079.999755859375,
        -4734.37353515625,
        1101.623779296875
      ],
      "bbox_max": [
        -3069.76953125,
        -4730.7685546875,
        1112.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3082.1005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -3921.677001953125,
        1106.818115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4271.44091796875,
        1106.8177490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3080.0,
        -4679.7998046875,
        1106.8173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950360059738159,
        -0.0,
        -0.09951574355363846
      ],
      "plane_d": -2957.171875,
      "bbox_min": [
        -3093.13330078125,
        -4731.59619140625,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -3915.11669921875,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3084.1005859375,
        -4731.59619140625,
        1101.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -3915.11669921875,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3079.999755859375,
        -4731.59619140625,
        1106.8177490234375
      ],
      "bbox_max": [
        -3077.651611328125,
        -3915.11669921875,
        1115.901123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33234429359436035,
        -0.9431581497192383,
        -0.0
      ],
      "plane_d": -5485.4833984375,
      "bbox_min": [
        -3079.999755859375,
        -4731.59619140625,
        1106.8177490234375
      ],
      "bbox_max": [
        -3077.651611328125,
        -4268.1171875,
        1115.901123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3079.999755859375,
        -4271.44091796875,
        1106.8177490234375
      ],
      "bbox_max": [
        -3077.651611328125,
        -4268.1171875,
        1115.9007568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3079.999755859375,
        -4271.43994140625,
        1112.623779296875
      ],
      "bbox_max": [
        -3077.651611328125,
        -4268.1171875,
        1115.9007568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3084.1005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -3921.67724609375,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3084.1005859375,
        -4277.24267578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -3921.67724609375,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3084.1005859375,
        -3931.641845703125,
        1115.3028564453125
      ],
      "bbox_max": [
        -3083.468505859375,
        -3931.36865234375,
        1121.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3084.1005859375,
        -4277.24267578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4269.08984375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3083.200439453125,
        -4274.4140625,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4269.08984375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.1005859375,
        -3927.546630859375,
        1115.3028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3093.13330078125,
        -4278.98388671875,
        1101.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4270.41552734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3088.165283203125,
        -4277.24267578125,
        1112.623779296875
      ],
      "bbox_max": [
        -3083.200439453125,
        -4270.41552734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3235.93408203125,
        -4739.4658203125,
        1101.623779296875
      ],
      "bbox_max": [
        -3045.2607421875,
        -3644.481689453125,
        1390.294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3172.192138671875,
        -3959.59814453125,
        1102.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3172.192138671875,
        -3959.59814453125,
        1123.0234375
      ],
      "bbox_max": [
        -3070.75439453125,
        -3895.846923828125,
        1252.9814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3172.192138671875,
        -3959.59814453125,
        1197.2989501953125
      ],
      "bbox_max": [
        -3123.158447265625,
        -3927.405029296875,
        1249.1500244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3196.34130859375,
        -4739.4658203125,
        1101.623779296875
      ],
      "bbox_max": [
        -3045.2607421875,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1247.1727294921875
      ],
      "bbox_max": [
        -3079.301025390625,
        -3919.725341796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838698506355286,
        0.0,
        0.17888544499874115
      ],
      "plane_d": -3236.50634765625,
      "bbox_min": [
        -3153.438720703125,
        -4739.4658203125,
        1101.623779296875
      ],
      "bbox_max": [
        -3045.2607421875,
        -4257.443359375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3086.670654296875,
        -4739.4658203125,
        1115.933349609375
      ],
      "bbox_max": [
        -3045.2607421875,
        -4257.443359375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3323265016078949,
        -0.9431077241897583,
        0.010337146930396557
      ],
      "plane_d": -5497.1044921875,
      "bbox_min": [
        -3079.999755859375,
        -4739.4658203125,
        1130.703857421875
      ],
      "bbox_max": [
        -3045.2607421875,
        -4257.443359375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3079.999755859375,
        -4739.4658203125,
        1130.703857421875
      ],
      "bbox_max": [
        -3045.2607421875,
        -4257.443359375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3727324903011322,
        -0.9278463125228882,
        0.013105603866279125
      ],
      "plane_d": -3274.653076171875,
      "bbox_min": [
        -3054.30859375,
        -4739.4658203125,
        1187.7740478515625
      ],
      "bbox_max": [
        -3045.2607421875,
        -4735.583984375,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -3086.670654296875,
        -4679.7998046875,
        1115.933349609375
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3085.635986328125,
        -4679.7998046875,
        1121.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3085.635986328125,
        -4277.87890625,
        1121.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3086.670654296875,
        -4277.87890625,
        1115.933349609375
      ],
      "bbox_max": [
        -3084.1005859375,
        -4274.2265625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1120.7445068359375
      ],
      "bbox_max": [
        -3114.20361328125,
        -4309.0048828125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3323265314102173,
        -0.9431077837944031,
        0.010334725491702557
      ],
      "plane_d": -3436.677978515625,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1133.5791015625
      ],
      "bbox_max": [
        -3119.999755859375,
        -4309.0048828125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526395559310913,
        -0.35317710041999817,
        0.3850606083869934
      ],
      "plane_d": 694.5632934570312,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1133.5791015625
      ],
      "bbox_max": [
        -3119.999755859375,
        -4309.0048828125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33234429359436035,
        -0.9431581497192383,
        0.0
      ],
      "plane_d": -3424.94873046875,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1133.5791015625
      ],
      "bbox_max": [
        -3119.999755859375,
        -4730.7685546875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -5585.61865234375,
      "bbox_min": [
        -3153.438720703125,
        -4739.43017578125,
        1190.625732421875
      ],
      "bbox_max": [
        -3145.69091796875,
        -4736.1064453125,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1120.7445068359375
      ],
      "bbox_max": [
        -3114.20361328125,
        -4309.0048828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526395559310913,
        -0.35317710041999817,
        0.3850606083869934
      ],
      "plane_d": 694.5632934570312,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1121.623779296875
      ],
      "bbox_max": [
        -3114.36328125,
        -4309.0048828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1121.623779296875
      ],
      "bbox_max": [
        -3114.36328125,
        -4679.7998046875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8526395559310913,
        -0.35317710041999817,
        0.3850606083869934
      ],
      "plane_d": 694.5632934570312,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770167350769043,
        -0.319015771150589,
        -0.5523326396942139
      ],
      "plane_d": 1637.0086669921875,
      "bbox_min": [
        -3114.36328125,
        -4329.19580078125,
        1101.623779296875
      ],
      "bbox_max": [
        -3087.617431640625,
        -4272.47216796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35841548442840576,
        -0.8653020858764648,
        0.35041505098342896
      ],
      "plane_d": -2980.012451171875,
      "bbox_min": [
        -3099.21826171875,
        -4281.6142578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3087.617431640625,
        -4272.47216796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3099.21826171875,
        -4281.6142578125,
        1112.623779296875
      ],
      "bbox_max": [
        -3087.617431640625,
        -4272.47216796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1113.8370361328125
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4679.7998046875,
      "bbox_min": [
        -3119.999755859375,
        -4679.7998046875,
        1121.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35317516326904297,
        -0.8526392579078674,
        0.38506290316581726
      ],
      "plane_d": -2989.61328125,
      "bbox_min": [
        -3104.5537109375,
        -4281.6142578125,
        1121.623779296875
      ],
      "bbox_max": [
        -3079.99951171875,
        -4261.5439453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31901195645332336,
        -0.7701619863510132,
        -0.5523421764373779
      ],
      "plane_d": -1690.7847900390625,
      "bbox_min": [
        -3094.654296875,
        -4281.6142578125,
        1113.8370361328125
      ],
      "bbox_max": [
        -3085.635986328125,
        -4273.115234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -3247.0,
        -5219.0,
        1035.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4920.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3247.0,
        -5219.0,
        1035.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4920.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3247.0,
        -5219.0,
        1035.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4920.0,
        1140.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -0.000656990276183933,
        0.9999998807907104
      ],
      "plane_d": -1104.8690185546875,
      "bbox_min": [
        -3116.6005859375,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3082.100341796875,
        -4920.0,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3082.100341796875,
        -4920.0,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3085.73388671875,
      "bbox_min": [
        -3085.734130859375,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8264952301979065,
        -5.569224413193297e-06,
        -0.5629439353942871
      ],
      "plane_d": 3196.833740234375,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8264952301979065,
        5.569224413193297e-06,
        -0.5629439353942871
      ],
      "plane_d": -1927.380859375,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.32747265696525574,
        -2.206629687862005e-06,
        -0.9448606371879578
      ],
      "plane_d": 2071.15283203125,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.32747265696525574,
        2.206629687862005e-06,
        -0.9448606371879578
      ],
      "plane_d": 40.844482421875,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        6.738363026670413e-06,
        0.0
      ],
      "plane_d": -3085.70068359375,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3085.73388671875,
        -4934.7685546875,
        1106.5679931640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -6.738363026670413e-06,
        0.0
      ],
      "plane_d": 3114.232421875,
      "bbox_min": [
        -3114.265869140625,
        -4976.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3097.60009765625,
        -4934.7685546875,
        1106.5679931640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3102.60009765625,
        -4951.85009765625,
        1101.623779296875
      ],
      "bbox_max": [
        -3097.60009765625,
        -4946.85009765625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3247.0,
        -5219.0,
        1035.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.11588192731142044,
        0.0,
        0.9932630062103271
      ],
      "plane_d": -1432.636962890625,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -5003.5,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1065337285399437,
        0.9943090677261353,
        0.0
      ],
      "plane_d": 4650.06201171875,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -5003.5,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1506434679031372,
        0.0,
        -0.9885882139205933
      ],
      "plane_d": 1553.9241943359375,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -5003.5,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1078.5999755859375,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1077.076171875
      ],
      "bbox_max": [
        -3237.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1077.076171875
      ],
      "bbox_max": [
        -3237.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.5,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1077.076171875
      ],
      "bbox_max": [
        -3237.0,
        -5023.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01190398819744587,
        -0.9999291896820068,
        -0.0
      ],
      "plane_d": -5041.6787109375,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -5003.5,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.5,
      "bbox_min": [
        -3247.0,
        -5023.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5023.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3025.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1040.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1083.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1040.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.5,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1083.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5204.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5219.0,
        1083.0
      ],
      "bbox_max": [
        -3065.000244140625,
        -5204.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.29828330874443054,
        -0.9544774293899536
      ],
      "plane_d": 2562.102783203125,
      "bbox_min": [
        -3195.000244140625,
        -5124.0,
        1083.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5112.80029296875,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3070.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -4976.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5144.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833810806274
      ],
      "plane_d": 2673.0732421875,
      "bbox_min": [
        -3080.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5193.5,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6363814473152161,
        0.7713745832443237
      ],
      "plane_d": -4064.55224609375,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -4976.0,
        1086.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.6363813281059265,
        -0.771374523639679
      ],
      "plane_d": 4063.915283203125,
      "bbox_min": [
        -3120.000244140625,
        -5074.24267578125,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -4976.0,
        1086.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1083.5001220703125,
      "bbox_min": [
        -3110.000244140625,
        -5074.24267578125,
        1083.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5074.24267578125,
        1083.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5074.24267578125,
        1083.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5072.63623046875,
        1083.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3070.515869140625,
        -4991.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -4976.0,
        1083.3143310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3070.515869140625,
        -4991.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -4991.0,
        1083.3143310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3094.545654296875,
        -5143.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1086.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.5,
      "bbox_min": [
        -3094.545654296875,
        -5143.0,
        1083.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34425464272499084,
        0.0,
        0.9388763308525085
      ],
      "plane_d": -2082.11474609375,
      "bbox_min": [
        -3087.7275390625,
        -5143.0,
        1085.5
      ],
      "bbox_max": [
        -3085.000244140625,
        -5134.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34425464272499084,
        0.0,
        -0.9388763308525085
      ],
      "plane_d": 2081.17578125,
      "bbox_min": [
        -3094.545654296875,
        -5143.0,
        1083.0
      ],
      "bbox_max": [
        -3085.000244140625,
        -5134.0,
        1085.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34425464272499084,
        0.0,
        0.9388763308525085
      ],
      "plane_d": -2082.11474609375,
      "bbox_min": [
        -3094.545654296875,
        -5143.0,
        1083.0
      ],
      "bbox_max": [
        -3087.7275390625,
        -5134.0,
        1085.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5204628705978394,
        0.0,
        -0.8538843989372253
      ],
      "plane_d": 2519.7724609375,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4976.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833810806274
      ],
      "plane_d": 2673.0732421875,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4991.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5204.0,
        1083.0
      ],
      "bbox_max": [
        -3065.000244140625,
        -5193.9150390625,
        1086.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3070.000244140625,
        -4991.0,
        1083.0
      ],
      "bbox_max": [
        -3058.867431640625,
        -4991.0,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833810806274
      ],
      "plane_d": 2673.0732421875,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1083.314208984375
      ],
      "bbox_max": [
        -3065.000244140625,
        -5193.5,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5204.0,
        1086.361572265625
      ],
      "bbox_max": [
        -3065.000244140625,
        -5193.5,
        1086.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1119.9998779296875,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1098.0,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1120.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.5999755859375,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1120.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5004.0,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3145.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3130.000244140625,
      "bbox_min": [
        -3145.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3145.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3140.000244140625,
      "bbox_min": [
        -3145.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3140.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3140.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3140.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3145.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3145.000244140625,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5105.0,
      "bbox_min": [
        -3145.000244140625,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49301260709762573,
        0.0,
        0.8700222969055176
      ],
      "plane_d": -2503.92431640625,
      "bbox_min": [
        -3141.1767578125,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3141.1767578125,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5,
      "bbox_min": [
        -3135.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3130.000244140625,
        -5105.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3080.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3107.500244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5185.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3100.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5204.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3107.500244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1100.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3120.000244140625,
        -5069.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3110.000244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5104.0,
      "bbox_min": [
        -3130.000244140625,
        -5104.0,
        1100.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3130.000244140625,
        -5019.0,
        1100.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5204.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3130.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3130.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3125.000244140625,
      "bbox_min": [
        -3125.000244140625,
        -5185.0,
        1100.5
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3092.500244140625,
        -5054.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5144.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5204.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1100.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5144.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5004.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5185.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3100.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5204.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5204.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3107.500244140625,
        -5069.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5143.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5144.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3120.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5094.0,
      "bbox_min": [
        -3130.000244140625,
        -5104.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5104.0,
      "bbox_min": [
        -3130.000244140625,
        -5104.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3130.000244140625,
        -5019.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5204.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3130.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3130.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3125.000244140625,
      "bbox_min": [
        -3125.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5070.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5143.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3120.000244140625,
        -5019.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5204.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5185.0,
        1098.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5184.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3092.500244140625,
        -5069.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3092.500244140625,
        -5054.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5143.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5204.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5143.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5144.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1100.5,
      "bbox_min": [
        -3080.000244140625,
        -5169.728515625,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5162.27783203125,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3070.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.0,
      "bbox_min": [
        -3080.000244140625,
        -5069.0,
        1100.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3080.000244140625,
        -5054.0,
        1100.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5143.0,
        1100.5
      ],
      "bbox_max": [
        -3045.000244140625,
        -5125.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3045.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5143.0,
        1100.5
      ],
      "bbox_max": [
        -3045.000244140625,
        -5125.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3060.000244140625,
        -5143.0,
        1100.5
      ],
      "bbox_max": [
        -3045.000244140625,
        -5134.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5134.0,
      "bbox_min": [
        -3060.000244140625,
        -5134.0,
        1100.5
      ],
      "bbox_max": [
        -3045.000244140625,
        -5134.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3070.000244140625,
        -5114.0,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3040.000244140625,
        -5114.0,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5114.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3070.000244140625,
        -5074.0,
        1100.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.0,
      "bbox_min": [
        -3070.000244140625,
        -5074.0,
        1100.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.8944272398948669,
        -0.0
      ],
      "plane_d": -5897.853515625,
      "bbox_min": [
        -3050.000244140625,
        -5074.0,
        1100.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5069.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 3156.433349609375,
      "bbox_min": [
        -3050.000244140625,
        -5054.0,
        1100.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5159.0,
      "bbox_min": [
        -3080.000244140625,
        -5162.27783203125,
        1100.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5159.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3181227743625641,
        0.9480495452880859
      ],
      "plane_d": -2685.566650390625,
      "bbox_min": [
        -3080.000244140625,
        -5162.27783203125,
        1100.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5162.27783203125,
        1100.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5169.728515625,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3070.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1100.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5070.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5143.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3080.000244140625,
        -5054.0,
        1098.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3035.000244140625,
        -5124.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3035.000244140625,
      "bbox_min": [
        -3035.000244140625,
        -5143.0,
        1098.0
      ],
      "bbox_max": [
        -3035.000244140625,
        -5124.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3070.000244140625,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1100.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3040.000244140625,
        -5114.0,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5114.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3070.000244140625,
        -5074.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.8944272398948669,
        -0.0
      ],
      "plane_d": -5897.853515625,
      "bbox_min": [
        -3050.000244140625,
        -5074.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -5069.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 3156.433349609375,
      "bbox_min": [
        -3050.000244140625,
        -5054.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5159.0,
      "bbox_min": [
        -3080.000244140625,
        -5169.728515625,
        1098.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5159.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5169.728515625,
        1098.0
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1100.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3080.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3100.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3107.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3107.500244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3107.500244140625,
        -5069.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5140.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5140.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3107.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3092.500244140625,
        -5144.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3119.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3119.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3119.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3120.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3120.000244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3119.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3119.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5104.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5094.0,
      "bbox_min": [
        -3130.000244140625,
        -5094.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3130.000244140625,
        -5019.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3130.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3130.000244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3130.000244140625,
        -5184.0,
        1101.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3116.000244140625,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3119.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3119.000244140625,
        -5019.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3119.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3119.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3119.000244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3119.000244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3116.000244140625,
        -5185.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3116.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3116.000244140625,
        -5140.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3116.000244140625,
        -5069.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3116.000244140625,
        -5019.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5140.0,
      "bbox_min": [
        -3116.000244140625,
        -5140.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5070.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3116.000244140625,
        -5079.0,
        1101.5
      ],
      "bbox_max": [
        -3114.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3116.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3116.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3116.000244140625,
        -5185.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3116.000244140625,
        -5184.0,
        1101.5
      ],
      "bbox_max": [
        -3107.500244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3090.000244140625,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3089.000244140625,
      "bbox_min": [
        -3090.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3090.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3090.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3090.000244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3090.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3090.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3090.000244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3089.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3089.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3089.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3089.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3089.000244140625,
        -5184.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.0,
      "bbox_min": [
        -3089.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3089.000244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3089.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3085.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3085.000244140625,
      "bbox_min": [
        -3085.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3085.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3092.500244140625,
        -5069.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3092.500244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3092.500244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5140.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3092.500244140625,
        -5144.0,
        1101.5
      ],
      "bbox_max": [
        -3090.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5159.2978515625,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3070.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3026.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5125.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3026.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3026.000244140625,
      "bbox_min": [
        -3026.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3026.000244140625,
        -5125.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3070.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5004.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3040.000244140625,
        -5114.0,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3070.000244140625,
        -5074.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.8944272398948669,
        -0.0
      ],
      "plane_d": -5897.853515625,
      "bbox_min": [
        -3050.000244140625,
        -5074.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.8944272398948669,
        0.0
      ],
      "plane_d": 3156.433349609375,
      "bbox_min": [
        -3050.000244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -5049.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.0,
      "bbox_min": [
        -3080.000244140625,
        -5054.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5054.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 3517.4609375,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1101.5
      ],
      "bbox_max": [
        -3075.303466796875,
        -5081.19677734375,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4789.82177734375,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1101.5
      ],
      "bbox_max": [
        -3075.303466796875,
        -5086.5,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3075.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3075.000244140625,
      "bbox_min": [
        -3075.000244140625,
        -5070.0,
        1101.5
      ],
      "bbox_max": [
        -3075.000244140625,
        -5069.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4795.56201171875,
      "bbox_min": [
        -3077.500244140625,
        -5109.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -890.8753662109375,
      "bbox_min": [
        -3077.500244140625,
        -5109.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        0.9239028692245483,
        0.0
      ],
      "plane_d": 3531.69580078125,
      "bbox_min": [
        -3075.303466796875,
        -5109.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        -0.9239028692245483,
        -0.0
      ],
      "plane_d": -5894.884765625,
      "bbox_min": [
        -3075.303466796875,
        -5109.0,
        1101.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5106.80322265625,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5159.0,
      "bbox_min": [
        -3080.000244140625,
        -5159.2978515625,
        1101.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3065.000244140625,
        -5159.2978515625,
        1101.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3145.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.3000928461551666,
        0.9539099931716919
      ],
      "plane_d": -2574.09912109375,
      "bbox_min": [
        -3195.000244140625,
        -5126.0,
        1098.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5076.00146484375,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3195.000244140625,
        -5126.0,
        1098.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5124.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5126.0,
      "bbox_min": [
        -3195.000244140625,
        -5126.0,
        1098.0
      ],
      "bbox_max": [
        -3180.000244140625,
        -5126.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3179.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3179.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3180.000244140625,
        -5019.0,
        1098.0
      ],
      "bbox_max": [
        -3179.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3161.000244140625,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1101.5,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1101.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3161.000244140625,
        -5019.0,
        1101.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5146.0,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3161.000244140625,
        -5104.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5019.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3161.000244140625,
        -5104.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5162.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5162.0,
      "bbox_min": [
        -3161.000244140625,
        -5162.0,
        1098.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5162.0,
        1101.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5134.0,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3161.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3179.000244140625,
        -5104.0,
        1098.0
      ],
      "bbox_max": [
        -3161.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3179.000244140625,
        -5019.0,
        1098.0
      ],
      "bbox_max": [
        -3161.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3161.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5170.0,
      "bbox_min": [
        -3179.000244140625,
        -5170.0,
        1098.0
      ],
      "bbox_max": [
        -3161.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -5104.99951171875,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3145.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3160.000244140625,
        -5019.0,
        1098.0
      ],
      "bbox_max": [
        -3145.000244140625,
        -5019.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1098.0
      ],
      "bbox_max": [
        -3145.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1098.0
      ],
      "bbox_max": [
        -3145.000244140625,
        -5184.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3120.000244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3045.906494140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -4991.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3045.906494140625,
        -4991.0,
        1098.0
      ],
      "bbox_max": [
        -3040.000244140625,
        -4991.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3107.500244140625,
      "bbox_min": [
        -3120.000244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3080.0,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3092.500244140625,
        -5004.0,
        1098.0
      ],
      "bbox_max": [
        -3080.0,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5571180582046509,
        -0.8304333686828613,
        0.0
      ],
      "plane_d": -2422.2939453125,
      "bbox_min": [
        -3092.500244140625,
        -4991.58837890625,
        1098.0
      ],
      "bbox_max": [
        -3080.0,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584196209907532,
        -0.28536278009414673,
        -6.499743176391348e-05
      ],
      "plane_d": 1532.0389404296875,
      "bbox_min": [
        -3082.6796875,
        -4985.0,
        1098.0
      ],
      "bbox_max": [
        -3080.0,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5571180582046509,
        -0.8304333686828613,
        -0.0
      ],
      "plane_d": -5876.42626953125,
      "bbox_min": [
        -3120.000244140625,
        -4991.58837890625,
        1098.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9584338068962097,
        -0.28531500697135925,
        -0.0
      ],
      "plane_d": -4410.041015625,
      "bbox_min": [
        -3120.000244140625,
        -4985.0,
        1098.0
      ],
      "bbox_max": [
        -3117.32080078125,
        -4976.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1110.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3180.000244140625,
        -5104.0,
        1110.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3179.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3179.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3180.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3179.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3161.000244140625,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3161.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3161.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3160.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5134.0,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3161.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3179.000244140625,
        -5104.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3161.000244140625,
        -5104.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3179.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3161.000244140625,
        -5170.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5170.0,
      "bbox_min": [
        -3179.000244140625,
        -5170.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3161.000244140625,
        -5170.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3195.000244140625,
        -5126.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3180.000244140625,
        -5124.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5126.0,
      "bbox_min": [
        -3195.000244140625,
        -5126.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3180.000244140625,
        -5126.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3070.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3070.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5124.0,
        1115.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5125.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5125.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3026.000244140625,
      "bbox_min": [
        -3026.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3025.000244140625,
        -5125.0,
        1115.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3026.000244140625,
        -5139.0,
        1104.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5129.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.5,
      "bbox_min": [
        -3026.000244140625,
        -5139.0,
        1104.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5129.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5139.0,
      "bbox_min": [
        -3026.000244140625,
        -5139.0,
        1104.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5129.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5129.0,
      "bbox_min": [
        -3026.000244140625,
        -5129.0,
        1104.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5129.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3080.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3160.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3140.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1115.0
      ],
      "bbox_max": [
        -3119.000244140625,
        -5144.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3119.000244140625,
        -5144.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3120.000244140625,
        -5114.0,
        1106.0
      ],
      "bbox_max": [
        -3119.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3120.000244140625,
        -5114.0,
        1106.0
      ],
      "bbox_max": [
        -3119.000244140625,
        -5114.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3160.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5105.0,
      "bbox_min": [
        -3160.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3130.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5105.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.0,
      "bbox_min": [
        -3130.000244140625,
        -5105.0,
        1112.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3119.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3085.000244140625,
      "bbox_min": [
        -3085.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -3085.000244140625,
        -5070.0,
        1115.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1114.9998779296875,
      "bbox_min": [
        -3119.000244140625,
        -5144.0,
        1106.0
      ],
      "bbox_max": [
        -3090.000244140625,
        -5143.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        -3119.000244140625,
        -5144.0,
        1106.0
      ],
      "bbox_max": [
        -3090.000244140625,
        -5143.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3090.000244140625,
      "bbox_min": [
        -3090.000244140625,
        -5144.0,
        1106.0
      ],
      "bbox_max": [
        -3090.000244140625,
        -5143.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3090.000244140625,
      "bbox_min": [
        -3119.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5070.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3089.000244140625,
      "bbox_min": [
        -3090.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5114.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3090.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3089.000244140625,
        -5114.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5115.0,
      "bbox_min": [
        -3089.000244140625,
        -5115.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5115.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1932.575439453125,
      "bbox_min": [
        -3119.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3090.000244140625,
        -5070.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5140.0,
      "bbox_min": [
        -3116.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3090.000244140625,
        -5136.400390625,
        1104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3116.000244140625,
      "bbox_min": [
        -3116.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3116.000244140625,
        -5136.400390625,
        1104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 809.8623657226562,
      "bbox_min": [
        -3119.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3114.000244140625,
        -5070.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3116.000244140625,
      "bbox_min": [
        -3119.000244140625,
        -5140.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3114.000244140625,
        -5070.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3119.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3116.000244140625,
        -5079.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3119.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3116.000244140625,
        -5079.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3114.000244140625,
      "bbox_min": [
        -3116.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3114.000244140625,
        -5070.0,
        1104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3116.000244140625,
        -5079.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3114.000244140625,
        -5079.0,
        1104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3114.000244140625,
      "bbox_min": [
        -3119.000244140625,
        -5079.0,
        1102.666748046875
      ],
      "bbox_max": [
        -3114.000244140625,
        -5070.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3119.000244140625,
        -5079.0,
        1102.666748046875
      ],
      "bbox_max": [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5184.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3119.000244140625,
        -5204.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3080.000244140625,
        -5185.0,
        1120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3119.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3119.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5203.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 3517.4609375,
      "bbox_min": [
        -3080.000244140625,
        -5109.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3077.500244140625,
        -5109.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5081.19677734375,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -890.8753662109375,
      "bbox_min": [
        -3077.500244140625,
        -5109.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5086.5,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        0.9239028692245483,
        0.0
      ],
      "plane_d": 3531.69580078125,
      "bbox_min": [
        -3075.303466796875,
        -5109.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5092.44677734375,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        -0.9239028692245483,
        -0.0
      ],
      "plane_d": -5894.884765625,
      "bbox_min": [
        -3075.303466796875,
        -5109.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5106.80322265625,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827725350856781,
        -0.92384272813797,
        -1.288843122893013e-05
      ],
      "plane_d": -5881.15234375,
      "bbox_min": [
        -3073.75,
        -5094.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5092.44677734375,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4789.82177734375,
      "bbox_min": [
        -3077.500244140625,
        -5092.44677734375,
        1101.5999755859375
      ],
      "bbox_max": [
        -3073.75,
        -5086.5,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827725350856781,
        -0.92384272813797,
        -1.288843122893013e-05
      ],
      "plane_d": -5881.15234375,
      "bbox_min": [
        -3075.303466796875,
        -5092.44677734375,
        1101.5999755859375
      ],
      "bbox_max": [
        -3073.75,
        -5091.80322265625,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3080.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3080.000244140625,
        -5070.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -3080.000244140625,
        -5070.0,
        1115.0
      ],
      "bbox_max": [
        -3075.000244140625,
        -5069.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3080.000244140625,
        -5143.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5143.0,
        1120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5204.0,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3080.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5164.0,
      "bbox_min": [
        -3195.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5164.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3140.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5164.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1091.4998779296875,
      "bbox_min": [
        -3140.000244140625,
        -5164.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3140.000244140625,
        -5143.0,
        1086.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1091.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5114.0,
        1086.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1091.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1086.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5114.0,
        1091.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3140.000244140625,
        -5154.0,
        1091.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1096.4998779296875,
      "bbox_min": [
        -3140.000244140625,
        -5154.0,
        1091.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3130.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5154.0,
        1091.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3130.000244140625,
        -5143.0,
        1091.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3120.000244140625,
      "bbox_min": [
        -3130.000244140625,
        -5143.0,
        1091.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1096.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3130.000244140625,
        -5114.0,
        1091.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5114.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3140.000244140625,
        -5114.0,
        1091.5
      ],
      "bbox_max": [
        -3130.000244140625,
        -5114.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3140.000244140625,
        -5144.0,
        1096.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3140.000244140625,
        -5144.0,
        1096.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1096.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5143.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5143.0,
        1096.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5104.0,
        1098.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3140.000244140625,
        -5114.0,
        1096.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5114.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5164.0,
        1086.5
      ],
      "bbox_max": [
        -3140.000244140625,
        -5105.0,
        1098.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5160.0,
      "bbox_min": [
        -3180.000244140625,
        -5160.0,
        1086.5
      ],
      "bbox_max": [
        -3179.000244140625,
        -5160.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3161.000244140625,
      "bbox_min": [
        -3179.000244140625,
        -5164.0,
        1086.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5134.0,
        1098.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5162.0,
      "bbox_min": [
        -3161.000244140625,
        -5162.0,
        1089.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5146.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5146.0,
      "bbox_min": [
        -3161.000244140625,
        -5146.0,
        1089.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5146.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5134.0,
      "bbox_min": [
        -3179.000244140625,
        -5134.0,
        1086.5
      ],
      "bbox_max": [
        -3161.000244140625,
        -5134.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -5104.99951171875,
      "bbox_min": [
        -3160.000244140625,
        -5124.0,
        1086.5
      ],
      "bbox_max": [
        -3140.000244140625,
        -5105.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3160.000244140625,
        -5124.0,
        1086.5
      ],
      "bbox_max": [
        -3140.000244140625,
        -5105.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        -3160.000244140625,
        -5114.0,
        1093.0
      ],
      "bbox_max": [
        -3150.000244140625,
        -5105.0,
        1093.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5449883937835693,
        0.8384436964988708
      ],
      "plane_d": -3703.489501953125,
      "bbox_min": [
        -3160.000244140625,
        -5124.0,
        1086.5
      ],
      "bbox_max": [
        -3150.000244140625,
        -5114.0,
        1093.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3150.000244140625,
      "bbox_min": [
        -3150.000244140625,
        -5124.0,
        1086.5
      ],
      "bbox_max": [
        -3150.000244140625,
        -5114.0,
        1093.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3000928461551666,
        0.9539099931716919
      ],
      "plane_d": -2574.09912109375,
      "bbox_min": [
        -3195.000244140625,
        -5124.0,
        1086.5
      ],
      "bbox_max": [
        -3180.000244140625,
        -5104.0,
        1092.7918701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.29828330874443054,
        -0.9544774293899536
      ],
      "plane_d": 2562.102783203125,
      "bbox_min": [
        -3195.000244140625,
        -5112.80029296875,
        1086.5
      ],
      "bbox_max": [
        -3180.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3180.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5164.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3180.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5164.0,
        1098.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5185.0,
      "bbox_min": [
        -3140.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5184.0,
        1098.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1089.5,
      "bbox_min": [
        -3125.000244140625,
        -5185.0,
        1089.5
      ],
      "bbox_max": [
        -3110.000244140625,
        -5184.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3110.000244140625,
      "bbox_min": [
        -3125.000244140625,
        -5185.0,
        1089.5
      ],
      "bbox_max": [
        -3110.000244140625,
        -5184.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3125.000244140625,
      "bbox_min": [
        -3125.000244140625,
        -5185.0,
        1089.5
      ],
      "bbox_max": [
        -3125.000244140625,
        -5184.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5203.0,
      "bbox_min": [
        -3140.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5203.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5203.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5203.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5203.0,
        1086.5
      ],
      "bbox_max": [
        -3100.000244140625,
        -5185.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3180.000244140625,
        -5184.0,
        1086.5
      ],
      "bbox_max": [
        -3160.000244140625,
        -5164.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5170.0,
      "bbox_min": [
        -3180.000244140625,
        -5170.0,
        1086.5
      ],
      "bbox_max": [
        -3161.000244140625,
        -5164.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3161.000244140625,
      "bbox_min": [
        -3161.000244140625,
        -5170.0,
        1086.5
      ],
      "bbox_max": [
        -3161.000244140625,
        -5164.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3195.000244140625,
        -5104.0,
        1086.5
      ],
      "bbox_max": [
        -3080.000244140625,
        -5069.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5070.0,
        1086.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5069.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5104.0,
        1086.5
      ],
      "bbox_max": [
        -3120.000244140625,
        -5070.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.29828330874443054,
        -0.9544774293899536
      ],
      "plane_d": 2562.102783203125,
      "bbox_min": [
        -3195.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      "bbox_max": [
        -3180.000244140625,
        -5076.00146484375,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3180.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5104.0,
        1089.2501220703125
      ],
      "bbox_max": [
        -3180.000244140625,
        -5076.00146484375,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3000928461551666,
        0.9539099931716919
      ],
      "plane_d": -2574.09912109375,
      "bbox_min": [
        -3195.000244140625,
        -5104.0,
        1092.7918701171875
      ],
      "bbox_max": [
        -3180.000244140625,
        -5087.44482421875,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3070.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833810806274
      ],
      "plane_d": 2673.0732421875,
      "bbox_min": [
        -3080.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5069.0,
      "bbox_min": [
        -3080.000244140625,
        -5069.0,
        1086.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5069.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1086.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5144.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3070.000244140625,
        -5143.0,
        1086.5
      ],
      "bbox_max": [
        -3035.000244140625,
        -5124.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3035.000244140625,
      "bbox_min": [
        -3035.000244140625,
        -5143.0,
        1086.5
      ],
      "bbox_max": [
        -3035.000244140625,
        -5124.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.000244140625,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3162277638912201,
        -0.9486833810806274
      ],
      "plane_d": 2673.0732421875,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5159.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3181227743625641,
        0.9480495452880859
      ],
      "plane_d": -2685.566650390625,
      "bbox_min": [
        -3070.000244140625,
        -5204.0,
        1086.5
      ],
      "bbox_max": [
        -3065.000244140625,
        -5169.728515625,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3064.773681640625,
        -4991.0,
        1086.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5204628705978394,
        0.0,
        -0.8538843989372253
      ],
      "plane_d": 2519.7724609375,
      "bbox_min": [
        -3064.773681640625,
        -4991.0,
        1086.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -4976.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3064.773681640625,
        -4991.0,
        1086.5
      ],
      "bbox_max": [
        -3040.000244140625,
        -4991.0,
        1098.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1120.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1120.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3070.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1120.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3070.000244140625,
        -5124.0,
        1120.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 3175.65869140625,
      "bbox_min": [
        -3070.000244140625,
        -5124.0,
        1120.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 4838.9267578125,
      "bbox_min": [
        -3070.000244140625,
        -5069.0,
        1120.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5059.0,
      "bbox_min": [
        -3070.000244140625,
        -5059.0,
        1135.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3070.000244140625,
        -5124.0,
        1120.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5124.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3060.000244140625,
        -5124.0,
        1120.0
      ],
      "bbox_max": [
        -3025.000244140625,
        -5124.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 4838.9267578125,
      "bbox_min": [
        -3120.000244140625,
        -5069.0,
        1120.0
      ],
      "bbox_max": [
        -3119.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5059.0,
      "bbox_min": [
        -3120.000244140625,
        -5059.0,
        1135.0
      ],
      "bbox_max": [
        -3119.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5070.0,
      "bbox_min": [
        -3119.000244140625,
        -5143.0,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 4838.9267578125,
      "bbox_min": [
        -3119.000244140625,
        -5069.0,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5059.0,
      "bbox_min": [
        -3119.000244140625,
        -5059.0,
        1135.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5059.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3119.000244140625,
        -5143.0,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5070.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.0,
      "bbox_min": [
        -3119.000244140625,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5070.0,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5070.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8384436964988708,
        0.0,
        -0.5449883937835693
      ],
      "plane_d": 3224.02587890625,
      "bbox_min": [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      "bbox_max": [
        -3107.500244140625,
        -5070.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3114.000244140625,
      "bbox_min": [
        -3114.000244140625,
        -5079.0,
        1120.0
      ],
      "bbox_max": [
        -3114.000244140625,
        -5070.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827725350856781,
        -0.92384272813797,
        -1.288843122893013e-05
      ],
      "plane_d": -5881.15234375,
      "bbox_min": [
        -3077.500244140625,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 3517.4609375,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5079.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -896.6158447265625,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1120.0
      ],
      "bbox_max": [
        -3075.303466796875,
        -5081.19677734375,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4789.82177734375,
      "bbox_min": [
        -3077.500244140625,
        -5091.80322265625,
        1120.0
      ],
      "bbox_max": [
        -3075.303466796875,
        -5086.5,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4795.56201171875,
      "bbox_min": [
        -3077.500244140625,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -890.8753662109375,
      "bbox_min": [
        -3077.500244140625,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        0.9239028692245483,
        0.0
      ],
      "plane_d": 3531.69580078125,
      "bbox_min": [
        -3075.303466796875,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5094.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826272785663605,
        -0.9239028692245483,
        -0.0
      ],
      "plane_d": -5894.884765625,
      "bbox_min": [
        -3075.303466796875,
        -5108.99951171875,
        1120.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5106.80322265625,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5019.0,
      "bbox_min": [
        -3195.000244140625,
        -5147.5,
        1040.0
      ],
      "bbox_max": [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1066.0,
      "bbox_min": [
        -3195.000244140625,
        -5019.0,
        1066.0
      ],
      "bbox_max": [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.5999755859375,
      "bbox_min": [
        -3195.000244140625,
        -5019.0,
        1066.0
      ],
      "bbox_max": [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5004.0,
      "bbox_min": [
        -3195.000244140625,
        -5019.0,
        1066.0
      ],
      "bbox_max": [
        -3086.593994140625,
        -4976.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3092.500244140625,
        -5019.0,
        1066.0
      ],
      "bbox_max": [
        -3092.500244140625,
        -5004.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3107.500244140625,
      "bbox_min": [
        -3107.500244140625,
        -5004.0,
        1066.0
      ],
      "bbox_max": [
        -3086.593994140625,
        -4976.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5204628705978394,
        0.0,
        -0.8538843989372253
      ],
      "plane_d": 2519.7724609375,
      "bbox_min": [
        -3092.500244140625,
        -5004.0,
        1066.0
      ],
      "bbox_max": [
        -3086.593994140625,
        -4976.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3092.500244140625,
      "bbox_min": [
        -3092.500244140625,
        -5004.0,
        1066.0
      ],
      "bbox_max": [
        -3086.593994140625,
        -4991.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3092.500244140625,
        -4991.0,
        1066.0
      ],
      "bbox_max": [
        -3086.593994140625,
        -4991.0,
        1069.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5204628705978394,
        0.0,
        0.8538843989372253
      ],
      "plane_d": -2522.84619140625,
      "bbox_min": [
        -3092.500244140625,
        -4991.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5204628705978394,
        0.0,
        -0.8538843989372253
      ],
      "plane_d": 2519.7724609375,
      "bbox_min": [
        -3092.500244140625,
        -4991.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -3064.609619140625,
        -4976.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4991.0,
      "bbox_min": [
        -3092.500244140625,
        -4991.0,
        1069.5999755859375
      ],
      "bbox_max": [
        -3064.609619140625,
        -4991.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3124.500244140625,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1040.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3065.500244140625,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1040.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1069.9998779296875,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1040.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5147.5,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1070.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1070.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.0,
      "bbox_min": [
        -3120.000244140625,
        -5147.5,
        1070.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.60009765625,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1070.0
      ],
      "bbox_max": [
        -3065.500244140625,
        -5079.60009765625,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3070.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1070.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5091.39990234375,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1070.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363866329193115,
        -0.7713702321052551
      ],
      "plane_d": 4063.937744140625,
      "bbox_min": [
        -3120.000244140625,
        -5089.0,
        1070.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5086.57568359375,
        1072.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1070.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5119.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1070.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5119.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5913637280464172,
        0.8064050674438477
      ],
      "plane_d": 2164.33740234375,
      "bbox_min": [
        -3120.000244140625,
        -5123.0908203125,
        1070.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5119.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5913627743721008,
        -0.806405782699585
      ],
      "plane_d": -2165.13818359375,
      "bbox_min": [
        -3120.000244140625,
        -5123.0908203125,
        1070.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5119.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5123.0908203125,
        1070.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5119.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3070.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5143.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3120.000244140625,
        -5144.0,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5144.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5091.39990234375,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6306912302970886,
        0.7760339975357056
      ],
      "plane_d": -4043.7861328125,
      "bbox_min": [
        -3120.000244140625,
        -5091.39990234375,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6363866329193115,
        -0.7713702321052551
      ],
      "plane_d": 4063.937744140625,
      "bbox_min": [
        -3120.000244140625,
        -5088.939453125,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.2421875,
        1083.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1075.0,
      "bbox_min": [
        -3120.000244140625,
        -5088.939453125,
        1075.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.24267578125,
        1083.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6363813281059265,
        0.7713746428489685
      ],
      "plane_d": -4064.5517578125,
      "bbox_min": [
        -3120.000244140625,
        -5083.939453125,
        1075.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5073.24267578125,
        1083.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5083.939453125,
        1075.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5073.24267578125,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5083.939453125,
        1075.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5073.24267578125,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.636419951915741,
        0.7713428735733032
      ],
      "plane_d": -4069.169189453125,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1072.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5091.39990234375,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5,
      "bbox_min": [
        -3120.000244140625,
        -5093.9697265625,
        1072.5
      ],
      "bbox_max": [
        -3070.000244140625,
        -5091.39990234375,
        1073.0003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1073.0003662109375,
      "bbox_min": [
        -3120.000244140625,
        -5093.36328125,
        1073.0003662109375
      ],
      "bbox_max": [
        -3070.000244140625,
        -5091.39990234375,
        1073.0003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1072.0
      ],
      "bbox_max": [
        -3091.818359375,
        -5121.72705078125,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1081.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1080.0
      ],
      "bbox_max": [
        -3091.818359375,
        -5132.63623046875,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3120.000244140625,
        -5143.0,
        1080.0
      ],
      "bbox_max": [
        -3097.27294921875,
        -5132.63623046875,
        1081.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.34425464272499084,
        0.0,
        -0.9388763308525085
      ],
      "plane_d": 2081.17578125,
      "bbox_min": [
        -3100.000244140625,
        -5143.0,
        1080.0
      ],
      "bbox_max": [
        -3097.27294921875,
        -5134.0,
        1081.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5913637280464172,
        0.8064050674438477
      ],
      "plane_d": 2164.33740234375,
      "bbox_min": [
        -3120.000244140625,
        -5134.0,
        1080.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5132.63623046875,
        1081.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5134.0,
        1080.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5132.63623046875,
        1081.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34425464272499084,
        0.0,
        -0.9388763308525085
      ],
      "plane_d": 2081.17578125,
      "bbox_min": [
        -3100.000244140625,
        -5143.0,
        1081.0
      ],
      "bbox_max": [
        -3091.818359375,
        -5134.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34425464272499084,
        0.0,
        0.9388763308525085
      ],
      "plane_d": -2082.11474609375,
      "bbox_min": [
        -3100.000244140625,
        -5143.0,
        1081.0
      ],
      "bbox_max": [
        -3091.818359375,
        -5134.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3100.000244140625,
        -5134.0,
        1081.0
      ],
      "bbox_max": [
        -3091.818359375,
        -5134.0,
        1083.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5913637280464172,
        0.8064050674438477
      ],
      "plane_d": 2164.33740234375,
      "bbox_min": [
        -3120.000244140625,
        -5134.0,
        1072.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5121.72705078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5913627743721008,
        -0.806405782699585
      ],
      "plane_d": -2165.13818359375,
      "bbox_min": [
        -3120.000244140625,
        -5134.0,
        1072.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5121.72705078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3110.000244140625,
      "bbox_min": [
        -3110.000244140625,
        -5134.0,
        1072.0
      ],
      "bbox_max": [
        -3110.000244140625,
        -5121.72705078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.0,
      "bbox_min": [
        -3124.500244140625,
        -5147.5,
        1070.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5079.60009765625,
        1072.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.60009765625,
      "bbox_min": [
        -3124.500244140625,
        -5079.60009765625,
        1070.0
      ],
      "bbox_max": [
        -3120.000244140625,
        -5079.60009765625,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3070.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5114.0,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1435.427001953125,
      "bbox_min": [
        -3100.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5114.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -3100.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5114.0,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5113.99951171875,
      "bbox_min": [
        -3100.000244140625,
        -5144.0,
        1060.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5114.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3100.000244140625,
        -5144.0,
        1060.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1050.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5134.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5134.0,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3080.000244140625,
        -5144.0,
        1040.0
      ],
      "bbox_max": [
        -3070.000244140625,
        -5144.0,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1079.9998779296875,
      "bbox_min": [
        -3025.000244140625,
        -5159.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1059.9998779296875,
      "bbox_min": [
        -3010.000244140625,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3010.000244140625,
      "bbox_min": [
        -3010.000244140625,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.0,
      "bbox_min": [
        -3010.000244140625,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3004.734375,
      "bbox_min": [
        -3010.000244140625,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3317185044288635,
        -0.0,
        0.9433784484863281
      ],
      "plane_d": -6.55694580078125,
      "bbox_min": [
        -3010.000244140625,
        -5086.6328125,
        1060.0
      ],
      "bbox_max": [
        -3004.734375,
        -5041.3671875,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3010.000244140625,
        -5086.6328125,
        1060.0
      ],
      "bbox_max": [
        -3004.734375,
        -5041.3671875,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        -0.8944272994995117,
        -0.0
      ],
      "plane_d": -5893.3818359375,
      "bbox_min": [
        -3010.000244140625,
        -5086.6328125,
        1060.0
      ],
      "bbox_max": [
        -3004.734375,
        -5084.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15121209621429443,
        -0.2952600419521332,
        0.9433750510215759
      ],
      "plane_d": -2039.136474609375,
      "bbox_min": [
        -3009.00048828125,
        -5086.6328125,
        1063.5
      ],
      "bbox_max": [
        -3004.734375,
        -5041.3671875,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        -0.8944272994995117,
        -0.0
      ],
      "plane_d": -5893.3818359375,
      "bbox_min": [
        -3009.00048828125,
        -5086.6328125,
        1063.5
      ],
      "bbox_max": [
        -3004.734375,
        -5084.5,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1065.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.11514623463153839,
        -0.26358821988105774,
        0.9577382206916809
      ],
      "plane_d": -2002.928955078125,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5035.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4003121852874756,
        -0.9163788557052612,
        0.0
      ],
      "plane_d": -3422.231201171875,
      "bbox_min": [
        -3004.734375,
        -5047.10791015625,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5035.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        -0.9037274122238159,
        0.0
      ],
      "plane_d": -3270.22314453125,
      "bbox_min": [
        -2996.000244140625,
        -5043.29248046875,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5035.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2996.0,
      "bbox_min": [
        -2996.000244140625,
        -5043.29248046875,
        1060.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.84228515625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15121209621429443,
        -0.2952600419521332,
        0.9433750510215759
      ],
      "plane_d": -2039.136474609375,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5037.84228515625,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        -0.8944272994995117,
        -0.0
      ],
      "plane_d": -5893.3818359375,
      "bbox_min": [
        -3004.734375,
        -5094.0,
        1060.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5080.89208984375,
        1065.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.11514624208211899,
        0.26358821988105774,
        0.9577383399009705
      ],
      "plane_d": 666.6923828125,
      "bbox_min": [
        -3004.734375,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5080.89208984375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4003121852874756,
        0.9163788557052612,
        -0.0
      ],
      "plane_d": 5858.853515625,
      "bbox_min": [
        -3004.734375,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5080.89208984375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1060.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5084.70751953125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2996.0,
      "bbox_min": [
        -2996.000244140625,
        -5090.15771484375,
        1060.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5084.70751953125,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15121208131313324,
        0.2952600419521332,
        0.9433750510215759
      ],
      "plane_d": 951.2572021484375,
      "bbox_min": [
        -3004.734375,
        -5090.15771484375,
        1063.5
      ],
      "bbox_max": [
        -2996.000244140625,
        -5080.89208984375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3009.000244140625,
      "bbox_min": [
        -3010.000244140625,
        -5094.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        -3010.000244140625,
        -5084.5,
        1075.0
      ],
      "bbox_max": [
        -3009.000244140625,
        -5043.5,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3010.000244140625,
        -5084.5,
        1075.0
      ],
      "bbox_max": [
        -3009.000244140625,
        -5043.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        -0.8944272994995117,
        -0.0
      ],
      "plane_d": -5893.3818359375,
      "bbox_min": [
        -3010.000244140625,
        -5084.5,
        1075.0
      ],
      "bbox_max": [
        -3009.000244140625,
        -5084.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5034.0,
      "bbox_min": [
        -3009.000244140625,
        -5094.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3009.000244140625,
        -5094.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5093.0,
      "bbox_min": [
        -3009.000244140625,
        -5094.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5035.0,
      "bbox_min": [
        -3009.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -2992.000244140625,
        -5035.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5034.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4558313190937042,
        -0.8900662660598755,
        0.0
      ],
      "plane_d": -3118.3427734375,
      "bbox_min": [
        -3009.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5035.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        0.8944272994995117,
        0.0
      ],
      "plane_d": 3165.3779296875,
      "bbox_min": [
        -3009.000244140625,
        -5044.5,
        1065.0
      ],
      "bbox_max": [
        -2992.000244140625,
        -5035.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        -3009.000244140625,
        -5044.5,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.0,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5037.84228515625,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5037.0,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4558313190937042,
        0.8900662660598755,
        -0.0
      ],
      "plane_d": 5896.24853515625,
      "bbox_min": [
        -3009.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5035.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721364974975586,
        -0.8944272994995117,
        -0.0
      ],
      "plane_d": -5893.3818359375,
      "bbox_min": [
        -3009.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2992.000244140625,
        -5083.5,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1074.9998779296875,
      "bbox_min": [
        -3009.000244140625,
        -5091.0,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5083.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2996.000244140625,
      "bbox_min": [
        -2996.000244140625,
        -5091.0,
        1065.0
      ],
      "bbox_max": [
        -2996.000244140625,
        -5090.15771484375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        -0.9037274122238159,
        0.0
      ],
      "plane_d": -3270.22314453125,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5035.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4281085133552551,
        0.9037274122238159,
        0.0
      ],
      "plane_d": 5882.72802734375,
      "bbox_min": [
        -2996.000244140625,
        -5093.0,
        1065.0
      ],
      "bbox_max": [
        -2990.000244140625,
        -5090.15771484375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5099.0,
      "bbox_min": [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5099.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1098.0,
      "bbox_min": [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5099.0,
        1140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.5999755859375,
      "bbox_min": [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5099.0,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5159.0,
      "bbox_min": [
        -3025.000244140625,
        -5159.0,
        1098.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2995.000244140625,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -2995.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5144.0,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1098.0
      ],
      "bbox_max": [
        -2995.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5114.0,
      "bbox_min": [
        -3025.000244140625,
        -5129.0,
        1098.0
      ],
      "bbox_max": [
        -2995.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3010.000244140625,
      "bbox_min": [
        -3025.000244140625,
        -5129.0,
        1098.0
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3025.000244140625,
        -5129.0,
        1098.0
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5129.0,
      "bbox_min": [
        -3025.000244140625,
        -5129.0,
        1098.0
      ],
      "bbox_max": [
        -3010.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.000244140625,
      "bbox_min": [
        -3015.000244140625,
        -5124.0,
        1098.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5114.0,
        1101.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5114.0,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.000244140625,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5129.0,
      "bbox_min": [
        -3015.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1124.0,
      "bbox_min": [
        -3010.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2980.000244140625,
        -5114.0,
        1124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3010.000244140625,
      "bbox_min": [
        -3010.000244140625,
        -5129.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3010.000244140625,
        -5114.0,
        1124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -3015.000244140625,
        -5124.0,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.0,
        -0.5547002553939819
      ],
      "plane_d": 3138.216796875,
      "bbox_min": [
        -3025.000244140625,
        -5129.0,
        1120.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5124.0,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.0,
        -0.5547002553939819
      ],
      "plane_d": 3138.216796875,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1120.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5129.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5144.0,
      "bbox_min": [
        -3025.000244140625,
        -5144.0,
        1120.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5144.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3367.0,
        -4142.04638671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3247.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3367.0,
        -4142.04638671875,
        1102.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4119.22314453125,
        1150.4337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3367.0,
        -4126.39453125,
        1102.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4119.22314453125,
        1150.4337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -3367.0,
        -3885.97607421875,
        1302.623779296875
      ],
      "bbox_max": [
        -3301.525146484375,
        -3651.509765625,
        1386.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -3367.0,
        -3885.97607421875,
        1302.623779296875
      ],
      "bbox_max": [
        -3301.525146484375,
        -3820.217529296875,
        1322.2840576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3367.0,
        -5073.943359375,
        1061.70703125
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3364.949951171875,
        -5073.943359375,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.949951171875,
        -5073.943359375,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3364.949951171875,
        -5073.943359375,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1064.699951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3361.949951171875,
        -5073.943359375,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5070.2998046875,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3359.89990234375,
        -5070.2998046875,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1064.699951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3358.306396484375,
        -5070.2998046875,
        1061.70703125
      ],
      "bbox_max": [
        -3356.056884765625,
        -5068.05029296875,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        -3367.0,
        -5073.943359375,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.70703125,
      "bbox_min": [
        -3367.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.50048828125,
      "bbox_min": [
        -3367.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5035.00048828125,
      "bbox_min": [
        -3318.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3295.0,
        -5023.50048828125,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3295.0,
      "bbox_min": [
        -3318.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3295.0,
        -5023.50048828125,
        1080.6070556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3318.0,
      "bbox_min": [
        -3318.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3318.0,
        -5023.50048828125,
        1080.6070556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7133314609527588,
        -0.0,
        -0.70082688331604
      ],
      "plane_d": -1569.548583984375,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1078.5999755859375,
      "bbox_min": [
        -3260.0,
        -5023.5,
        1075.0
      ],
      "bbox_max": [
        -3247.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3260.0,
        -5003.5,
        1075.0
      ],
      "bbox_max": [
        -3247.0,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4000733494758606,
        -0.5985084176063538,
        -0.6940670013427734
      ],
      "plane_d": -3536.025390625,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5987338423728943,
        -0.400060772895813,
        -0.6938797235488892
      ],
      "plane_d": -3200.158447265625,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062419056892395,
        -0.1404874324798584,
        -0.693891704082489
      ],
      "plane_d": -2256.845703125,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14045031368732452,
        -0.7060664892196655,
        -0.6940776705741882
      ],
      "plane_d": -3215.736328125,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9615240097045898,
        0.0,
        -0.2747211456298828
      ],
      "plane_d": 3458.521484375,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14044855535030365,
        -0.7060576677322388,
        -0.6940869688987732
      ],
      "plane_d": -2286.890380859375,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3287.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615240097045898,
        -0.0,
        -0.2747211456298828
      ],
      "plane_d": -2900.036865234375,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3287.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1078.6070556640625,
      "bbox_min": [
        -3326.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3287.0,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1078.6033935546875
      ],
      "bbox_max": [
        -3287.0,
        -4957.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18784187734127045,
        0.944408118724823,
        -0.2698308825492859
      ],
      "plane_d": 5620.71728515625,
      "bbox_min": [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3305.5,
        -4984.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18784263730049133,
        0.9444118738174438,
        -0.2698171138763428
      ],
      "plane_d": 4378.52001953125,
      "bbox_min": [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3306.5,
        -4984.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444087743759155,
        0.18784885108470917,
        -0.26982352137565613
      ],
      "plane_d": 4336.85302734375,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3287.0,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349686741828918,
        0.8006281852722168,
        -0.26982006430625916
      ],
      "plane_d": 6049.0771484375,
      "bbox_min": [
        -3305.5,
        -4996.705078125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3288.484375,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8006315231323242,
        0.5349592566490173,
        -0.2698291838169098
      ],
      "plane_d": 5598.2265625,
      "bbox_min": [
        -3305.5,
        -4996.705078125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3288.484375,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18784187734127045,
        0.944408118724823,
        -0.2698308825492859
      ],
      "plane_d": 5620.71728515625,
      "bbox_min": [
        -3305.5,
        -4987.0947265625,
        1078.6070556640625
      ],
      "bbox_max": [
        -3299.03759765625,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999577760696411,
        -0.5985686182975769,
        -0.6940817832946777
      ],
      "plane_d": -891.0071411132812,
      "bbox_min": [
        -3326.0,
        -5003.50048828125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3307.5,
        -4960.5927734375,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444068670272827,
        0.18784846365451813,
        -0.26983052492141724
      ],
      "plane_d": -1908.51025390625,
      "bbox_min": [
        -3326.0,
        -5003.50048828125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3307.5,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5349685549736023,
        0.8006280660629272,
        -0.26982107758522034
      ],
      "plane_d": 2511.330078125,
      "bbox_min": [
        -3324.515625,
        -4996.705078125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3307.5,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8006294965744019,
        0.5349578857421875,
        -0.269837886095047
      ],
      "plane_d": 303.6596374511719,
      "bbox_min": [
        -3324.515625,
        -4996.705078125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3307.5,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18784263730049133,
        0.9444118738174438,
        -0.2698171138763428
      ],
      "plane_d": 4378.52001953125,
      "bbox_min": [
        -3313.96240234375,
        -4987.0947265625,
        1078.6070556640625
      ],
      "bbox_max": [
        -3307.5,
        -4984.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950886994600296,
        -0.980785608291626,
        -0.0
      ],
      "plane_d": -5506.8154296875,
      "bbox_min": [
        -3324.257080078125,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3288.742919921875,
        -4957.00048828125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4985.7431640625,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18784187734127045,
        0.944408118724823,
        -0.2698308825492859
      ],
      "plane_d": 5620.71728515625,
      "bbox_min": [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4985.7431640625,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18784263730049133,
        0.9444118738174438,
        -0.2698171138763428
      ],
      "plane_d": 4378.52001953125,
      "bbox_min": [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      "bbox_max": [
        -3306.5,
        -4985.7431640625,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3306.5,
        -4990.23828125,
        1077.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4990.03955078125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3320.0,
      "bbox_min": [
        -3324.257080078125,
        -5023.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444068670272827,
        0.18784846365451813,
        -0.26983052492141724
      ],
      "plane_d": -1908.51025390625,
      "bbox_min": [
        -3324.257080078125,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3320.0,
        -4992.35693359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8006294965744019,
        0.5349578857421875,
        -0.269837886095047
      ],
      "plane_d": 303.6596374511719,
      "bbox_min": [
        -3322.905517578125,
        -4996.8037109375,
        1077.70703125
      ],
      "bbox_max": [
        -3320.0,
        -4992.35693359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5349685549736023,
        0.8006280660629272,
        -0.26982107758522034
      ],
      "plane_d": 2511.330078125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18784263730049133,
        0.9444118738174438,
        -0.2698171138763428
      ],
      "plane_d": 4378.52001953125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8006294965744019,
        0.5349578857421875,
        -0.269837886095047
      ],
      "plane_d": 303.6596374511719,
      "bbox_min": [
        -3320.0,
        -4992.810546875,
        1077.70703125
      ],
      "bbox_max": [
        -3318.874267578125,
        -4990.9443359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3311.651123046875,
        -4991.064453125,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3293.0,
      "bbox_min": [
        -3305.5,
        -5023.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3288.742919921875,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444087743759155,
        0.18784885108470917,
        -0.26982352137565613
      ],
      "plane_d": 4336.85302734375,
      "bbox_min": [
        -3293.0,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3288.742919921875,
        -4992.35693359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8006315231323242,
        0.5349592566490173,
        -0.2698291838169098
      ],
      "plane_d": 5598.2265625,
      "bbox_min": [
        -3293.0,
        -4996.8037109375,
        1077.70703125
      ],
      "bbox_max": [
        -3290.094482421875,
        -4992.35693359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349686741828918,
        0.8006281852722168,
        -0.26982006430625916
      ],
      "plane_d": 6049.0771484375,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18784187734127045,
        0.944408118724823,
        -0.2698308825492859
      ],
      "plane_d": 5620.71728515625,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4985.94189453125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8006315231323242,
        0.5349592566490173,
        -0.2698291838169098
      ],
      "plane_d": 5598.2265625,
      "bbox_min": [
        -3294.125732421875,
        -4992.810546875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4990.9443359375,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3305.5,
        -4991.064453125,
        1077.70703125
      ],
      "bbox_max": [
        -3301.348876953125,
        -4990.23828125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3087.728271484375,
      "bbox_min": [
        -3324.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3289.0,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1588.3690185546875,
      "bbox_min": [
        -3324.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3289.0,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3320.0,
      "bbox_min": [
        -3324.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3289.0,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3324.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3320.0,
        -4992.810546875,
        1077.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.593612551689148,
        0.3966447710990906,
        -0.7002121210098267
      ],
      "plane_d": 764.2021484375,
      "bbox_min": [
        -3322.66796875,
        -4997.56884765625,
        1075.70703125
      ],
      "bbox_max": [
        -3320.0,
        -4992.810546875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807836413383484,
        -0.1950991004705429,
        0.0
      ],
      "plane_d": 2281.98486328125,
      "bbox_min": [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        -0.5555756092071533,
        0.0
      ],
      "plane_d": -15.37841796875,
      "bbox_min": [
        -3320.820068359375,
        -4997.56884765625,
        1075.0
      ],
      "bbox_max": [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3289.0,
        -4992.810546875,
        1077.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5936010479927063,
        0.39663711190223694,
        -0.7002261877059937
      ],
      "plane_d": 4689.701171875,
      "bbox_min": [
        -3293.0,
        -4997.56884765625,
        1075.70703125
      ],
      "bbox_max": [
        -3290.33203125,
        -4992.810546875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807836413383484,
        0.1950991004705429,
        -0.0
      ],
      "plane_d": 4203.9375,
      "bbox_min": [
        -3293.0,
        -5003.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3291.0,
        -4996.34130859375,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        0.5555756092071533,
        -0.0
      ],
      "plane_d": 5513.86279296875,
      "bbox_min": [
        -3293.0,
        -4997.56884765625,
        1075.0
      ],
      "bbox_max": [
        -3292.179931640625,
        -4996.34130859375,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3293.0,
        -4977.00048828125,
        1077.70703125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.1392594426870346,
        0.7002167105674744,
        -0.7002167105674744
      ],
      "plane_d": 4706.37060546875,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1075.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4986.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13926368951797485,
        0.7002381086349487,
        -0.7001944780349731
      ],
      "plane_d": 3785.516845703125,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1075.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4986.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1075.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3306.5,
        -4990.23828125,
        1075.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39665064215660095,
        0.5936230421066284,
        -0.7001999616622925
      ],
      "plane_d": 2401.024169921875,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13926368951797485,
        0.7002381086349487,
        -0.7001944780349731
      ],
      "plane_d": 3785.516845703125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4986.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555580258369446,
        -0.8314778208732605,
        0.0
      ],
      "plane_d": -2310.14501953125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.593612551689148,
        0.3966447710990906,
        -0.7002121210098267
      ],
      "plane_d": 764.2021484375,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1075.70703125
      ],
      "bbox_max": [
        -3317.460205078125,
        -4991.1259765625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9793387651443481,
        -0.20222648978233337,
        0.0
      ],
      "plane_d": 2239.564453125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314491510391235,
        -0.5556010007858276,
        0.0
      ],
      "plane_d": -17.56103515625,
      "bbox_min": [
        -3318.936279296875,
        -4998.34912109375,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3311.651123046875,
        -4991.064453125,
        1075.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39667969942092896,
        0.5936074256896973,
        -0.7001966834068298
      ],
      "plane_d": 5024.08935546875,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4986.19921875,
        1077.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1392594426870346,
        0.7002167105674744,
        -0.7002167105674744
      ],
      "plane_d": 4706.37060546875,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4986.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555580258369446,
        -0.8314778208732605,
        0.0
      ],
      "plane_d": -5984.05029296875,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5936010479927063,
        0.39663711190223694,
        -0.7002261877059937
      ],
      "plane_d": 4689.701171875,
      "bbox_min": [
        -3295.539794921875,
        -4996.34130859375,
        1075.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4991.1259765625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9793387651443481,
        -0.20222648978233337,
        0.0
      ],
      "plane_d": -4236.802734375,
      "bbox_min": [
        -3305.5,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314491510391235,
        -0.5556010007858276,
        0.0
      ],
      "plane_d": -5515.9345703125,
      "bbox_min": [
        -3305.5,
        -4998.34912109375,
        1075.70703125
      ],
      "bbox_max": [
        -3294.063720703125,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3305.5,
        -4991.064453125,
        1075.70703125
      ],
      "bbox_max": [
        -3301.348876953125,
        -4990.23828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3293.0,
        -4977.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19506025314331055,
        -0.9807913303375244,
        0.0
      ],
      "plane_d": -4247.220703125,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4977.00048828125,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1075.0
      ],
      "bbox_max": [
        -3307.5,
        -4977.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5556128025054932,
        -0.8314412832260132,
        0.0
      ],
      "plane_d": -2307.781005859375,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        -0.5555756092071533,
        0.0
      ],
      "plane_d": -15.37841796875,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4988.19921875,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19506025314331055,
        -0.9807913303375244,
        -0.0
      ],
      "plane_d": -5537.154296875,
      "bbox_min": [
        -3306.5,
        -4988.19921875,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556128025054932,
        -0.8314412832260132,
        -0.0
      ],
      "plane_d": -5982.04833984375,
      "bbox_min": [
        -3305.5,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3293.0,
        -4988.19921875,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19506025314331055,
        -0.9807913303375244,
        -0.0
      ],
      "plane_d": -5537.154296875,
      "bbox_min": [
        -3305.5,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3293.0,
        -4988.19921875,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        0.5555756092071533,
        -0.0
      ],
      "plane_d": 5513.86279296875,
      "bbox_min": [
        -3295.539794921875,
        -4996.34130859375,
        1075.0
      ],
      "bbox_max": [
        -3293.0,
        -4992.54052734375,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4967.00048828125,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3322.0,
      "bbox_min": [
        -3322.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3321.29296875,
        -4999.9462890625,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807836413383484,
        -0.1950991004705429,
        0.0
      ],
      "plane_d": 2281.98486328125,
      "bbox_min": [
        -3322.0,
        -5003.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3321.29296875,
        -4999.9462890625,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3291.0,
      "bbox_min": [
        -3291.706787109375,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3291.0,
        -4999.947265625,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807836413383484,
        0.1950991004705429,
        -0.0
      ],
      "plane_d": 4203.9375,
      "bbox_min": [
        -3291.706787109375,
        -5003.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3291.0,
        -4999.947265625,
        1075.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0004236618697177619,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1080.031005859375,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3323.2265625,
        -4960.32763671875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7127070426940918,
        0.0,
        -0.7014617323875427
      ],
      "plane_d": 3146.31103515625,
      "bbox_min": [
        -3353.000244140625,
        -5023.50048828125,
        1078.610595703125
      ],
      "bbox_max": [
        -3324.272705078125,
        -4960.5576171875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7059730887413025,
        -0.14071038365364075,
        -0.6941199898719788
      ],
      "plane_d": 2411.7685546875,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1078.610595703125
      ],
      "bbox_max": [
        -3324.272705078125,
        -4960.5576171875,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3999577760696411,
        -0.5985686182975769,
        -0.6940817832946777
      ],
      "plane_d": -891.0071411132812,
      "bbox_min": [
        -3339.371337890625,
        -4974.86279296875,
        1078.6163330078125
      ],
      "bbox_max": [
        -3324.272705078125,
        -4960.5576171875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00020105989824514836,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.92578125,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1075.0
      ],
      "bbox_max": [
        -3323.2265625,
        -4960.32763671875,
        1078.622802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3367.0,
        -5003.5009765625,
        1078.5941162109375
      ],
      "bbox_max": [
        -3324.25341796875,
        -4960.53173828125,
        1078.622802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8722839488182217e-05,
        -1.0,
        0.0
      ],
      "plane_d": -5003.59716796875,
      "bbox_min": [
        -3367.0,
        -5003.5009765625,
        1078.5999755859375
      ],
      "bbox_max": [
        -3353.000244140625,
        -5003.50048828125,
        1078.610595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555756092071533,
        -0.8314660787582397,
        0.0
      ],
      "plane_d": -2277.62353515625,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1078.5941162109375
      ],
      "bbox_max": [
        -3324.25341796875,
        -4960.53173828125,
        1078.622802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314619064331055,
        -0.55558180809021,
        0.0
      ],
      "plane_d": 14.9814453125,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1078.5941162109375
      ],
      "bbox_max": [
        -3324.25341796875,
        -4960.53173828125,
        1078.622802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3999577760696411,
        -0.5985686182975769,
        -0.6940817832946777
      ],
      "plane_d": -891.0071411132812,
      "bbox_min": [
        -3339.38037109375,
        -4970.62890625,
        1078.5941162109375
      ],
      "bbox_max": [
        -3324.25341796875,
        -4960.53173828125,
        1078.622802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950886994600296,
        -0.980785608291626,
        0.0
      ],
      "plane_d": -4216.69384765625,
      "bbox_min": [
        -3324.294677734375,
        -4960.5400390625,
        1078.5941162109375
      ],
      "bbox_max": [
        -3324.25341796875,
        -4960.53173828125,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3367.0,
        -5003.5009765625,
        1075.0
      ],
      "bbox_max": [
        -3323.2265625,
        -4960.32763671875,
        1078.6046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8722839488182217e-05,
        -1.0,
        0.0
      ],
      "plane_d": -5003.59716796875,
      "bbox_min": [
        -3367.0,
        -5003.5009765625,
        1075.0
      ],
      "bbox_max": [
        -3353.000244140625,
        -5003.50048828125,
        1078.6046142578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555756092071533,
        -0.8314660787582397,
        0.0
      ],
      "plane_d": -2277.62353515625,
      "bbox_min": [
        -3339.38037109375,
        -4970.6201171875,
        1075.0
      ],
      "bbox_max": [
        -3323.2265625,
        -4960.32763671875,
        1078.59716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950886994600296,
        -0.980785608291626,
        0.0
      ],
      "plane_d": -4216.69384765625,
      "bbox_min": [
        -3324.294677734375,
        -4960.5400390625,
        1075.0
      ],
      "bbox_max": [
        -3323.2265625,
        -4960.32763671875,
        1078.5941162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807851910591125,
        -0.19509129226207733,
        -0.0
      ],
      "plane_d": -4173.4990234375,
      "bbox_min": [
        -3289.7734375,
        -5003.5,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -4960.32763671875,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3260.0,
        -5003.5,
        1075.0
      ],
      "bbox_max": [
        -3256.463134765625,
        -5003.5,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555756092071533,
        -0.8314661383628845,
        -0.0
      ],
      "plane_d": -5951.6455078125,
      "bbox_min": [
        -3289.7734375,
        -4985.70556640625,
        1075.0
      ],
      "bbox_max": [
        -3263.53955078125,
        -4960.32763671875,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314619064331055,
        -0.55558180809021,
        -0.0
      ],
      "plane_d": -5483.4765625,
      "bbox_min": [
        -3289.7734375,
        -4985.70556640625,
        1075.0
      ],
      "bbox_max": [
        -3263.53955078125,
        -4960.32763671875,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950886994600296,
        -0.980785608291626,
        -0.0
      ],
      "plane_d": -5506.8154296875,
      "bbox_min": [
        -3289.7734375,
        -4960.5400390625,
        1075.0
      ],
      "bbox_max": [
        -3288.705322265625,
        -4960.32763671875,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5035.00048828125,
      "bbox_min": [
        -3367.0,
        -5073.943359375,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3364.949951171875,
        -5073.943359375,
        1064.699951171875
      ],
      "bbox_max": [
        -3353.89990234375,
        -5035.00048828125,
        1074.63720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1071.8070068359375,
      "bbox_min": [
        -3364.949951171875,
        -5073.943359375,
        1070.228515625
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3361.949951171875,
        -5073.943359375,
        1070.228515625
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659245610237122,
        0.258823961019516,
        0.0
      ],
      "plane_d": -1929.96484375,
      "bbox_min": [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3363.767822265625,
        -5073.943359375,
        1064.699951171875
      ],
      "bbox_max": [
        -3353.89990234375,
        -5035.00048828125,
        1074.63720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3361.949951171875,
        -5073.943359375,
        1064.699951171875
      ],
      "bbox_max": [
        -3358.306396484375,
        -5070.2998046875,
        1070.6409912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659245610237122,
        0.258823961019516,
        0.0
      ],
      "plane_d": -1929.96484375,
      "bbox_min": [
        -3358.306396484375,
        -5070.2998046875,
        1064.699951171875
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3358.306396484375,
        -5070.2998046875,
        1064.699951171875
      ],
      "bbox_max": [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5024.50048828125,
      "bbox_min": [
        -3367.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.50048828125,
      "bbox_min": [
        -3367.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.8070068359375,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3358.0,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3257.0,
      "bbox_min": [
        -3257.0,
        -5024.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.70703125,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3358.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3364.0,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3364.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3318.0,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3364.0,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5023.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3358.0,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5023.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.8070068359375,
      "bbox_min": [
        -3364.0,
        -5024.50048828125,
        1074.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5023.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3257.0,
      "bbox_min": [
        -3295.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3257.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3295.0,
      "bbox_min": [
        -3295.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0004164811398368329,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1063.3033447265625,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3367.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807851910591125,
        -0.19509129226207733,
        -0.0
      ],
      "plane_d": -4173.4990234375,
      "bbox_min": [
        -3349.46044921875,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3260.0,
        -5003.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5003.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950886994600296,
        -0.980785608291626,
        -0.0
      ],
      "plane_d": -5506.8154296875,
      "bbox_min": [
        -3349.46044921875,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3263.53955078125,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950886994600296,
        -0.980785608291626,
        0.0
      ],
      "plane_d": -4216.69384765625,
      "bbox_min": [
        -3349.46044921875,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3263.53955078125,
        -4957.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314619064331055,
        -0.55558180809021,
        -0.0
      ],
      "plane_d": -5483.4765625,
      "bbox_min": [
        -3349.46044921875,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3263.53955078125,
        -4957.19921875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314619064331055,
        -0.55558180809021,
        0.0
      ],
      "plane_d": 14.9814453125,
      "bbox_min": [
        -3349.46044921875,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3290.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3291.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3322.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3105.40625,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3322.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3323.0,
        -5003.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3322.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7002162337303162,
        0.1392635554075241,
        0.7002162337303162
      ],
      "plane_d": -2378.33935546875,
      "bbox_min": [
        -3323.0,
        -5003.50048828125,
        1068.70703125
      ],
      "bbox_max": [
        -3322.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.800048828125,
      "bbox_min": [
        -3322.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1065.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1065.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4977.00048828125,
      "bbox_min": [
        -3307.5,
        -4987.19921875,
        1064.699951171875
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19507315754890442,
        0.9807887077331543,
        -0.0
      ],
      "plane_d": 5536.203125,
      "bbox_min": [
        -3307.5,
        -4987.19921875,
        1064.699951171875
      ],
      "bbox_max": [
        -3305.5,
        -4987.00048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19507315754890442,
        0.9807887077331543,
        0.0
      ],
      "plane_d": 4246.18408203125,
      "bbox_min": [
        -3307.5,
        -4987.19921875,
        1064.699951171875
      ],
      "bbox_max": [
        -3306.5,
        -4987.00048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4967.00048828125,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314606547355652,
        0.5555837750434875,
        0.0
      ],
      "plane_d": 14.455810546875,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555574893951416,
        0.8314781188964844,
        0.0
      ],
      "plane_d": 2307.16748046875,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19507315754890442,
        0.9807887077331543,
        0.0
      ],
      "plane_d": 4246.18408203125,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314606547355652,
        0.5555837750434875,
        -0.0
      ],
      "plane_d": 5512.9052734375,
      "bbox_min": [
        -3305.5,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555574893951416,
        0.8314781188964844,
        -0.0
      ],
      "plane_d": 5981.06884765625,
      "bbox_min": [
        -3305.5,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19507315754890442,
        0.9807887077331543,
        -0.0
      ],
      "plane_d": 5536.203125,
      "bbox_min": [
        -3305.5,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4987.19921875,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807901382446289,
        0.19506590068340302,
        -0.0
      ],
      "plane_d": 4202.81201171875,
      "bbox_min": [
        -3291.255859375,
        -4998.47265625,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.0,
        -4997.18603515625,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.70703125,
      "bbox_min": [
        -3322.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3293.0,
      "bbox_min": [
        -3322.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314606547355652,
        0.5555837750434875,
        -0.0
      ],
      "plane_d": 5512.9052734375,
      "bbox_min": [
        -3293.0,
        -4998.47265625,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807901382446289,
        0.19506590068340302,
        -0.0
      ],
      "plane_d": 4202.81201171875,
      "bbox_min": [
        -3293.0,
        -4998.47265625,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5935563445091248,
        0.3966156542301178,
        0.7002761960029602
      ],
      "plane_d": 3187.117919921875,
      "bbox_min": [
        -3293.0,
        -4997.56884765625,
        1068.70703125
      ],
      "bbox_max": [
        -3291.255859375,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3320.0,
      "bbox_min": [
        -3322.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4957.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314606547355652,
        0.5555837750434875,
        0.0
      ],
      "plane_d": 14.455810546875,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1065.800048828125
      ],
      "bbox_max": [
        -3320.0,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3322.0,
        -4998.47265625,
        1065.800048828125
      ],
      "bbox_max": [
        -3320.0,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5935388803482056,
        0.39660394191741943,
        0.7002977132797241
      ],
      "plane_d": -738.0936279296875,
      "bbox_min": [
        -3321.744140625,
        -4997.56884765625,
        1068.70703125
      ],
      "bbox_max": [
        -3320.0,
        -4994.57568359375,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314606547355652,
        0.5555837750434875,
        -0.0
      ],
      "plane_d": 5512.9052734375,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4957.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4977.00048828125,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19507315754890442,
        0.9807887077331543,
        -0.0
      ],
      "plane_d": 5536.203125,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4977.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555574893951416,
        0.8314781188964844,
        -0.0
      ],
      "plane_d": 5981.06884765625,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13926881551742554,
        0.700215756893158,
        0.700215756893158
      ],
      "plane_d": 3204.143310546875,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39665111899375916,
        0.5936500430107117,
        0.7001767754554749
      ],
      "plane_d": 3522.01708984375,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314491510391235,
        -0.5556010007858276,
        -0.0
      ],
      "plane_d": -5515.9345703125,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5935563445091248,
        0.3966156542301178,
        0.7002761960029602
      ],
      "plane_d": 3187.117919921875,
      "bbox_min": [
        -3295.539794921875,
        -4996.34130859375,
        1068.70703125
      ],
      "bbox_max": [
        -3293.0,
        -4991.8330078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        -0.0
      ],
      "plane_d": -5539.34228515625,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19507315754890442,
        0.9807887077331543,
        0.0
      ],
      "plane_d": 4246.18408203125,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1065.800048828125
      ],
      "bbox_max": [
        -3306.5,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13927437365055084,
        0.7002436518669128,
        0.7001867294311523
      ],
      "plane_d": 2283.310302734375,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1068.70703125
      ],
      "bbox_max": [
        -3306.5,
        -4987.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9793387651443481,
        -0.20222648978233337,
        -0.0
      ],
      "plane_d": -4236.802734375,
      "bbox_min": [
        -3307.5,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.0,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555580258369446,
        -0.8314778208732605,
        -0.0
      ],
      "plane_d": -5984.05029296875,
      "bbox_min": [
        -3307.5,
        -4993.982421875,
        1065.800048828125
      ],
      "bbox_max": [
        -3296.981689453125,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3306.5,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3305.5,
        -4988.19921875,
        1068.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4987.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3305.5,
        -4987.19921875,
        1065.800048828125
      ],
      "bbox_max": [
        -3305.5,
        -4977.00048828125,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555574893951416,
        0.8314781188964844,
        0.0
      ],
      "plane_d": 2307.16748046875,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555580258369446,
        -0.8314778208732605,
        0.0
      ],
      "plane_d": -2310.14501953125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39665111899375916,
        0.5936500430107117,
        0.7001767754554749
      ],
      "plane_d": 898.9632568359375,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19507315754890442,
        0.9807887077331543,
        0.0
      ],
      "plane_d": 4246.18408203125,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4987.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5935388803482056,
        0.39660394191741943,
        0.7002977132797241
      ],
      "plane_d": -738.0936279296875,
      "bbox_min": [
        -3320.0,
        -4996.34130859375,
        1068.70703125
      ],
      "bbox_max": [
        -3317.460205078125,
        -4991.8330078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9793387651443481,
        -0.20222648978233337,
        0.0
      ],
      "plane_d": 2239.564453125,
      "bbox_min": [
        -3320.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314491510391235,
        -0.5556010007858276,
        0.0
      ],
      "plane_d": -17.56103515625,
      "bbox_min": [
        -3318.936279296875,
        -4998.34912109375,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3311.651123046875,
        -4991.064453125,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4967.00048828125,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807836413383484,
        0.1950991004705429,
        -0.0
      ],
      "plane_d": 4203.9375,
      "bbox_min": [
        -3322.0,
        -5003.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3291.0,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807836413383484,
        -0.1950991004705429,
        0.0
      ],
      "plane_d": 2281.98486328125,
      "bbox_min": [
        -3322.0,
        -5003.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3292.179931640625,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3305.5,
      "bbox_min": [
        -3320.820068359375,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3292.179931640625,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19506025314331055,
        -0.9807913303375244,
        0.0
      ],
      "plane_d": -4247.220703125,
      "bbox_min": [
        -3320.820068359375,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4957.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4967.00048828125,
      "bbox_min": [
        -3307.5,
        -4977.00048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4977.00048828125,
      "bbox_min": [
        -3307.5,
        -4977.00048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4977.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5556128025054932,
        -0.8314412832260132,
        0.0
      ],
      "plane_d": -2307.781005859375,
      "bbox_min": [
        -3320.820068359375,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        -0.5555756092071533,
        0.0
      ],
      "plane_d": -15.37841796875,
      "bbox_min": [
        -3320.820068359375,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4988.19921875,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19506025314331055,
        -0.9807913303375244,
        -0.0
      ],
      "plane_d": -5537.154296875,
      "bbox_min": [
        -3306.5,
        -4988.19921875,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4988.00048828125,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556128025054932,
        -0.8314412832260132,
        -0.0
      ],
      "plane_d": -5982.04833984375,
      "bbox_min": [
        -3305.5,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3292.179931640625,
        -4988.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314659595489502,
        0.5555756092071533,
        -0.0
      ],
      "plane_d": 5513.86279296875,
      "bbox_min": [
        -3305.5,
        -4997.56884765625,
        1069.70703125
      ],
      "bbox_max": [
        -3292.179931640625,
        -4988.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19506025314331055,
        -0.9807913303375244,
        -0.0
      ],
      "plane_d": -5537.154296875,
      "bbox_min": [
        -3305.5,
        -4989.18017578125,
        1069.70703125
      ],
      "bbox_max": [
        -3300.568359375,
        -4988.19921875,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1570.69140625,
      "bbox_min": [
        -3291.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807901382446289,
        0.19506590068340302,
        -0.0
      ],
      "plane_d": 4202.81201171875,
      "bbox_min": [
        -3291.0,
        -5003.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3290.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7001447081565857,
        0.1392493098974228,
        0.7002906799316406
      ],
      "plane_d": 2251.8046875,
      "bbox_min": [
        -3291.0,
        -5003.50048828125,
        1068.70703125
      ],
      "bbox_max": [
        -3290.0,
        -4998.47265625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.8070068359375,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3295.0,
        -5024.50048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3295.0,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3295.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3364.0,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3357.767822265625,
        -5024.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1124890148639679,
        0.9936529397964478
      ],
      "plane_d": -1624.1627197265625,
      "bbox_min": [
        -3358.0,
        -5033.56298828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3357.990234375,
        -5033.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.70703125,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3358.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1124890148639679,
        0.9936529397964478
      ],
      "plane_d": -1624.1627197265625,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3363.767822265625,
        -5033.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3363.767822265625,
        -5033.50048828125,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3318.0,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3318.0,
        -5024.50048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3364.0,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3357.767822265625,
        -5024.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3358.0,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3357.767822265625,
        -5024.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3358.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3357.767822265625,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.1124890148639679,
        -0.9936529397964478
      ],
      "plane_d": 1634.1986083984375,
      "bbox_min": [
        -3358.0,
        -5035.00048828125,
        1074.63720703125
      ],
      "bbox_max": [
        -3357.767822265625,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.1124890148639679,
        -0.9936529397964478
      ],
      "plane_d": 1634.1986083984375,
      "bbox_min": [
        -3364.0,
        -5035.00048828125,
        1074.63720703125
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -3963.999755859375,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -3634.55712890625,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3367.0,
        -4106.7890625,
        1234.052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3367.0,
        -4106.7890625,
        1234.052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3398.675537109375,
        -4126.3291015625,
        1147.634521484375
      ],
      "bbox_max": [
        -3367.0,
        -4106.7890625,
        1233.3277587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3494.719970703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3448.039306640625,
        -4168.08642578125,
        1230.967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3494.719970703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3479.999755859375,
        -4207.68310546875,
        1230.967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -3634.55712890625,
        -4207.7431640625,
        1226.4107666015625
      ],
      "bbox_max": [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3502.647216796875,
        -4207.7431640625,
        1226.4107666015625
      ],
      "bbox_max": [
        -3398.3798828125,
        -4106.26220703125,
        1236.8394775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3502.647216796875,
        -4207.68310546875,
        1226.4107666015625
      ],
      "bbox_max": [
        -3398.3798828125,
        -4106.26220703125,
        1236.8394775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3502.647216796875,
        -4207.68310546875,
        1230.967041015625
      ],
      "bbox_max": [
        -3494.719970703125,
        -4206.91162109375,
        1234.052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3495.07421875,
        -4207.7431640625,
        1228.752685546875
      ],
      "bbox_max": [
        -3447.064208984375,
        -4165.8994140625,
        1234.9482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3495.07421875,
        -4207.7431640625,
        1230.72607421875
      ],
      "bbox_max": [
        -3494.100830078125,
        -4206.91162109375,
        1234.052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3492.775634765625,
        -4205.1201171875,
        1229.9801025390625
      ],
      "bbox_max": [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3379.318603515625,
        -3651.509765625,
        1386.788818359375
      ],
      "bbox_max": [
        -3367.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3447.064208984375,
        -4165.8994140625,
        1229.9801025390625
      ],
      "bbox_max": [
        -3400.0986328125,
        -4125.603515625,
        1274.5533447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3417.996337890625,
        -4126.208984375,
        1229.9801025390625
      ],
      "bbox_max": [
        -3400.0986328125,
        -4125.603515625,
        1274.5533447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3567.142578125,
        -4206.91162109375,
        1234.052490234375
      ],
      "bbox_max": [
        -3417.986328125,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3567.142578125,
        -4206.91162109375,
        1234.052490234375
      ],
      "bbox_max": [
        -3417.996337890625,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3429.320556640625,
        -4126.103515625,
        1274.5533447265625
      ],
      "bbox_max": [
        -3417.996337890625,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3439.29150390625,
        -4148.46630859375,
        1263.2750244140625
      ],
      "bbox_max": [
        -3417.986328125,
        -4125.90966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3429.320556640625,
        -4126.14453125,
        1274.4359130859375
      ],
      "bbox_max": [
        -3417.986328125,
        -4125.90966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3430.0,
      "bbox_min": [
        -3475.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4940.70068359375,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766268372535706,
        0.0,
        -0.9662350416183472
      ],
      "plane_d": 1904.810302734375,
      "bbox_min": [
        -3475.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4953.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.70703125,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5018.20068359375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4968.89990234375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8953441381454468,
        -0.4453750550746918
      ],
      "plane_d": 4979.671875,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4989.00048828125,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3460.0,
      "bbox_min": [
        -3460.0,
        -4989.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3459.5,
        -4989.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3459.999755859375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4989.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3475.0,
      "bbox_min": [
        -3475.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3475.0,
        -4989.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3460.0,
        -5002.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -5001.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5002.50048828125,
      "bbox_min": [
        -3460.0,
        -5002.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -5002.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3445.0,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 6016.7724609375,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2495131641626358,
        0.2495131641626358,
        -0.9356743097305298
      ],
      "plane_d": 3108.0986328125,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4953.50048828125,
      "bbox_min": [
        -3445.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588219940662384,
        0.0,
        -0.9659250378608704
      ],
      "plane_d": 1953.820556640625,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4940.70068359375,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3198.0234375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4940.70068359375,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.70703125,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.97900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.97900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8953441381454468,
        -0.4453750550746918
      ],
      "plane_d": 4979.671875,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -5016.20068359375,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.70703125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4940.70068359375,
        1111.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3418.0,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        0.44721364974975586
      ],
      "plane_d": 2573.3984375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4940.70068359375,
        1104.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659250974655151,
        0.0,
        -0.2588219940662384
      ],
      "plane_d": 3593.092529296875,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4940.70068359375,
        1097.0274658203125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5018.20068359375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4968.89990234375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1085.7276611328125
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.53173828125
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8953441381454468,
        -0.4453750550746918
      ],
      "plane_d": 4979.671875,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -5016.20068359375,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425271153450012,
        -0.21876883506774902,
        -0.25255244970321655
      ],
      "plane_d": 2422.38427734375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4940.70068359375,
        1097.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4940.70068359375,
        1097.0274658203125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5016.20068359375,
        1097.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3419.999755859375,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5056.4853515625,
        1083.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3422.0,
        -5056.92919921875,
        1079.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5056.4853515625,
        1080.778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3428.0,
        -5043.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5016.20068359375,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3428.0,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3421.5,
        -5039.00048828125,
        1093.706787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3424.0,
        -5043.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3424.0,
        -5039.00048828125,
        1093.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3428.0,
        -5035.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5016.20068359375,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3428.0,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3421.5,
        -5031.00048828125,
        1093.706787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3424.0,
        -5035.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3424.0,
        -5031.00048828125,
        1093.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666667461395264,
        -0.6666667461395264,
        0.3333333730697632
      ],
      "plane_d": -1426.036376953125,
      "bbox_min": [
        -3420.0,
        -5018.20068359375,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5016.20068359375,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1130.0986328125,
      "bbox_min": [
        -3420.0,
        -5018.20068359375,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5016.20068359375,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4940.70068359375,
        1104.687744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5031.00048828125,
        1098.687744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5039.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -5031.00048828125,
        1098.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5031.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -5031.00048828125,
        1098.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5031.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3422.5,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5031.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3422.5,
        -5031.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5031.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4942.00048828125,
        1111.70703125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4942.00048828125,
        1096.70703125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3409.0,
      "bbox_min": [
        -3418.0,
        -5039.19287109375,
        1088.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4942.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1091.7069091796875,
      "bbox_min": [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4942.00048828125,
        1092.45703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4969.00048828125,
      "bbox_min": [
        -3412.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9743912220001221,
        0.22485950589179993,
        -0.0
      ],
      "plane_d": 4445.7724609375,
      "bbox_min": [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827044665813446,
        0.9238708019256592,
        0.0
      ],
      "plane_d": 3348.83203125,
      "bbox_min": [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3418.0,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3345.44482421875,
      "bbox_min": [
        -3418.0,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1224.8323974609375,
      "bbox_min": [
        -3418.0,
        -5033.5361328125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3418.0,
        -5031.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3414.0,
        -5031.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3412.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3401.0,
      "bbox_min": [
        -3409.0,
        -5039.19287109375,
        1088.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4953.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1091.70703125,
      "bbox_min": [
        -3409.0,
        -5039.19287109375,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4953.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9734172224998474,
        0.22903934121131897
      ],
      "plane_d": -5087.12646484375,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4968.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4969.00048828125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4969.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9743912220001221,
        0.22485950589179993,
        -0.0
      ],
      "plane_d": 4437.9775390625,
      "bbox_min": [
        -3409.0,
        -5039.19287109375,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792657852173,
        -0.3826840817928314,
        0.0
      ],
      "plane_d": 1217.212158203125,
      "bbox_min": [
        -3409.0,
        -5039.19287109375,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827044665813446,
        0.9238708019256592,
        0.0
      ],
      "plane_d": 3348.83203125,
      "bbox_min": [
        -3409.0,
        -5036.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3407.635986328125,
        -5036.3642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3404.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1091.70703125,
      "bbox_min": [
        -3401.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4953.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4969.00048828125,
      "bbox_min": [
        -3401.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4968.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9734172224998474,
        0.22903934121131897
      ],
      "plane_d": -5087.12646484375,
      "bbox_min": [
        -3401.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4968.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4962.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3416.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3404.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38267579674720764,
        0.923882782459259
      ],
      "plane_d": 936.652099609375,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5056.4853515625,
        1083.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5056.4853515625,
        1083.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3405.0,
        -5056.92919921875,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5056.4853515625,
        1080.778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.37906694412231445,
        0.9253692626953125
      ],
      "plane_d": -2881.90869140625,
      "bbox_min": [
        -3378.0,
        -5053.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4962.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4959.00048828125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4940.70068359375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9741045236587524,
        -0.2260982245206833,
        0.0
      ],
      "plane_d": 2221.20068359375,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3370.0,
        -4959.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9741045236587524,
        -0.2260982245206833,
        0.0
      ],
      "plane_d": 2221.20068359375,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3370.0,
        -4959.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1073.70703125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1070.7069091796875,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5056.00048828125,
      "bbox_min": [
        -3430.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5001.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3427.0,
      "bbox_min": [
        -3427.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5001.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5001.00048828125,
      "bbox_min": [
        -3427.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5001.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.00048828125,
      "bbox_min": [
        -3422.0,
        -5054.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 2920.673583984375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8932863473892212,
        -0.44948819279670715
      ],
      "plane_d": 4997.72607421875,
      "bbox_min": [
        -3430.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3422.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3405.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38267579674720764,
        -0.923882782459259
      ],
      "plane_d": 2918.76318359375,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3422.0,
        -5056.92919921875,
        1064.635986328125
      ],
      "bbox_max": [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3405.0,
        -5056.92919921875,
        1064.635986328125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238730072975159,
        0.38269925117492676
      ],
      "plane_d": 4260.1953125,
      "bbox_min": [
        -3430.0,
        -5059.17236328125,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3430.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3403.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3419.999755859375,
      "bbox_min": [
        -3420.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3420.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3419.999755859375,
      "bbox_min": [
        -3420.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3408.0,
        -5056.4853515625,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3404.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.37906694412231445,
        0.9253692626953125
      ],
      "plane_d": -2881.90869140625,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3367.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3400.0,
        -5053.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3373.0,
        -5053.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1044.4298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3378.0,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1044.4298095703125
      ],
      "bbox_max": [
        -3367.0,
        -4966.88232421875,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9238730072975159,
        0.38269925117492676
      ],
      "plane_d": 4260.1953125,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 2920.673583984375,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8932863473892212,
        -0.44948819279670715
      ],
      "plane_d": 4997.72607421875,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1066.0501708984375
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5056.00048828125,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1070.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3395.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3378.0,
        -5053.00048828125,
        1044.4298095703125
      ],
      "bbox_max": [
        -3367.0,
        -4966.88232421875,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0004236618697177619,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1080.031005859375,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.705810546875
      ],
      "bbox_max": [
        -3367.0,
        -5003.50048828125,
        1078.6046142578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0004164811398368329,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1063.3033447265625,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.705810546875
      ],
      "bbox_max": [
        -3367.0,
        -5003.50048828125,
        1078.6046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8722839488182217e-05,
        -1.0,
        0.0
      ],
      "plane_d": -5003.59716796875,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.705810546875
      ],
      "bbox_max": [
        -3367.0,
        -5003.50048828125,
        1078.6046142578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.50048828125,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3367.0,
        -5023.50048828125,
        1078.6033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3378.0,
        -5053.00048828125,
        1044.4298095703125
      ],
      "bbox_max": [
        -3370.0,
        -5003.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.70703125,
      "bbox_min": [
        -3378.0,
        -5034.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5003.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.0,
      "bbox_min": [
        -3247.0,
        -5310.0,
        810.0
      ],
      "bbox_max": [
        -2660.0,
        -4650.0,
        1035.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 965.0,
      "bbox_min": [
        -2980.000244140625,
        -5194.0,
        910.0
      ],
      "bbox_max": [
        -2880.0,
        -5009.0,
        1035.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -2980.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5076.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5176.0,
      "bbox_min": [
        -2979.000244140625,
        -5194.0,
        1000.0
      ],
      "bbox_max": [
        -2880.0,
        -5150.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1000.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5150.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1000.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2979.000244140625,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        1000.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2969.000244140625,
      "bbox_min": [
        -2969.000244140625,
        -5159.0,
        1000.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5194.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        1000.0
      ],
      "bbox_max": [
        -2880.0,
        -5176.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2900.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        1000.0
      ],
      "bbox_max": [
        -2880.0,
        -5176.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2880.0,
      "bbox_min": [
        -2880.000244140625,
        -5194.0,
        1000.0
      ],
      "bbox_max": [
        -2880.0,
        -5176.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -6.975446467549773e-06
      ],
      "plane_d": 2930.007080078125,
      "bbox_min": [
        -2980.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5076.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2969.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5159.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5150.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2979.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -2979.000244140625,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.000244140625,
        -5150.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -6.10351571594947e-06,
        0.0
      ],
      "plane_d": -2880.031494140625,
      "bbox_min": [
        -2930.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5076.0,
        1000.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.707102358341217,
        -0.7071112990379333
      ],
      "plane_d": -2899.261474609375,
      "bbox_min": [
        -2930.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5076.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5076.0,
      "bbox_min": [
        -2930.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5076.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5137.0,
      "bbox_min": [
        -2930.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5134.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2930.000244140625,
        -5137.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5134.0,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -968.0,
      "bbox_min": [
        -2930.0,
        -5137.0,
        968.0
      ],
      "bbox_max": [
        -2880.0,
        -5134.0,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5174.0,
      "bbox_min": [
        -2930.000244140625,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5194.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2900.0,
      "bbox_min": [
        -2900.0,
        -5194.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5176.0,
      "bbox_min": [
        -2900.0,
        -5176.0,
        980.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        -2900.0,
        -5176.0,
        980.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277638912201,
        0.0,
        0.9486832618713379
      ],
      "plane_d": -1805.66064453125,
      "bbox_min": [
        -2980.000244140625,
        -5174.0,
        910.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        943.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2880.000244140625,
      "bbox_min": [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        943.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5076.0,
      "bbox_min": [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        943.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2890.00048828125,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5134.0,
        943.3334350585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -2736.50341796875,
      "bbox_min": [
        -2980.000244140625,
        -5174.0,
        910.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2880.000244140625,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5076.0,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5076.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -962.0,
      "bbox_min": [
        -2910.00048828125,
        -5134.0,
        960.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -2910.00048828125,
        -5124.0,
        960.0
      ],
      "bbox_max": [
        -2880.000244140625,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8778956532478333,
        -0.47885218262672424,
        -0.0
      ],
      "plane_d": -5014.69970703125,
      "bbox_min": [
        -2980.000244140625,
        -5174.0,
        910.0
      ],
      "bbox_max": [
        -2905.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957900047302,
        -0.857492983341217,
        -0.0
      ],
      "plane_d": -5860.10693359375,
      "bbox_min": [
        -2950.000244140625,
        -5134.0,
        920.0
      ],
      "bbox_max": [
        -2905.000244140625,
        -5064.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5076.0,
      "bbox_min": [
        -2930.000244140625,
        -5076.0,
        940.0
      ],
      "bbox_max": [
        -2905.000244140625,
        -5076.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -2917.272705078125,
        -5134.0,
        960.0
      ],
      "bbox_max": [
        -2908.000244140625,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2911.818603515625,
        -5134.0,
        960.0
      ],
      "bbox_max": [
        -2908.000244140625,
        -5134.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2911.818603515625,
        -5134.0,
        958.1815795898438
      ],
      "bbox_max": [
        -2910.000244140625,
        -5134.0,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2911.818603515625,
        -5134.0,
        962.0
      ],
      "bbox_max": [
        -2905.000244140625,
        -5134.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5174.0,
      "bbox_min": [
        -2980.000244140625,
        -5174.0,
        910.0
      ],
      "bbox_max": [
        -2911.818603515625,
        -5124.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2930.000244140625,
      "bbox_min": [
        -2930.000244140625,
        -5174.0,
        940.0
      ],
      "bbox_max": [
        -2911.818603515625,
        -5124.0,
        965.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        940.0
      ],
      "bbox_max": [
        -2911.818603515625,
        -5124.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        960.0
      ],
      "bbox_max": [
        -2911.818603515625,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -962.0,
      "bbox_min": [
        -2930.000244140625,
        -5134.0,
        960.0
      ],
      "bbox_max": [
        -2911.81884765625,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -2930.000244140625,
        -5124.0,
        960.0
      ],
      "bbox_max": [
        -2917.272705078125,
        -5124.0,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        910.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -965.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        910.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        910.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        910.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        910.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5009.0,
      "bbox_min": [
        -3195.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        965.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 963.0,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        963.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5004.0,
      "bbox_min": [
        -3195.000244140625,
        -5004.0,
        963.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5104.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5134.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5134.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3120.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5104.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3120.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5104.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3120.000244140625,
        -5064.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3120.000244140625,
        -5064.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3120.000244140625,
        -5064.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5044.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3120.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3120.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3160.000244140625,
        -5154.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3040.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3040.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3020.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3040.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3020.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3040.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3040.000244140625,
        -5124.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3020.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3040.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3040.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5164.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3080.000244140625,
        -5029.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5164.0,
        965.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        930.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5164.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5219.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        965.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        965.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5009.0,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        965.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5004.0,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        965.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1035.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5004.0,
        1010.0000610351562
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3165.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5004.0,
        1010.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3015.000244140625,
      "bbox_min": [
        -3015.000244140625,
        -5009.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5004.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        980.0
      ],
      "bbox_max": [
        -3195.000244140625,
        -5004.0,
        1010.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5006.5,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5004.0,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3017.500244140625,
      "bbox_min": [
        -3017.500244140625,
        -5009.0,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        1010.0000610351562
      ],
      "bbox_max": [
        -3195.000244140625,
        -5006.5,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5006.5,
        1010.0000610351562
      ],
      "bbox_max": [
        -3195.000244140625,
        -5004.0,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5006.5,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5004.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5009.0,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3162.500244140625,
      "bbox_min": [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1015.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3017.500244140625,
      "bbox_min": [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5006.5,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5006.5,
        1012.5
      ],
      "bbox_max": [
        -3195.000244140625,
        -5004.0,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5004.0,
        965.0
      ],
      "bbox_max": [
        -3195.000244140625,
        -4976.0,
        1035.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3195.000244140625,
      "bbox_min": [
        -3195.000244140625,
        -5219.0,
        965.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -5009.0,
        1035.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5029.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5124.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3120.000244140625,
        -5154.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5154.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3120.000244140625,
        -5124.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5124.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3120.000244140625,
        -5064.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5029.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3120.000244140625,
        -5064.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5064.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3120.000244140625,
        -5029.0,
        965.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5029.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5154.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5134.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5154.0,
        965.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5134.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3082.0,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3020.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3040.000244140625,
        -5164.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5029.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3040.000244140625,
        -5104.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5029.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3040.000244140625,
        -5104.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3040.000244140625,
        -5164.0,
        965.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3082.0,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3058.0,
        -5009.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5029.0,
        965.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5029.0,
        965.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5009.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        965.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5074.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3082.0,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5184.0,
        965.0
      ],
      "bbox_max": [
        -3080.000244140625,
        -5164.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3082.0,
      "bbox_min": [
        -3082.0,
        -5126.0,
        979.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5126.0,
      "bbox_min": [
        -3082.0,
        -5126.0,
        979.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5102.0,
      "bbox_min": [
        -3082.0,
        -5126.0,
        979.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3058.0,
      "bbox_min": [
        -3082.0,
        -5126.0,
        979.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 978.9999389648438,
      "bbox_min": [
        -3082.0,
        -5126.0,
        979.0
      ],
      "bbox_max": [
        -3058.0,
        -5102.0,
        980.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3060.0,
      "bbox_min": [
        -3080.000244140625,
        -5124.0,
        979.0
      ],
      "bbox_max": [
        -3060.0,
        -5104.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5104.0,
      "bbox_min": [
        -3080.000244140625,
        -5124.0,
        979.0
      ],
      "bbox_max": [
        -3060.0,
        -5104.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5124.0,
      "bbox_min": [
        -3080.000244140625,
        -5124.0,
        979.0
      ],
      "bbox_max": [
        -3060.0,
        -5104.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3080.0,
      "bbox_min": [
        -3080.000244140625,
        -5124.0,
        979.0
      ],
      "bbox_max": [
        -3080.0,
        -5104.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3015.000244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3020.000244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3020.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5009.0,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5189.0,
      "bbox_min": [
        -3020.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3015.000244140625,
        -5189.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3017.500244140625,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5009.0,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5186.5,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      "bbox_max": [
        -3017.500244140625,
        -5186.5,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3017.500244140625,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5009.0,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5186.5,
      "bbox_min": [
        -3020.000244140625,
        -5186.5,
        1012.5
      ],
      "bbox_max": [
        -3017.500244140625,
        -5186.5,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3162.500244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1012.4999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5189.0,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5184.0,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5186.5,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5184.0,
        1012.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5186.5,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5184.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5186.5,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3160.000244140625,
      "bbox_min": [
        -3162.500244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3162.500244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5009.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3162.500244140625,
        -5044.0,
        980.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5029.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3162.500244140625,
        -5029.0,
        980.0
      ],
      "bbox_max": [
        -3160.000244140625,
        -5029.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3079.500244140625,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5104.5,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5123.5,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.5,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5123.5,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -5.425347262644209e-05,
        0.0
      ],
      "plane_d": -3060.77734375,
      "bbox_min": [
        -3060.500244140625,
        -5123.5,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.5,
        1012.5000610351562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.5,
        -5123.5,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5104.5,
        1012.5000610351562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5108.0,
      "bbox_min": [
        -3060.5,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5108.0,
        991.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5119.0,
      "bbox_min": [
        -3060.5,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -3060.5,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5109.0,
      "bbox_min": [
        -3060.5,
        -5109.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -991.0,
      "bbox_min": [
        -3060.000244140625,
        -5120.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5108.0,
        991.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3058.999755859375,
      "bbox_min": [
        -3060.000244140625,
        -5120.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5108.0,
        991.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5120.0,
      "bbox_min": [
        -3060.000244140625,
        -5120.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5108.0,
        991.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5108.0,
      "bbox_min": [
        -3060.000244140625,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5108.0,
        991.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5119.0,
      "bbox_min": [
        -3060.000244140625,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -3060.000244140625,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5109.0,
      "bbox_min": [
        -3060.000244140625,
        -5109.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5109.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5124.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5104.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5134.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5154.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3040.000244140625,
        -5134.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5184.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3040.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3040.000244140625,
        -5044.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3040.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3040.000244140625,
        -5074.0,
        980.0
      ],
      "bbox_max": [
        -3020.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3080.000244140625,
        -5064.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3080.000244140625,
        -5064.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5064.0,
        980.0
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3160.000244140625,
        -5064.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5064.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5044.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3160.000244140625,
        -5029.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5029.0,
        980.0
      ],
      "bbox_max": [
        -3140.000244140625,
        -5009.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3100.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1012.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5186.5,
      "bbox_min": [
        -3162.500244140625,
        -5186.5,
        1012.5
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5104.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5124.0,
      "bbox_min": [
        -3160.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3079.500244140625,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5104.5,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5123.5,
      "bbox_min": [
        -3079.500244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.5,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5123.5,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.5,
      "bbox_min": [
        -3079.500244140625,
        -5123.5,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.5,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        6.10351571594947e-06
      ],
      "plane_d": 3059.993896484375,
      "bbox_min": [
        -3060.000244140625,
        -5123.5,
        1029.5
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.5,
        1030.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        6.10351571594947e-06
      ],
      "plane_d": 3059.993896484375,
      "bbox_min": [
        -3060.000244140625,
        -5123.5,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5104.5,
        1029.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3140.000244140625,
        -5124.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5104.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5154.0,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3080.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5134.0,
      "bbox_min": [
        -3040.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3040.000244140625,
        -5154.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3040.000244140625,
        -5134.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5164.0,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5164.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5184.0,
      "bbox_min": [
        -3120.000244140625,
        -5184.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5184.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3100.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3160.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3160.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5064.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3160.000244140625,
      "bbox_min": [
        -3160.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5009.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3160.000244140625,
        -5029.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3140.000244140625,
        -5029.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.000244140625,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5074.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3120.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3100.000244140625,
        -5094.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3040.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5074.0,
      "bbox_min": [
        -3040.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3040.000244140625,
        -5094.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5094.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3040.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3040.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3020.000244140625,
        -5064.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5044.0,
      "bbox_min": [
        -3080.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3080.000244140625,
      "bbox_min": [
        -3080.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.0,
      "bbox_min": [
        -3080.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3060.000244140625,
      "bbox_min": [
        -3060.000244140625,
        -5064.0,
        1012.5000610351562
      ],
      "bbox_max": [
        -3060.000244140625,
        -5044.0,
        1030.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1012.4999389648438,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5009.0,
        1012.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3165.000244140625,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5009.0,
        1010.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5189.0,
      "bbox_min": [
        -3165.000244140625,
        -5189.0,
        980.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5189.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5029.0,
      "bbox_min": [
        -3165.000244140625,
        -5029.0,
        980.0
      ],
      "bbox_max": [
        -3162.500244140625,
        -5029.0,
        1010.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: secdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "secdr2",
      "offset": 3733,
      "centroid": [
        -3140.25,
        -5169.25,
        1095.5
      ],
      "bbox_min": [
        -3160.5,
        -5184.5,
        1089.5
      ],
      "bbox_max": [
        -3082.0,
        -5126.0,
        1101.5
      ],
      "dimensions_source": {
        "span_x": 78.5,
        "span_y": 58.5,
        "height_z": 12.0,
        "door_width": 78.5,
        "door_depth": 58.5,
        "leaf_depth": 58.46,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3158.0,
          -5184.5,
          1089.5
        ],
        [
          -3158.0,
          -5184.5,
          1089.5
        ],
        [
          -3082.0,
          -5184.5,
          1101.5
        ],
        [
          -3082.0,
          -5184.5,
          1101.5
        ],
        [
          -3082.0,
          -5184.5,
          1089.5
        ],
        [
          -3082.0,
          -5184.5,
          1089.5
        ],
        [
          -3158.0,
          -5184.5,
          1101.5
        ],
        [
          -3158.0,
          -5184.5,
          1101.5
        ],
        [
          -3160.5,
          -5182.0,
          1089.5
        ],
        [
          -3160.5,
          -5182.0,
          1089.5
        ],
        [
          -3160.5,
          -5126.0,
          1101.5
        ],
        [
          -3160.5,
          -5126.0,
          1101.5
        ],
        [
          -3160.5,
          -5182.0,
          1101.5
        ],
        [
          -3160.5,
          -5182.0,
          1101.5
        ],
        [
          -3160.5,
          -5126.0,
          1089.5
        ],
        [
          -3160.5,
          -5126.0,
          1089.5
        ]
      ],
      "plane_distance": -3160.5
    },
    {
      "tag": "CSlidingDoor piece: elev2dr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr1",
      "offset": 5189,
      "centroid": [
        -2890.0,
        -5175.0,
        972.5
      ],
      "bbox_min": [
        -2900.0,
        -5176.0,
        965.0
      ],
      "bbox_max": [
        -2880.0,
        -5174.0,
        980.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 2.0,
        "height_z": 15.0,
        "door_width": 20.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2880.0,
          -5174.0,
          965.0
        ],
        [
          -2880.0,
          -5174.0,
          980.0
        ],
        [
          -2880.0,
          -5176.0,
          965.0
        ],
        [
          -2880.0,
          -5176.0,
          980.0
        ],
        [
          -2900.0,
          -5174.0,
          965.0
        ],
        [
          -2900.0,
          -5174.0,
          980.0
        ],
        [
          -2900.0,
          -5176.0,
          980.0
        ],
        [
          -2900.0,
          -5176.0,
          965.0
        ]
      ],
      "plane_distance": 5174.0,
      "authentic_texture": "cbaseelevdoor"
    },
    {
      "tag": "CSlidingDoor piece: elev2dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr2",
      "offset": 6394,
      "centroid": [
        -2900.5,
        -5185.0,
        1067.5
      ],
      "bbox_min": [
        -2901.0,
        -5194.0,
        1060.0
      ],
      "bbox_max": [
        -2900.0,
        -5176.0,
        1075.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 18.0,
        "height_z": 15.0,
        "door_width": 18.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2900.0,
          -5176.0,
          1060.0
        ],
        [
          -2900.0,
          -5176.0,
          1075.0
        ],
        [
          -2901.0,
          -5176.0,
          1060.0
        ],
        [
          -2901.0,
          -5176.0,
          1075.0
        ],
        [
          -2900.0,
          -5194.0,
          1075.0
        ],
        [
          -2900.0,
          -5194.0,
          1060.0
        ],
        [
          -2901.0,
          -5194.0,
          1060.0
        ],
        [
          -2901.0,
          -5194.0,
          1075.0
        ]
      ],
      "plane_distance": 2900.0,
      "authentic_texture": "cbaseelevdoor"
    },
    {
      "tag": "CSlidingDoor piece: secdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "secdr1",
      "offset": 10284,
      "centroid": [
        -3306.5,
        -4893.0,
        1071.199951171875
      ],
      "bbox_min": [
        -3306.5,
        -4898.0,
        1064.699951171875
      ],
      "bbox_max": [
        -3306.5,
        -4888.0,
        1077.699951171875
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 10.0,
        "height_z": 13.0,
        "door_width": 10.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3306.5,
          -4888.0,
          1064.699951171875
        ],
        [
          -3306.5,
          -4888.0,
          1064.699951171875
        ],
        [
          -3306.5,
          -4888.0,
          1077.699951171875
        ],
        [
          -3306.5,
          -4888.0,
          1077.699951171875
        ],
        [
          -3306.5,
          -4898.0,
          1077.699951171875
        ],
        [
          -3306.5,
          -4898.0,
          1077.699951171875
        ],
        [
          -3306.5,
          -4898.0,
          1064.699951171875
        ],
        [
          -3306.5,
          -4898.0,
          1064.699951171875
        ]
      ],
      "plane_distance": -3306.5
    },
    {
      "tag": "CSlidingDoor piece: elec",
      "entity_class": "CSlidingDoor",
      "piece_name": "elec",
      "offset": 11100,
      "centroid": [
        -3087.5,
        -4990.0,
        973.0
      ],
      "bbox_min": [
        -3195.0,
        -5004.0,
        973.0
      ],
      "bbox_max": [
        -2980.0,
        -4976.0,
        973.0
      ],
      "dimensions_source": {
        "span_x": 215.0,
        "span_y": 28.0,
        "height_z": 0.0,
        "door_width": 215.0,
        "door_depth": 28.0,
        "leaf_depth": 27.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3195.0,
          -4976.0,
          973.0
        ],
        [
          -2980.0,
          -4976.0,
          973.0
        ],
        [
          -2980.0,
          -5004.0,
          973.0
        ],
        [
          -3195.0,
          -5004.0,
          973.0
        ]
      ],
      "plane_distance": -973.0,
      "authentic_texture": "elev3"
    },
    {
      "tag": "CElevator piece: elv",
      "entity_class": "CElevator",
      "piece_name": "elv",
      "offset": 13062,
      "centroid": [
        -2975.0,
        -5156.699951171875,
        981.4000244140625
      ],
      "bbox_min": [
        -2979.0,
        -5159.0,
        980.0
      ],
      "bbox_max": [
        -2969.0,
        -5150.0,
        984.5
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 9.0,
        "height_z": 4.5,
        "door_width": 10.0,
        "door_depth": 9.0,
        "leaf_depth": 9.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2979.0,
          -5159.0,
          980.0
        ],
        [
          -2979.0,
          -5150.0,
          980.550048828125
        ],
        [
          -2979.0,
          -5159.0,
          980.550048828125
        ],
        [
          -2979.0,
          -5150.0,
          980.0
        ],
        [
          -2969.0,
          -5159.0,
          980.0
        ],
        [
          -2969.0,
          -5150.0,
          980.550048828125
        ],
        [
          -2969.0,
          -5159.0,
          980.550048828125
        ],
        [
          -2969.0,
          -5150.0,
          980.0
        ],
        [
          -2977.0,
          -5158.89990234375,
          980.550048828125
        ],
        [
          -2976.0,
          -5158.89990234375,
          984.5
        ],
        [
          -2976.0,
          -5158.89990234375,
          980.550048828125
        ],
        [
          -2977.0,
          -5158.89990234375,
          984.5
        ],
        [
          -2975.0,
          -5158.89990234375,
          980.550048828125
        ],
        [
          -2976.0,
          -5158.89990234375,
          980.550048828125
        ],
        [
          -2976.0,
          -5158.89990234375,
          984.5
        ],
        [
          -2975.0,
          -5158.89990234375,
          984.5
        ]
      ],
      "plane_distance": 5158.8999,
      "authentic_texture": "cbaseelevpaneldown"
    },
    {
      "tag": "CSlidingDoor piece: secretdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "secretdr",
      "offset": 14775,
      "centroid": [
        -3059.5,
        -5114.0,
        985.0
      ],
      "bbox_min": [
        -3060.0,
        -5119.0,
        980.0
      ],
      "bbox_max": [
        -3059.0,
        -5109.0,
        990.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 10.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3060.0,
          -5119.0,
          980.0
        ],
        [
          -3060.0,
          -5109.0,
          990.0
        ],
        [
          -3060.0,
          -5119.0,
          990.0
        ],
        [
          -3060.0,
          -5109.0,
          980.0
        ],
        [
          -3059.0,
          -5119.0,
          980.0
        ],
        [
          -3059.0,
          -5119.0,
          990.0
        ],
        [
          -3059.0,
          -5109.0,
          990.0
        ],
        [
          -3059.0,
          -5109.0,
          980.0
        ]
      ],
      "plane_distance": -990.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: rech",
      "entity_class": "CSlidingDoor",
      "piece_name": "rech",
      "offset": 16738,
      "centroid": [
        -3088.900146484375,
        -5128.75,
        1106.0
      ],
      "bbox_min": [
        -3088.900146484375,
        -5130.0,
        1105.0
      ],
      "bbox_max": [
        -3088.900146484375,
        -5127.5,
        1107.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 2.5,
        "height_z": 2.0,
        "door_width": 2.5,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3088.900146484375,
          -5130.0,
          1105.0
        ],
        [
          -3088.900146484375,
          -5127.5,
          1107.0
        ],
        [
          -3088.900146484375,
          -5130.0,
          1107.0
        ],
        [
          -3088.900146484375,
          -5127.5,
          1105.0
        ]
      ],
      "plane_distance": 3088.9001
    },
    {
      "tag": "CSlidingDoor piece: celllift",
      "entity_class": "CSlidingDoor",
      "piece_name": "celllift",
      "offset": 18594,
      "centroid": [
        -3074.283243815104,
        -5114.0750732421875,
        997.25
      ],
      "bbox_min": [
        -3080.0,
        -5124.0,
        979.0
      ],
      "bbox_max": [
        -3060.0,
        -5104.0,
        1030.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 20.0,
        "height_z": 51.0,
        "door_width": 20.0,
        "door_depth": 20.0,
        "leaf_depth": 19.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3080.0,
          -5124.0,
          979.0
        ],
        [
          -3080.0,
          -5104.0,
          980.0
        ],
        [
          -3080.0,
          -5104.0,
          1030.0
        ],
        [
          -3080.0,
          -5124.0,
          1030.0
        ],
        [
          -3080.0,
          -5124.0,
          980.0
        ],
        [
          -3080.0,
          -5104.0,
          979.0
        ],
        [
          -3060.0,
          -5124.0,
          979.0
        ],
        [
          -3060.0,
          -5104.0,
          1030.0
        ],
        [
          -3060.0,
          -5104.0,
          980.0
        ],
        [
          -3060.0,
          -5124.0,
          1030.0
        ],
        [
          -3060.0,
          -5124.0,
          980.0
        ],
        [
          -3060.0,
          -5104.0,
          979.0
        ],
        [
          -3079.499755859375,
          -5115.60009765625,
          980.0
        ],
        [
          -3079.499755859375,
          -5112.7001953125,
          1030.0
        ],
        [
          -3079.499755859375,
          -5115.60009765625,
          1030.0
        ],
        [
          -3079.499755859375,
          -5112.7001953125,
          980.0
        ],
        [
          -3078.099853515625,
          -5115.60009765625,
          980.0
        ],
        [
          -3078.099853515625,
          -5112.7001953125,
          1030.0
        ],
        [
          -3078.099853515625,
          -5115.60009765625,
          1030.0
        ],
        [
          -3078.099853515625,
          -5112.7001953125,
          980.0
        ],
        [
          -3078.099853515625,
          -5115.60009765625,
          983.0
        ],
        [
          -3078.099853515625,
          -5112.7001953125,
          986.0
        ],
        [
          -3078.099853515625,
          -5115.60009765625,
          986.0
        ],
        [
          -3078.099853515625,
          -5112.7001953125,
          983.0
        ]
      ],
      "plane_distance": -980.0,
      "authentic_texture": "cbaseelevpanelup"
    },
    {
      "tag": "CSlidingDoor piece: hyperpan",
      "entity_class": "CSlidingDoor",
      "piece_name": "hyperpan",
      "offset": 21739,
      "centroid": [
        -3006.8673095703125,
        -5064.06005859375,
        1064.300048828125
      ],
      "bbox_min": [
        -3009.000244140625,
        -5067.18017578125,
        1063.550048828125
      ],
      "bbox_max": [
        -3004.734375,
        -5060.93994140625,
        1065.050048828125
      ],
      "dimensions_source": {
        "span_x": 4.265869140625,
        "span_y": 6.240234375,
        "height_z": 1.5,
        "door_width": 6.240234375,
        "door_depth": 4.265869140625,
        "leaf_depth": 4.225869140625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.3317,
          0.0,
          0.9434
        ]
      },
      "vertices": [
        [
          -3009.000244140625,
          -5060.93994140625,
          1065.050048828125
        ],
        [
          -3009.000244140625,
          -5067.18017578125,
          1065.050048828125
        ],
        [
          -3004.734375,
          -5061.357421875,
          1063.550048828125
        ],
        [
          -3004.734375,
          -5066.7626953125,
          1063.550048828125
        ]
      ],
      "plane_distance": -6.6042
    }
  ],
  "tutorial_messages": []
}